import AccessTimeIcon from '@mui/icons-material/AccessTime';
// ARCHIVE mode (several uploads as ONE sheet): which exports are single-source-only + Cherry's archive starters.
import { ARCHIVE_UNSUPPORTED_EXPORTS } from './archiveExport';
import { ARCHIVE_GOAL_CHIPS } from './archiveAiPack';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import LinkIcon from '@mui/icons-material/Link';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import EditNoteIcon from '@mui/icons-material/EditNote';
import GridViewIcon from '@mui/icons-material/GridView';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LabelIcon from '@mui/icons-material/Label';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import CommentIcon from '@mui/icons-material/Comment';
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MovieIcon from '@mui/icons-material/Movie';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SubtitlesOffIcon from '@mui/icons-material/SubtitlesOff';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import SortIcon from '@mui/icons-material/Sort';
import NumbersIcon from '@mui/icons-material/Numbers';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import PushPinIcon from '@mui/icons-material/PushPin';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import CheckIcon from '@mui/icons-material/Check';
import TagIcon from '@mui/icons-material/Tag';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import LanguageIcon from '@mui/icons-material/Language';
import CloseIcon from '@mui/icons-material/Close';
import { getEmbedParentOrigin, postToEmbedParent, isTrustedEmbedCommand } from '../../utils/embedBridge';
import PanelSlider from './panelSlider';
import {
    Badge,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    ClickAwayListener,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    LinearProgress,
    Paper,
    Popper,
    Slider,
    Stack,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import cherryLogo from '../../assets/brand/logo_site.svg';
import { logAiUsage, getAiUsage, clearAiUsage, totals as usageTotals, byVideo as usageByVideo } from '../../utils/aiUsage';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import HighlightIcon from '@mui/icons-material/Highlight';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import { toJS } from 'mobx';
import React, { useContext, useEffect, useRef, useState } from 'react';
import SentimentIcon from '../../icons/sentimentIcon';
import SpeakerIcon from '../../icons/speakerIcon';
import { filterContext } from "../../stores/filters/filterContext";
import { messageContext } from "../../stores/messages/messageContext";
import { userContext } from '../../stores/users/userContext';
import { GIF_MAX_DURATION, viewItems, aiProxySharedUrl } from '../constants';
import apiRequest from '../../utils/apiClient';
import { TRANSCRIPT_OPTION } from './export/exportText';
import CustomModal from './customModal';
import './draggableToolbar.css';
const iconStyle = {
    fontSize: 18,
};

const TRANSCRIPT_FONTS = [
    // Caption / video overlay style
    { key: 'impact',       label: 'Impact',           css: "Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif", group: 'Caption' },
    { key: 'anton',        label: 'Anton',             css: "'Anton', sans-serif",              group: 'Caption' },
    { key: 'bebas',        label: 'Bebas Neue',        css: "'Bebas Neue', sans-serif",         group: 'Caption' },
    { key: 'oswald',       label: 'Oswald',            css: "'Oswald', sans-serif",             group: 'Caption' },
    // Clean sans-serif
    { key: 'sans',         label: 'System Default',    css: "system-ui, -apple-system, sans-serif", group: 'Sans-Serif' },
    { key: 'roboto',       label: 'Roboto',            css: "'Roboto', sans-serif",             group: 'Sans-Serif' },
    { key: 'opensans',     label: 'Open Sans',         css: "'Open Sans', sans-serif",          group: 'Sans-Serif' },
    { key: 'lato',         label: 'Lato',              css: "'Lato', sans-serif",               group: 'Sans-Serif' },
    { key: 'montserrat',   label: 'Montserrat',        css: "'Montserrat', sans-serif",         group: 'Sans-Serif' },
    { key: 'dmsans',       label: 'DM Sans',           css: "'DM Sans', sans-serif",            group: 'Sans-Serif' },
    { key: 'nunito',       label: 'Nunito',            css: "'Nunito', sans-serif",             group: 'Sans-Serif' },
    // Serif / editorial
    { key: 'times',        label: 'Times New Roman',   css: "'Times New Roman', Times, serif",   group: 'Serif' },
    { key: 'georgia',      label: 'Georgia',           css: "Georgia, 'Times New Roman', serif", group: 'Serif' },
    { key: 'playfair',     label: 'Playfair Display',  css: "'Playfair Display', serif",        group: 'Serif' },
    { key: 'merriweather', label: 'Merriweather',      css: "'Merriweather', serif",            group: 'Serif' },
    { key: 'lora',         label: 'Lora',              css: "'Lora', serif",                    group: 'Serif' },
    { key: 'garamond',     label: 'EB Garamond',       css: "'EB Garamond', serif",             group: 'Serif' },
    // Monospace
    { key: 'courier',      label: 'Courier New',       css: "'Courier New', monospace",         group: 'Mono' },
    { key: 'robotomono',   label: 'Roboto Mono',       css: "'Roboto Mono', monospace",         group: 'Mono' },
    { key: 'sourcecode',   label: 'Source Code Pro',   css: "'Source Code Pro', monospace",     group: 'Mono' },
];

const TRANSLATE_LANGUAGES = [
    { code: 'es',    label: 'Spanish',              native: 'Español' },
    { code: 'fr',    label: 'French',               native: 'Français' },
    { code: 'de',    label: 'German',               native: 'Deutsch' },
    { code: 'it',    label: 'Italian',              native: 'Italiano' },
    { code: 'pt',    label: 'Portuguese',           native: 'Português' },
    { code: 'ru',    label: 'Russian',              native: 'Русский' },
    { code: 'zh-CN', label: 'Chinese (Simplified)', native: '中文(简)' },
    { code: 'zh-TW', label: 'Chinese (Traditional)',native: '中文(繁)' },
    { code: 'ja',    label: 'Japanese',             native: '日本語' },
    { code: 'ko',    label: 'Korean',               native: '한국어' },
    { code: 'ar',    label: 'Arabic',               native: 'العربية' },
    { code: 'hi',    label: 'Hindi',                native: 'हिन्दी' },
    { code: 'he',    label: 'Hebrew',               native: 'עברית' },
    { code: 'yi',    label: 'Yiddish',              native: 'ייִדיש' },
    { code: 'nl',    label: 'Dutch',                native: 'Nederlands' },
    { code: 'pl',    label: 'Polish',               native: 'Polski' },
    { code: 'sv',    label: 'Swedish',              native: 'Svenska' },
    { code: 'no',    label: 'Norwegian',            native: 'Norsk' },
    { code: 'da',    label: 'Danish',               native: 'Dansk' },
    { code: 'fi',    label: 'Finnish',              native: 'Suomi' },
    { code: 'tr',    label: 'Turkish',              native: 'Türkçe' },
    { code: 'uk',    label: 'Ukrainian',            native: 'Українська' },
    { code: 'cs',    label: 'Czech',                native: 'Čeština' },
    { code: 'hu',    label: 'Hungarian',            native: 'Magyar' },
    { code: 'ro',    label: 'Romanian',             native: 'Română' },
    { code: 'id',    label: 'Indonesian',           native: 'Bahasa Indonesia' },
    { code: 'vi',    label: 'Vietnamese',           native: 'Tiếng Việt' },
    { code: 'th',    label: 'Thai',                 native: 'ภาษาไทย' },
    { code: 'el',    label: 'Greek',                native: 'Ελληνικά' },
    { code: 'bg',    label: 'Bulgarian',            native: 'Български' },
    { code: 'ca',    label: 'Catalan',              native: 'Català' },
    { code: 'ms',    label: 'Malay',                native: 'Bahasa Melayu' },
    { code: 'af',    label: 'Afrikaans',            native: 'Afrikaans' },
    { code: 'sw',    label: 'Swahili',              native: 'Kiswahili' },
    { code: 'tl',    label: 'Filipino',             native: 'Filipino' },
    { code: 'bn',    label: 'Bengali',              native: 'বাংলা' },
    { code: 'ur',    label: 'Urdu',                 native: 'اردو' },
    { code: 'fa',    label: 'Persian',              native: 'فارسی' },
    { code: 'hy',    label: 'Armenian',             native: 'Հայերեն' },
    { code: 'ka',    label: 'Georgian',             native: 'ქართული' },
    { code: 'eo',    label: 'Esperanto',            native: 'Esperanto' },
    { code: 'la',    label: 'Latin',                native: 'Latina' },
];



// Persona starters — shared by the live chat AND the copy/paste flow so they stay in sync.
// e = emoji, t = title, p = the instruction sent to the AI (or pasted into ChatGPT).
export const AI_GOAL_CHIPS = [
    { e: '🎬', t: 'Cinematic trailer', p: 'Make a cinematic trailer from the best moments — open on the strongest hook and end on a powerful line.' },
    { e: '✨', t: 'Best moments', p: 'Pick the strongest, most quotable moments, in story order.' },
    { e: '❤️', t: 'Emotional cut', p: 'Make an emotional cut — the most heartfelt, moving moments.' },
    { e: '🔥', t: 'Punchy 30s', p: 'Make a punchy 30-second social cut — only the most surprising or powerful lines.' },
    { e: '🎲', t: 'Surprise me', p: 'Surprise me — find a striking, non-obvious cut I would never have thought to try myself.' },
    { e: '⏳', t: 'Build suspense', p: 'Build suspense — use pacing and pauses to create tension and curiosity, then land a reveal.' },
    { e: '🧵', t: 'Tell the story', p: 'Tell the full story — a clear narrative arc with a hook, a build, and a payoff, well-paced.' },
    { e: '💬', t: 'Quotable lines', p: 'Pull the most quotable, postable lines — the kind that stand on their own.' },
    { e: '🎵', t: 'Find the rhythm', p: 'Build it for rhythm — vary the clip lengths and use beats so it flows with great pacing.' },
    { e: '🌟', t: 'Golden ratio', p: 'Build from the "golden ratio" soundbites — the harmonious middle length: long enough to land a complete thought, short enough to stay sharp. Favor those over the longest rambles and shortest fragments, and pick the most meaningful among them.' },
];
const AI_LENS_CHIPS = [
    { e: '🎞️', t: "Filmmaker's eye", p: 'Edit like an art-house documentary filmmaker — mood, atmosphere and visual poetry; let the strongest moments breathe.' },
    { e: '📜', t: "Historian's record", p: 'Edit like a historian preserving the essential record — the moments of lasting significance, kept in context and order.' },
    { e: '🎙️', t: "Journalist's cut", p: 'Edit like an investigative journalist — the key claims, revelations and the truth that matters most.' },
    { e: '🎭', t: "Dramatist's arc", p: 'Edit like a dramatist — find the character, the conflict and the emotional turning points; build a real arc.' },
    { e: '🧠', t: "Essayist's thread", p: 'Edit like a video essayist — the ideas and the throughline; the meaning beneath the surface, in a coherent argument.' },
    { e: '🌀', t: 'Poet of chaos', p: 'Edit like an avant-garde poet — find an unexpected, beautiful order in the chaos that reveals something no obvious cut would.' },
    { e: '🕯️', t: 'Rabbi', p: 'Edit like a wise Rabbi seeking inspiration — choose the most uplifting, soul-stirring moments, highlight any lines that echo Torah, scripture or timeless wisdom, and avoid anything that contradicts a Torah-true message.' },
    { e: '🧪', t: 'Experimentalist', p: 'Edit like a bold experimentalist — break the rules, try unconventional juxtapositions and unexpected orders; favor a daring, surprising result over a safe, obvious one.' },
    { e: '🔍', t: 'Fact-checker', p: 'Act as a careful fact-checker — review the claims across the clips and note which appear true in context and which appear false, misleading or unverified (give your confidence and remind me to verify independently). Then select the clips carrying the most notable claims.' },
    { e: '😂', t: 'Comedian', p: 'Edit like a comedian — find the funniest, most entertaining beats and the best comedic timing; build a piece that lands its laughs.' },
    { e: '💥', t: 'Hook-master', p: 'Edit like a viral content strategist — find the most attention-grabbing, scroll-stopping, shareable moments and open on the single strongest hook.' },
    { e: '🍒', t: 'Isaac', p: "Edit like Isaac — a documentary filmmaker who believes a film's soul lives in HOW each moment is cut. Trust intuition over formula. Find the quiet human truth and the beauty other editors walk past; honor faith, meaning and dignity; let real emotion breathe and leave room for a pregnant pause before what matters most. Remember that the same footage holds near-infinite cuts — reach past the obvious one for the cut that says something true and moves something deep, even if it surprises me." },
    { e: '🪡', t: 'Found Poet', p: "Become a found-poetry artist — an Edward-Scissorhands of words. Read every clip's words, then WRITE a short, original poem (or tiny story) using ONLY words that actually appear somewhere in the transcript. Build it by borrowing words from DIFFERENT clips — one word from here, the next from there — stitching real fragments into something the speaker never quite said. Rules: (1) First, in your reply, write out the finished poem so I can read it. (2) Then reconstruct it as the json: for EACH word or short run of words, output {\"id\": N, \"keep\": \"the EXACT word(s) copied verbatim from that clip's text\"}, IN THE ORDER they should play, so the clips replay your poem line by line. (3) The \"keep\" must be words that truly exist in that clip's text — never invent or change a word. (4) Use each clip at most once, so favor words that appear in many different clips. Make it beautiful and a little haunting." },
];

const DraggableToolbar = ({
    viewConfig,
    archiveInfo = null,       // ARCHIVE: { sources, key } when the sheet spans several uploads
    onPositionChange,
    rowCount = 0,
    selectedCount = 0,
    totalCount = 0,
    sentiments = {},
    onSentimentChange,
    speakers = {},
    onSpeakerChange,
    speakerNames = {},
    textLen = [0, 100],
    textLenBounds = [0, 0],
    onLengthChange,
    seconds = [0, 100],
    secondsBounds = [0, 0],
    onSecondsChange,
    onResetFilters,
    subtitlesEnabled,
    onSetResetSubtitles,
    spacesOnOff,
    onSetSpaces,
    onSearchChange,
    searchContext = 0,
    onSearchContextChange = null,
    searchValue,
    store,
    currentView = 'Create a Video',
    onViewChange,
    makeMidia,
    precision,
    onPrecisionChange,
    videoWidth,
    onVideoWidthChange,
    onJumpToItem = null,
    setCloseSearchModalRef = null,
    setOpenExportModalRef = null,
    setOpenBlackCherryRef = null,
    setToolbarOpeners = null,
    onExportModalOpenChange = null,
    videoFileExtension = 'mp4',
    quickFilters = { selectedOnly: false, hasQuestion: false },
    onQuickFilterChange = null,
    columnSet = 'standard',
    onToggleColumnSet = null,
    sortOrder = null,
    onSortOrderChange = null,
    spacesMode = 'hide',
    onSpacesModeChange = null,
    availableFirstLetters = [],
    availableDurations = [],
    defaultExportTitle = '',
    showExtraMobileColumns = false,
    onToggleMobileColumns = null,
    onPinSelectedToTop = null,
    onBuildAiPack = null,
    onSelectByIds = null,
    aiLink = null,          // { on, status, count } from utils/aiLink — null hides the button
    onToggleAiLink = null,
    onApplyFiller = null,
    fillerMode = 'off',
    fillerDone = false,
    onFillerModeChange = null,
    onApplyVirality = null,
    viralityDone = false,
    onSortVirality = null,
    viralityRange = [0, 100],
    onViralityRangeChange = null,
    onUndo = null,
    onRedo = null,
    canUndo = false,
    canRedo = false,
    penMode = false,
    onPenModeChange = null,
    editMode = false,
    onEditModeChange = null,
    playNext = false,
    onPlayNextChange = null,
    playHighlightsOnly = false,
    onPlayHighlightsChange = null,
    availableEntityTypes = [],
    availableContentFlags = [],
    availableKeyPhrases = [],
    availableVerbs = [],
    availableNouns = [],
    availableAdjectives = [],
    regroupParams = null,
    onRegroupChange = null,
    onClearSelections = null,
    originalRowCount = 0,
    transcriptStyle = null,
    onTranscriptStyleChange = null,
    translationLang = null,
    onTranslationLangChange = null,
    onTranslateAll = null,
    translating = false,
    translationProgress = 0,
    onClearTranslation = null,
    hasTranslations = false,
    onToggleTranslation = null,
    canToggleTranslation = false,
    lastTranslationLang = null,
    selectedDurationMs = 0,
    exportPreview = null,
    onShareLink = null,
    onEditText = null,
}) => {
    const x = toJS(sentiments);
    const [position, setPosition] = useState('top');
    // The pinned left cluster only reveals itself (a soft shadow) once the row is
    // actually scrolled — at rest it blends into the toolbar like any other group.
    const [scrolled, setScrolled] = useState(false);
    const toolbarScrollRef = useRef(null);
    // In the docked Premiere panel the window is short and narrow, so the Black
    // Cherry dialog's website offsets (264px top, 248px right, height 100vh-284)
    // squish it to nothing. Panel mode gets a near-top, near-full-height layout.
    const isPanelEmbed = getEmbedParentOrigin() === 'file://';
    const [hoveredShow, setHoveredShow] = useState(null);
    const [hoveredSort, setHoveredSort] = useState(null);
    const [hoveredMark, setHoveredMark] = useState(null);
    const [hoveredTool, setHoveredTool] = useState(null);
    const theme = useTheme();
    // Animated label that collapses to icon-only and expands on hover
    const expandLabelSx = (key, maxW = 90) => ({
        maxWidth: hoveredTool === key ? `${maxW}px` : 0,
        opacity: hoveredTool === key ? 1 : 0,
        overflow: 'hidden', whiteSpace: 'nowrap', fontWeight: 400, fontSize: '10px',
        marginLeft: hoveredTool === key ? '4px' : 0,
        transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
    });
    const isDarkMode = theme.palette.mode === 'dark';

    // Regroup panel state — use a ref to avoid stale closure in debounce
    const [regroupOpen, setRegroupOpen] = useState(false);
    const regroupAnchorRef = React.useRef(null);
    // When Segment by is opened from the floating tool rail there is no sensible toolbar
    // button to hang off, and hugging the toolbar put it small and far away. This virtual
    // anchor drops the panel near the middle of the screen instead.
    const [regroupCentered, setRegroupCentered] = useState(false);
    const centerAnchor = React.useMemo(() => ({
        getBoundingClientRect: () => {
            const x = window.innerWidth / 2, y = Math.max(90, window.innerHeight * 0.2);
            return { width: 0, height: 0, top: y, bottom: y, left: x, right: x, x, y, toJSON: () => {} };
        },
    }), []);
    const DEFAULT_REGROUP = { maxChars: 150, minDuration: 1, maxGap: 2 };
    const localParamsRef = React.useRef(DEFAULT_REGROUP);
    const [localParams, setLocalParams] = useState(DEFAULT_REGROUP);
    const regroupDebounceRef = React.useRef(null);
    // Pending segment-mode switch awaiting in-app confirmation: { count, apply } or null.
    const [confirmSwitch, setConfirmSwitch] = useState(null);

    const handleOpenRegroup = () => {
        // Sync local slider state from active params when opening
        if (regroupParams) {
            localParamsRef.current = regroupParams;
            setLocalParams(regroupParams);
        }
        setRegroupOpen(v => !v);
    };

    const handleRegroupSlider = (field, value) => {
        // Update both the ref (for immediate debounce access) and state (for rendering)
        const newParams = { ...localParamsRef.current, [field]: value };
        localParamsRef.current = newParams;
        setLocalParams(newParams);
        clearTimeout(regroupDebounceRef.current);
        regroupDebounceRef.current = setTimeout(() => {
            if (onRegroupChange) onRegroupChange(localParamsRef.current);
        }, 200);
    };

    const handleRegroupReset = () => {
        localParamsRef.current = DEFAULT_REGROUP;
        setLocalParams(DEFAULT_REGROUP);
        if (onRegroupChange) onRegroupChange(null);
        setRegroupOpen(false);
    };

    // The clip "space" each segment mode lives in. Switching between two different
    // spaces re-cuts the list with new clip ids, so any selection (which is keyed by
    // clip id) can't carry over — those exact clips no longer exist in the other mode.
    const currentSpace = () => {
        if (!regroupParams) return 'sentence';
        if (regroupParams.mode === 'word') return 'word';
        if (regroupParams.mode === 'interval') return 'interval';
        return 'custom';
    };

    // Warn before a mode switch that would discard selections. If the target space
    // matches the current one (no real switch) or nothing is selected, the switch
    // runs immediately; otherwise we stash the pending action and open an in-app
    // confirm dialog (handleConfirmSwitch runs it, handleCancelSwitch drops it).
    const requestModeSwitch = (targetSpace, apply) => {
        if (targetSpace === currentSpace()) { apply(); return; }
        const count = filterStore.howManySelectedSentences(currentView);
        if (count <= 0) { apply(); return; }
        setConfirmSwitch({ count, apply });
    };
    const handleConfirmSwitch = () => {
        if (confirmSwitch) {
            if (onClearSelections) onClearSelections();
            else filterStore.resetSelectedSentences(currentView);
            confirmSwitch.apply();
        }
        setConfirmSwitch(null);
    };
    const handleCancelSwitch = () => setConfirmSwitch(null);

    // Switch between Original (raw AssemblyAI sentences), Smart merge (slider-based),
    // and By seconds (fixed interval). Original = no regroup at all.
    const handleRegroupMode = (mode) => {
        const targetSpace = mode === 'original' ? 'sentence'
            : mode === 'interval' ? 'interval' : 'custom';
        requestModeSwitch(targetSpace, () => {
            if (mode === 'original') {
                if (onRegroupChange) onRegroupChange(null);
                return;
            }
            const params = mode === 'interval'
                ? { mode: 'interval', interval: localParamsRef.current.interval || 5 }
                : { ...DEFAULT_REGROUP };
            localParamsRef.current = params;
            setLocalParams(params);
            if (onRegroupChange) onRegroupChange(params);
        });
    };
    const handleRegroupInterval = (sec) => {
        // Already in seconds mode; changing N re-cuts the clip ids, so a stale selection
        // would silently point at the wrong slice. Drop it (no popup — this is live
        // fiddling within the same mode, not a mode switch).
        if (filterStore.howManySelectedSentences(currentView) > 0) {
            if (onClearSelections) onClearSelections();
            else filterStore.resetSelectedSentences(currentView);
        }
        const params = { mode: 'interval', interval: sec };
        localParamsRef.current = params;
        setLocalParams(params);
        clearTimeout(regroupDebounceRef.current);
        regroupDebounceRef.current = setTimeout(() => {
            if (onRegroupChange) onRegroupChange(localParamsRef.current);
        }, 150);
    };
    // Original sub-mode: sentence-by-sentence (null) vs word-by-word ({mode:'word'})
    const handleOriginalSub = (sub) => {
        requestModeSwitch(sub === 'word' ? 'word' : 'sentence', () => {
            if (onRegroupChange) onRegroupChange(sub === 'word' ? { mode: 'word' } : null);
        });
    };

    // Load Google Fonts once
    useEffect(() => {
        const id = 'cherryclipz-google-fonts';
        if (!document.getElementById(id)) {
            const link = document.createElement('link');
            link.id = id;
            link.rel = 'stylesheet';
            link.href = 'https://fonts.googleapis.com/css2?family=Anton&family=Bebas+Neue&family=DM+Sans:wght@400;500&family=EB+Garamond:wght@400;700&family=Lato:wght@400;700&family=Lora:ital,wght@0,400;1,400&family=Merriweather:wght@400;700&family=Montserrat:wght@400;700&family=Nunito:wght@400;700&family=Open+Sans:wght@400;700&family=Oswald:wght@400;700&family=Playfair+Display:wght@400;700&family=Roboto:wght@400;700&family=Roboto+Mono:wght@400;700&family=Source+Code+Pro:wght@400;700&display=swap';
            document.head.appendChild(link);
        }
    }, []);

    // Text style panel
    const [textStyleOpen, setTextStyleOpen] = useState(false);
    const [textStyleCentered, setTextStyleCentered] = useState(false);
    const textStyleAnchorRef = React.useRef(null);
    const currentSize = transcriptStyle?.size ?? 16;
    const currentFontKey = transcriptStyle?.fontKey ?? 'sans';

    // Language picker panel
    const [langPickerOpen, setLangPickerOpen] = useState(false);
    const langPickerAnchorRef = React.useRef(null);
    const [langSearch, setLangSearch] = useState('');
    const selectedLangInfo = TRANSLATE_LANGUAGES.find(l => l.code === translationLang);

    // Responsive video width ranges based on screen size
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    const getVideoWidthRange = () => {
        if (isMobile) {
            return { min: 70, max: 130 }; // Small screens: 70-130
        } else if (isTablet) {
            return { min: 20, max: 250 }; // Medium screens: 20-250
        } else {
            return { min: 30, max: 400 }; // Large screens: 30-400
        }
    };

    const videoWidthRange = getVideoWidthRange();

    // Get screen-appropriate default value for reset button
    const getResponsiveDefault = () => {
        if (isMobile) {
            return 100; // Mobile default: mid-range of 70-130
        } else if (isTablet) {
            return 120; // Tablet default: good balance for tablets
        } else {
            return 200; // Desktop default: good balance for large screens
        }
    };

    const responsiveDefault = getResponsiveDefault();
    const [activeModal, setActiveModal] = useState(null);
    const [exportModalKey, setExportModalKey] = useState(0);
    const [secondsValues, setSecondsValues] = useState(seconds);
    const [filterPopoverAnchor, setFilterPopoverAnchor] = useState(null);
    const filterPopoverOpen = Boolean(filterPopoverAnchor);
    const [selectedCreateOptions, setSelectedCreateOptions] = useState([]);
    const [shortcutsOpen, setShortcutsOpen] = useState(false);
    const [aiOpen, setAiOpen] = useState(false);       // AI clip-picker dialog
    const [aiPaste, setAiPaste] = useState('');        // ids/JSON pasted back from the AI
    const [aiCopied, setAiCopied] = useState(null);    // which mode was copied: 'rough' | 'precise' | null
    const [aiGoal, setAiGoal] = useState('');          // the user's goal, baked into the copied pack
    const [aiIncludeSilence, setAiIncludeSilence] = useState(true); // grab trailing silence so nothing's cut off
    const [aiFiltersAnchor, setAiFiltersAnchor] = useState(null);
    const aiFiltersAnchorRef = React.useRef(null);
    const [aiFiltersCentered, setAiFiltersCentered] = useState(false);
    const aiFiltersOpen = Boolean(aiFiltersAnchor);
    // Live chat (in-app, talks to OpenAI directly — no copy/paste)
    const [aiMode, setAiMode] = useState('chat');      // 'chat' (live API) | 'paste' (copy/paste)
    const [usageOpen, setUsageOpen] = useState(false); // AI usage report dialog
    const [usageRecords, setUsageRecords] = useState([]);
    const openUsage = () => { setUsageRecords(getAiUsage()); setUsageOpen(true); };
    // The chat can talk to any of these providers — the user brings their own key for each.
    const AI_PROVIDERS = {
        openai:    { label: 'OpenAI', keyName: 'cc_openai_key',    modelName: 'cc_openai_model',    defaultModel: 'gpt-5.4-mini',      hint: 'sk-…',     where: 'platform.openai.com → API keys' },
        anthropic: { label: 'Claude', keyName: 'cc_anthropic_key', modelName: 'cc_anthropic_model', defaultModel: 'claude-sonnet-4-6', hint: 'sk-ant-…', where: 'platform.claude.com → Get API key' },
        gemini:    { label: 'Gemini', keyName: 'cc_gemini_key',    modelName: 'cc_gemini_model',    defaultModel: 'gemini-2.5-flash',  hint: 'AIza…',    where: 'aistudio.google.com → Get API key' },
    };
    const [aiProvider, setAiProvider] = useState(() => { try { return localStorage.getItem('cc_ai_provider') || 'openai'; } catch (e) { return 'openai'; } });
    const [aiKey, setAiKey] = useState(() => { try { const p = localStorage.getItem('cc_ai_provider') || 'openai'; return localStorage.getItem(AI_PROVIDERS[p].keyName) || ''; } catch (e) { return ''; } });
    const [aiModel, setAiModel] = useState(() => { try { const p = localStorage.getItem('cc_ai_provider') || 'openai'; return localStorage.getItem(AI_PROVIDERS[p].modelName) || AI_PROVIDERS[p].defaultModel; } catch (e) { return 'gpt-5.4-mini'; } });
    // Set when the share's guest AI proxy answers 429/503 — flips the shared page
    // back to the "connect your key" form (otherwise shares never show it and the
    // "add your own key" error is a dead end — hit in the Premiere panel 2026-07-20).
    const [guestAiBlocked, setGuestAiBlocked] = useState(false);
    const [aiMessages, setAiMessages] = useState([]);  // [{role:'user'|'assistant', content}]
    const [aiInput, setAiInput] = useState('');
    const [aiChatLoading, setAiChatLoading] = useState(false);
    const [aiKeyDraft, setAiKeyDraft] = useState('');
    const [aiDrag, setAiDrag] = useState({ x: 0, y: 0 }); // drag offset for the floating panel
    const [aiElapsed, setAiElapsed] = useState(0);     // seconds the AI has been working (counts up, then holds)
    const [aiLastN, setAiLastN] = useState(-1);        // clips arranged on the last reply (-1 = none yet)
    const [aiPrecise, setAiPrecise] = useState(false); // let Cherry trim WITHIN clips (pen-style)
    const [aiLastTrimmed, setAiLastTrimmed] = useState(0); // how many clips got pen-trimmed on the last reply

    const userStore = useContext(userContext);
    const messageStore = useContext(messageContext);
    const filterStore = useContext(filterContext);
    // On a shared /s/ link the guest has no key — AI runs on the owner's server-side key via
    // the proxy (callLLM routes there), so the "add your key first" gates don't apply.
    const isSharedPage = typeof window !== 'undefined' && window.location.pathname.startsWith('/s/');
    const durationInMs = userStore.getDurationInMs()
    const currentDuration = (durationInMs !== undefined && durationInMs > 0 && durationInMs <= GIF_MAX_DURATION ? true : false)


    // Get current search text to determine if Super Cut should be enabled
    const currentSearchText = store.getSearch(currentView);
    const hasSuperCutEnabled = currentSearchText && currentSearchText.trim() !== '';

    // Audio uploads already export an audiogram via the main "Create a <EXT> video" option;
    // only VIDEO sources need a separate "Audio + Logo video" choice.
    const AUDIO_SOURCE_EXTS = ['mp3', 'm4a', 'wav', 'aac', 'flac', 'ogg', 'oga', 'aiff', 'aif', 'wma'];
    const isAudioSource = AUDIO_SOURCE_EXTS.includes((videoFileExtension || '').toLowerCase());
    const createOptions = [
        [`Create a ${videoFileExtension.toUpperCase()} video`, filterStore.hasSelectedSentences(currentView)],
        ['Super Cut (searched words only)', hasSuperCutEnabled && filterStore.hasSelectedSentences(currentView)],
        ['Create a MP3 audio', filterStore.hasSelectedSentences(currentView)],
        ...(!isAudioSource ? [['Create an Audio + Logo video', filterStore.hasSelectedSentences(currentView)]] : []),
        ['Create a GIF', currentDuration],
        ['Create a SRT file', filterStore.hasSelectedSentences(currentView)],
        ['Create a VTT file', filterStore.hasSelectedSentences(currentView)],
        ['Export XML for Premiere Pro', filterStore.hasSelectedSentences(currentView)],
        [TRANSCRIPT_OPTION, filterStore.hasSelectedSentences(currentView)],
    ];
    // only show the create zip file with all SRT's option if the current view is Create a Video
    if (currentView === 'Create a Video') {
        createOptions.push(['Create zip file with all SRT\'s', true])
    }
    // ARCHIVE: drop the single-source-only exports (super cut, GIF, Premiere XML, zip of SRTs).
    const exportOptions = archiveInfo ? createOptions.filter(([label]) => !ARCHIVE_UNSUPPORTED_EXPORTS.has(label)) : createOptions;

    // Update secondsValues only when seconds prop changes from parent
    useEffect(() => {
        // Only update if the new seconds values are different from the current secondsValues
        if (seconds[0] !== secondsValues[0] || seconds[1] !== secondsValues[1]) {
            setSecondsValues(seconds);
        }
    }, [seconds]);

    // Set the close search modal reference
    useEffect(() => {
        if (setCloseSearchModalRef) {
            setCloseSearchModalRef(() => () => {
                setActiveModal(null);
            });
        }
    }, [setCloseSearchModalRef]);

    // Notify parent component when position changes
    useEffect(() => {
        if (onPositionChange) {
            onPositionChange(position);
        }
    }, [position, onPositionChange]);

    // Tell the parent when the Create/export modal opens or closes, so it can hide the
    // floating overlays (view toggle, export bar) that would otherwise sit on top of it.
    useEffect(() => {
        if (onExportModalOpenChange) {
            onExportModalOpenChange(activeModal === 'Create');
        }
    }, [activeModal, onExportModalOpenChange]);

    const handleSecondsChange = (newValues) => {
        setSecondsValues(newValues);
        onSecondsChange(newValues);
    };

    const handleButtonClick = (callback) => {
        setActiveModal(null);  // Close any open modal
        callback();  // Execute the original callback
    };

    const handleResetClick = () => {
        onResetFilters();
        setActiveModal(null);  // Close the modal
    };

    // Handle click on the toolbar handle to change position
    // If a direction is provided, set it explicitly; otherwise, cycle through positions.
    const handlePositionChange = (direction) => {
        if (direction) {
            setPosition(direction);
        } else {
            // Cycle through positions: left -> top -> right -> bottom -> left
            let newPosition;
            switch (position) {
                case 'left':
                    newPosition = 'top';
                    break;
                case 'top':
                    newPosition = 'right';
                    break;
                case 'right':
                    newPosition = 'bottom';
                    break;
                case 'bottom':
                    newPosition = 'left';
                    break;
                default:
                    newPosition = 'left';
            }
            setPosition(newPosition);
        }
    };

    const isVertical = position === 'left' || position === 'right';

    // Divider that automatically orients itself for horizontal vs vertical toolbar
    const GDivider = () => (
        <Divider
            orientation={isVertical ? 'horizontal' : 'vertical'}
            flexItem
            sx={{ opacity: 0.25, mx: isVertical ? 0 : 1.5, my: isVertical ? 1 : 0 }}
        />
    );

    const [helpTab, setHelpTab] = useState(0);

    const sentimentLabels = {
        positive: 'Positive sentiment',
        negative: 'Negative sentiment',
        neutral: 'Neutral sentiment'
    };

    const handleCreateOptionChange = (option, checked) => {
        // Check if the option is enabled before allowing changes
        const optionConfig = createOptions.find(item =>
            (Array.isArray(item) && item[0] === option) || item === option
        );

        const isEnabled = Array.isArray(optionConfig) ? optionConfig[1] : true;

        if (!isEnabled) {
            return; // Don't allow changes to disabled options
        }

        // Update selected options
        setSelectedCreateOptions(prev =>
            checked
                ? [...prev, option]
                : prev.filter(item => item !== option)
        );
    };

    const handleViewChange = (event) => {
        const customEvent = new CustomEvent('viewChange', {
            detail: { view: event.target.value }
        });
        window.dispatchEvent(customEvent);
        if (onViewChange) {
            onViewChange(event.target.value);
        }
        // Only close the modal if it's not the Search modal
        if (activeModal !== 'Search') {
            setActiveModal(null);
        }
    };
    const handleCreateMedia = () => {
        setExportModalKey(k => k + 1); // force CustomModal remount so useState(defaultExportTitle) re-initializes fresh
        // Pre-check the MP4 option so users just click OK without having to select anything
        setSelectedCreateOptions([`Create a ${videoFileExtension.toUpperCase()} video`]);
        setActiveModal('Create');
    }

    // Hand the export-modal opener to the parent — the mobile floating Export button in
    // createVideo.jsx opens the same Create modal as the toolbar button / ⌘E.
    useEffect(() => {
        if (setOpenExportModalRef) {
            setOpenExportModalRef(() => handleCreateMedia);
        }
    }, [setOpenExportModalRef, videoFileExtension]);

    // One stable `openTool(name)` handed to the parent; the map itself is refreshed every
    // render just above the return, so this never closes over stale handlers.
    const openersRef = React.useRef({});
    useEffect(() => {
        if (setToolbarOpeners) {
            setToolbarOpeners(() => (name, arg) => {
                const fn = openersRef.current[name];
                if (fn) fn(arg);
            });
        }
    }, [setToolbarOpeners]);

    // Hand the Black Cherry opener to the parent — an embed (the marketing plugin page) can then
    // open Black Cherry via a cc-et-cmd "blackcherry" command (the same panel as the toolbar button).
    useEffect(() => {
        if (setOpenBlackCherryRef) {
            setOpenBlackCherryRef(() => () => { setAiCopied(null); setAiOpen(true); });
        }
    }, [setOpenBlackCherryRef]);

    const handleSearchClick = () => {
        // Toggle the search modal - close it if it's already open, open it if it's closed
        setActiveModal(activeModal === 'Search' ? null : 'Search');
    }

    // AI clip picker: copy a clips+instructions pack (rough or precise), and apply the reply.
    const handleCopyAiPack = async (mode) => {
        try {
            await navigator.clipboard.writeText(onBuildAiPack(mode, aiGoal));
            setAiCopied(mode);
            setTimeout(() => setAiCopied(null), 2500);
        } catch (e) {
            messageStore.setMessage('Could not copy to clipboard — try again', 'error');
        }
    };
    const handleApplyAiIds = () => {
        const n = onSelectByIds(aiPaste, aiIncludeSilence);
        if (n > 0) {
            messageStore.setMessage(`Selected ${n} clip${n !== 1 ? 's' : ''} from the AI's picks`, 'success');
            setAiOpen(false);
            setAiPaste('');
        } else {
            messageStore.setMessage('No matching clip IDs found in that text', 'error');
        }
    };
    // Fast path: read the AI's reply straight from the clipboard and apply it — no dialog.
    // Copy ChatGPT/Gemini's answer, click "Paste AI Picks" (or ⌘⇧V), done.
    // Where the page can't read the clipboard (an embedding iframe without clipboard-read —
    // the Premiere panel before v0.3.0 — or a browser that refuses), fall back to opening
    // Black Cherry's paste box with the cursor in it: ⌘V works everywhere.
    const aiPasteFieldRef = React.useRef(null);
    const openPasteBoxFallback = () => {
        setAiMode('paste'); setAiCopied(null); setAiOpen(true);
        messageStore.setMessage('This window can\'t read the clipboard — paste the AI\'s reply into the box (⌘V / Ctrl+V)', 'info');
        setTimeout(() => { try { aiPasteFieldRef.current && aiPasteFieldRef.current.focus(); } catch (e) { /* not mounted yet */ } }, 250);
    };
    const handlePasteAiFromClipboard = async () => {
        if (!(navigator.clipboard && navigator.clipboard.readText)) { openPasteBoxFallback(); return; }
        let text;
        try {
            text = await navigator.clipboard.readText();
        } catch (e) {
            openPasteBoxFallback();
            return;
        }
        if (!text || !text.trim()) {
            messageStore.setMessage('Clipboard is empty — copy the AI\'s reply first', 'error');
            return;
        }
        const n = onSelectByIds(text, aiIncludeSilence);
        messageStore.setMessage(
            n > 0 ? `Selected ${n} clip${n !== 1 ? 's' : ''} from the AI's picks` : 'No matching clip IDs found in the clipboard',
            n > 0 ? 'success' : 'error'
        );
    };

    // Drag the floating Black Cherry panel by its header.
    const startAiDrag = (e) => {
        const start = { mx: e.clientX, my: e.clientY, bx: aiDrag.x, by: aiDrag.y };
        const onMove = (ev) => setAiDrag({ x: start.bx + (ev.clientX - start.mx), y: start.by + (ev.clientY - start.my) });
        const onUp = () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
    };

    const saveAiKey = (k) => {
        // strip spaces & any non-printable / non-ASCII chars that sneak in on paste and
        // break the fetch Authorization header ("non ISO-8859-1 code point")
        const clean = (k || '').replace(/[^\x21-\x7E]/g, '');
        setAiKey(clean);
        try { localStorage.setItem(AI_PROVIDERS[aiProvider].keyName, clean); } catch (e) {}
    };
    const saveAiModel = (m) => {
        const v = (m || '').trim() || AI_PROVIDERS[aiProvider].defaultModel;
        setAiModel(v);
        try { localStorage.setItem(AI_PROVIDERS[aiProvider].modelName, v); } catch (e) {}
    };
    // Switch provider: load that provider's saved key + model (or its default).
    const switchProvider = (p) => {
        if (!AI_PROVIDERS[p]) return;
        setAiProvider(p);
        try { localStorage.setItem('cc_ai_provider', p); } catch (e) {}
        try { setAiKey(localStorage.getItem(AI_PROVIDERS[p].keyName) || ''); } catch (e) { setAiKey(''); }
        try { setAiModel(localStorage.getItem(AI_PROVIDERS[p].modelName) || AI_PROVIDERS[p].defaultModel); } catch (e) { setAiModel(AI_PROVIDERS[p].defaultModel); }
        setAiKeyDraft('');
    };
    // One call that talks to whichever provider is selected, normalizing the very different
    // request/response shapes of OpenAI, Claude (Anthropic) and Gemini into {reply, tokens}.
    const callLLM = async ({ provider, key, model, systemPrompt, history }) => {
        // Shared-link guests have no key of their own. Route through the backend proxy, which
        // calls the LLM with the OWNER's server-side key (capped per share) — the key never
        // reaches the browser. apiRequest attaches the X-Share-Token on /s/ pages.
        // A viewer who HAS added their own key in Black Cherry calls the provider directly
        // instead (their key, their cost) — this also makes the "add your own key" hint true
        // on shares where guest AI isn't configured.
        if (typeof window !== 'undefined' && window.location.pathname.startsWith('/s/') && !key) {
            const res = await apiRequest(aiProxySharedUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ systemPrompt, history }),
            });
            if (res.status === 429) throw new Error('This link has used up its free AI — add your own key in Black Cherry to keep going.');
            if (res.status === 503) throw new Error('Guest AI isn’t enabled for this link — add your own key in Black Cherry.');
            if (!res.ok) {
                const e = await res.json().catch(() => ({}));
                throw new Error(e.message || 'AI request failed — please try again.');
            }
            const data = await res.json();
            return { reply: data.reply || '', tokensIn: data.tokensIn || 0, tokensOut: data.tokensOut || 0, tokens: data.tokens || 0 };
        }
        if (provider === 'anthropic') {
            const res = await fetch('https://api.anthropic.com/v1/messages', {
                method: 'POST',
                headers: { 'content-type': 'application/json', 'x-api-key': key, 'anthropic-version': '2023-06-01', 'anthropic-dangerous-direct-browser-access': 'true' },
                body: JSON.stringify({ model, max_tokens: 8192, system: systemPrompt, messages: history.map(m => ({ role: m.role === 'assistant' ? 'assistant' : 'user', content: m.content })) }),
            });
            if (!res.ok) throw new Error(res.status === 401 ? 'Invalid Claude key — check it and try again' : `Claude error (${res.status})`);
            const data = await res.json();
            const reply = (data?.content || []).map(b => b.text || '').join('') || '';
            const ti = data?.usage?.input_tokens || 0, to = data?.usage?.output_tokens || 0;
            return { reply, tokensIn: ti, tokensOut: to, tokens: ti + to };
        }
        if (provider === 'gemini') {
            const res = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/${encodeURIComponent(model)}:generateContent?key=${encodeURIComponent(key)}`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({ systemInstruction: { parts: [{ text: systemPrompt }] }, contents: history.map(m => ({ role: m.role === 'assistant' ? 'model' : 'user', parts: [{ text: m.content }] })) }),
            });
            if (!res.ok) throw new Error((res.status === 400 || res.status === 403) ? 'Invalid Gemini key or model name' : `Gemini error (${res.status})`);
            const data = await res.json();
            const reply = (data?.candidates?.[0]?.content?.parts || []).map(p => p.text || '').join('') || '';
            const ti = data?.usageMetadata?.promptTokenCount || 0, to = data?.usageMetadata?.candidatesTokenCount || 0;
            return { reply, tokensIn: ti, tokensOut: to, tokens: data?.usageMetadata?.totalTokenCount || (ti + to) };
        }
        // default: OpenAI
        const res = await fetch('https://api.openai.com/v1/chat/completions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${key}` },
            body: JSON.stringify({ model, messages: [{ role: 'system', content: systemPrompt }, ...history] }),
        });
        if (!res.ok) throw new Error(res.status === 401 ? 'Invalid API key — check it and try again' : `OpenAI error (${res.status})`);
        const data = await res.json();
        const ti = data?.usage?.prompt_tokens || 0, to = data?.usage?.completion_tokens || 0;
        return { reply: data?.choices?.[0]?.message?.content || '', tokensIn: ti, tokensOut: to, tokens: data?.usage?.total_tokens || (ti + to) };
    };

    // Rough $ estimate per run (approx public prices, $/million tokens in/out). Labelled "≈"
    // because exact prices vary by model/tier — this is for awareness, not billing.
    const estimateCostUSD = (provider, model, tokensIn, tokensOut) => {
        const m = (model || '').toLowerCase();
        let pin = 3, pout = 15; // default ~Sonnet
        if (provider === 'anthropic') { pin = m.includes('opus') ? 15 : m.includes('haiku') ? 1 : 3; pout = m.includes('opus') ? 75 : m.includes('haiku') ? 5 : 15; }
        else if (provider === 'gemini') { pin = m.includes('flash') ? 0.30 : 1.25; pout = m.includes('flash') ? 2.5 : 10; }
        else { const cheap = m.includes('mini') || m.includes('nano'); pin = cheap ? 0.25 : 2.5; pout = cheap ? 2 : 10; }
        return (tokensIn / 1e6) * pin + (tokensOut / 1e6) * pout;
    };
    const usageNote = (tokensIn, tokensOut) => {
        const fmtT = (n) => (n >= 1000 ? `${Math.round(n / 1000)}k` : `${n}`);
        const usd = estimateCostUSD(aiProvider, (aiModel || AI_PROVIDERS[aiProvider].defaultModel), tokensIn, tokensOut);
        const fmtC = usd < 0.01 ? '<1¢' : usd < 1 ? `~${Math.round(usd * 100)}¢` : `~$${usd.toFixed(2)}`;
        return `${fmtT(tokensIn || 0)} in / ${fmtT(tokensOut || 0)} out · ${fmtC}`;
    };
    // Log each AI call to the local usage log (tokens, est cost, which video) so the
    // user can see per-video and lifetime spend. Best-effort; never blocks the call.
    const recordUsage = (feature, tokensIn, tokensOut) => {
        try {
            const model = aiModel || AI_PROVIDERS[aiProvider].defaultModel;
            logAiUsage({
                ts: Date.now(),
                transcriptId: userStore.getUserTranscriptId() ?? null,
                videoTitle: userStore.getUserTranscriptTitle() || '',
                feature,
                provider: aiProvider,
                model,
                tokensIn: tokensIn || 0,
                tokensOut: tokensOut || 0,
                costUSD: estimateCostUSD(aiProvider, model, tokensIn || 0, tokensOut || 0),
            });
        } catch (e) { /* ignore */ }
    };

    // Live chat: talk to ChatGPT directly inside CherryClipz. The clips + editor instructions
    // become the system prompt (reuses our pack); the conversation drives the edit. The reply
    // is shown AND its clip ids are applied — no copy/paste.
    const handleSendChat = async (overrideText) => {
        const text = ((typeof overrideText === 'string' ? overrideText : aiInput) || '').trim();
        if (!text || aiChatLoading) return;
        const cleanKey = (aiKey || '').replace(/[^\x21-\x7E]/g, '');
        if (!cleanKey && !isSharedPage) {
            messageStore.setMessage(`Add your ${AI_PROVIDERS[aiProvider].label} API key first`, 'error');
            return;
        }
        const history = [...aiMessages, { role: 'user', content: text }];
        setAiMessages(history);
        setAiInput('');
        setAiChatLoading(true);
        try {
            const systemPrompt = onBuildAiPack('chat', '', aiPrecise);
            const { reply, tokensIn, tokensOut } = await callLLM({ provider: aiProvider, key: cleanKey, model: (aiModel || AI_PROVIDERS[aiProvider].defaultModel), systemPrompt, history });
            recordUsage('chat', tokensIn, tokensOut);
            const n = onSelectByIds(reply, aiIncludeSilence); // ids parsed from the hidden json block
            setAiLastN(n);
            // Count how many clips actually got pen-trimmed (highlights live in the store now).
            // This makes "is it trimming?" visible instead of a guess.
            try { setAiLastTrimmed(Object.keys(filterStore.highlights || {}).length); } catch (e) { setAiLastTrimmed(0); }
            const display = reply.replace(/```[\s\S]*?```/g, '').trim() || 'Done — I arranged your clips. ✨';
            setAiMessages((m) => [...m, { role: 'assistant', content: display }]);
            if (n > 0) messageStore.setMessage(`Arranged ${n} clip${n !== 1 ? 's' : ''} from the chat`, 'success');
            // Embed bridge: mirror the reply to the parent page's chat dock (Letter P).
            postToEmbedParent({ type: 'cc-et-ai-reply', text: display, applied: n });
        } catch (e) {
            const errText = `⚠️ ${e.message || 'Something went wrong calling OpenAI.'}`;
            if (/add your own key/i.test(e.message || '')) setGuestAiBlocked(true);
            setAiMessages((m) => [...m, { role: 'assistant', content: errText }]);
            postToEmbedParent({ type: 'cc-et-ai-reply', text: errText, applied: 0, error: true });
        } finally {
            setAiChatLoading(false);
        }
    };

    // ── Embed bridge: the parent page's chat dock (Letter P) can drive THIS chat ──
    // Same Black Cherry pipeline (guest proxy on shares, user key otherwise), same
    // auto-apply of picked clips; the reply is mirrored back via cc-et-ai-reply above.
    // Locked to the allowlisted parent origin — see utils/embedBridge.js.
    const embedChatRef = useRef(null);
    embedChatRef.current = handleSendChat;
    useEffect(() => {
        if (!getEmbedParentOrigin()) return undefined;
        const onCmd = (e) => {
            if (!isTrustedEmbedCommand(e)) return;
            const d = e.data;
            if (!d || d.type !== 'cc-et-cmd' || d.cmd !== 'ai-chat') return;
            const text = typeof d.text === 'string' ? d.text.trim().slice(0, 4000) : '';
            if (text && embedChatRef.current) embedChatRef.current(text);
        };
        window.addEventListener('message', onCmd);
        return () => window.removeEventListener('message', onCmd);
    }, []);

    // FILLER — one AI pass over every clip, returns the throwaway ids. Reuses the same
    // key/provider/model the live chat uses, so no extra setup. Result is applied via
    // onApplyFiller (which flips the list into Dim mode so the keepers pop right away).
    const [fillerLoading, setFillerLoading] = useState(false);
    const handleFindFiller = async () => {
        if (fillerLoading || !onBuildAiPack || !onApplyFiller) return;
        const cleanKey = (aiKey || '').replace(/[^\x21-\x7E]/g, '');
        if (!cleanKey && !isSharedPage) {
            messageStore.setMessage(`Add your ${AI_PROVIDERS[aiProvider].label} API key first (open Black Cherry)`, 'error');
            return;
        }
        setFillerLoading(true);
        try {
            const systemPrompt = onBuildAiPack('filler', '', false);
            const { reply, tokensIn, tokensOut } = await callLLM({ provider: aiProvider, key: cleanKey, model: (aiModel || AI_PROVIDERS[aiProvider].defaultModel), systemPrompt, history: [{ role: 'user', content: 'Mark the filler clips.' }] });
            recordUsage('filler', tokensIn, tokensOut);
            const n = onApplyFiller(reply);
            messageStore.setMessage(n > 0 ? `Found ${n} filler clip${n !== 1 ? 's' : ''} · ${usageNote(tokensIn, tokensOut)}` : 'No clear filler found — your transcript is tight!', n > 0 ? 'success' : 'info');
        } catch (e) {
            messageStore.setMessage(`⚠️ ${e.message || 'Could not reach the AI.'}`, 'error');
        } finally {
            setFillerLoading(false);
        }
    };

    // VIRALITY — one AI pass scores every clip 0–100, then the list auto-sorts high→low and
    // a "Viral" column appears. Same key/provider/model as the live chat.
    const [viralityLoading, setViralityLoading] = useState(false);
    const handleScoreVirality = async () => {
        if (viralityLoading || !onBuildAiPack || !onApplyVirality) return;
        const cleanKey = (aiKey || '').replace(/[^\x21-\x7E]/g, '');
        if (!cleanKey && !isSharedPage) {
            messageStore.setMessage(`Add your ${AI_PROVIDERS[aiProvider].label} API key first (open Black Cherry)`, 'error');
            return;
        }
        setViralityLoading(true);
        try {
            const systemPrompt = onBuildAiPack('virality', '', false);
            const { reply, tokensIn, tokensOut } = await callLLM({ provider: aiProvider, key: cleanKey, model: (aiModel || AI_PROVIDERS[aiProvider].defaultModel), systemPrompt, history: [{ role: 'user', content: 'Score every clip for virality.' }] });
            recordUsage('virality', tokensIn, tokensOut);
            const n = onApplyVirality(reply);
            messageStore.setMessage(n > 0 ? `Scored ${n} clips · ${usageNote(tokensIn, tokensOut)} 🔥` : 'Could not read the scores — try again', n > 0 ? 'success' : 'error');
        } catch (e) {
            messageStore.setMessage(`⚠️ ${e.message || 'Could not reach the AI.'}`, 'error');
        } finally {
            setViralityLoading(false);
        }
    };

    // Cmd/Ctrl + E → open Export, but only in the create-video view, only when clips
    // are selected, and never while the user is typing in a field.
    useEffect(() => {
        const onKey = (e) => {
            if (!(e.metaKey || e.ctrlKey) || (e.key || '').toLowerCase() !== 'e') return;
            const el = document.activeElement;
            if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable)) return;
            if (!viewConfig?.createVideo || !filterStore.hasSelectedSentences(currentView)) return;
            e.preventDefault();
            handleCreateMedia();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [viewConfig, currentView, filterStore, activeModal]);

    // Cmd/Ctrl + Shift + V → apply the AI's reply straight from the clipboard (create-video
    // view only, and not while typing in a field). The fast paste-back loop.
    useEffect(() => {
        const onKey = (e) => {
            if (!(e.metaKey || e.ctrlKey) || !e.shiftKey || (e.key || '').toLowerCase() !== 'v') return;
            const el = document.activeElement;
            if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable)) return;
            if (!viewConfig?.createVideo || !onSelectByIds) return;
            e.preventDefault();
            handlePasteAiFromClipboard();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [viewConfig, onSelectByIds, aiIncludeSilence]);

    // While the AI is working, count the seconds up so the user sees it's loading; the
    // value holds at its final number once the reply lands (interval stops).
    useEffect(() => {
        if (!aiChatLoading) return;
        const start = Date.now();
        setAiElapsed(0);
        const id = setInterval(() => setAiElapsed((Date.now() - start) / 1000), 100);
        return () => clearInterval(id);
    }, [aiChatLoading]);

    // ── TOOL RAIL OPENERS ──────────────────────────────────────────────────────
    // The floating tool rail (createVideo.jsx) groups the toolbar into four bubbles —
    // Search / Filters / Ask AI / Settings. Each bubble shows a box of the SAME buttons
    // that live up here, and pressing one calls straight back into the toolbar's own
    // control, so there is exactly one implementation of every panel. Refreshed on every
    // render into a ref so the parent's stable `openTool` never fires a stale closure
    // (same reason createVideo keeps openBlackCherryLatest).
    openersRef.current = {
        search:       () => setActiveModal('Search'),
        clipSize:     () => setActiveModal('VideoWidth'),
        textStyle:    () => { setTextStyleCentered(true); setTextStyleOpen(true); },
        segment:      () => {
            // ARCHIVE: re-cutting by seconds/words across several videos is meaningless — each video keeps its clips.
            if (archiveInfo) { messageStore.setMessage("Segment by isn't available for archives yet — each video keeps its own clips.", 'info'); return; }
            setRegroupCentered(true); setRegroupOpen(true);
        },
        clipTime:     () => setActiveModal('Seconds'),
        length:       () => setActiveModal('Length'),
        views:        () => setActiveModal('Views'),
        columns:      () => { if (onToggleColumnSet) onToggleColumnSet(); },
        help:         () => setShortcutsOpen(true),
        translate:    () => setLangPickerOpen(true),
        translateAll: () => { if (onTranslateAll) onTranslateAll(); },
        aiFilters:    () => { setAiFiltersCentered(true); setAiFiltersAnchor(aiFiltersAnchorRef.current || document.body); },
        blackCherry:  () => { setAiCopied(null); setAiOpen(true); },
        pasteAiPicks: () => handlePasteAiFromClipboard(),
        // Two ways into Black Cherry with the edit depth already chosen: rough keeps whole
        // clips, precise lets Cherry trim within them (the pen-style pack).
        // Open the live chat and, if the rail handed us a prompt, send it immediately.
        // handleSendChat takes an override string, so there is no stale-state race here.
        chatAsk:      (text) => {
            setAiMode('chat'); setAiCopied(null); setAiOpen(true);
            if (text && text.trim()) setTimeout(() => handleSendChat(text.trim()), 60);
        },
        chatRough:    () => { setAiPrecise(false); setAiCopied(null); setAiOpen(true); },
        chatPrecise:  () => { setAiPrecise(true); setAiCopied(null); setAiOpen(true); },
        aiUsage:      () => setUsageOpen(true),
        filler:       () => handleFindFiller(),
        virality:     () => handleScoreVirality(),
        exportModal:  () => handleCreateMedia(),
        clearFilters: () => { if (onResetFilters) onResetFilters(); },
    };

    return (
        <Box
            className={`toolbar ${position} ${isDarkMode ? 'dark-theme' : 'light-theme'}`}
            sx={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                borderColor: theme.palette.divider,
                padding: 0,
                margin: 0,
                boxSizing: 'border-box',
                // In the Premiere panel, go fully shadow-free: the toolbar's own CSS
                // elevation shadow AND every contained-button's default drop shadow
                // (a row of them read as "black lines under the words"). Website keeps
                // both — this only fires in panel mode.
                ...(getEmbedParentOrigin() === 'file://'
                    ? { boxShadow: 'none !important', '& .MuiButton-root': { boxShadow: 'none !important' } }
                    : {}),
            }}
        >
            {/* Wheel/Magic-Mouse scrolling in the panel is handled globally in
                createVideo.jsx (CEF ignores wheel-on-overflow) — covers this
                toolbar and the clip list from one place. */}
            <Box
                className="toolbar-content"
                ref={toolbarScrollRef}
                onScroll={(e) => {
                    const s = e.currentTarget.scrollLeft > 2;
                    setScrolled((prev) => (prev !== s ? s : prev));
                }}
                sx={{
                    margin: 0,
                    overflow: 'auto',
                    position: 'relative', // Ensure proper stacking context
                    // Scrollable container with proper scrollbars
                    '&::-webkit-scrollbar': {
                        width: isVertical ? '6px' : 'auto',
                        height: isVertical ? 'auto' : '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: theme.palette.divider,
                        borderRadius: '3px',
                        '&:hover': {
                            backgroundColor: theme.palette.text.secondary,
                        }
                    },
                    // For Firefox
                    scrollbarWidth: 'thin',
                    scrollbarColor: `${theme.palette.divider} transparent`,
                    // Ensure dropdowns can escape the container
                    '& .MuiPopper-root': {
                        zIndex: 1400
                    }
                }}
            >
                <Stack
                    direction={isVertical ? "column" : "row"}
                    spacing={1.5}
                    alignItems="center"
                    sx={{
                        width: '100%',
                        minWidth: isVertical ? 'auto' : 'max-content',
                        minHeight: isVertical ? 'max-content' : 'auto',
                        // The 8px left inset lives on the pinned cluster's own padding
                        // now (horizontal), so its opaque backing can rest AND stick at
                        // 0 — no scroll hop, and it still covers the left edge. Vertical
                        // keeps the Stack padding.
                        pl: isVertical ? 1 : 0,
                        '& > *': { minWidth: isVertical ? '100%' : 'auto', flexShrink: 0 }
                    }}
                >

                    {/* ── PINNED LEFT CLUSTER ────────────────────────────────────
                           Clips / Selected + the "Filtering by" readout + a Reset
                           stay frozen at the left while the filter buttons scroll
                           under them — so you can always see the counts, what's on,
                           and clear it, without scrolling back (Isaac's ask). The
                           opaque background + right shadow hide the scrolling row. */}
                    <Box
                        className="toolbar-pinned"
                        sx={{
                            position: isVertical ? 'static' : 'sticky',
                            left: isVertical ? 'auto' : 0,
                            zIndex: 3,
                            // Own the 8px inset here (Stack no longer pads on the left in
                            // horizontal mode): content sits at 8px, but the box — and
                            // its opaque backing — rests at 0 and sticks at 0. So no hop,
                            // and the backing covers the left edge where a scrolled
                            // button was peeking ("EI"CLIPS).
                            pl: isVertical ? 0 : '8px',
                            display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 1.5,
                            // Transparent at rest → the toolbar's own colour shows
                            // through and the cluster is invisible, exactly like
                            // before. Only once scrolled does it need an opaque
                            // backing to mask the row sliding under it — matched to
                            // the toolbar's CSS colour (#333 dark / #f5f5f5 light),
                            // NOT background.paper, which is a different shade.
                            backgroundColor: (!isVertical && scrolled)
                                ? (isDarkMode ? '#333333' : '#f5f5f5')
                                : 'transparent',
                            pr: 0.75,
                            // No shadow — Isaac wants nothing when scrolling; the
                            // opaque backing alone masks the row cleanly.
                            boxShadow: 'none',
                        }}
                    >
                    {/* ── CLIPS / SELECTED ──────────────────────────────────────
                           Two labelled mini-columns ("Clips" + "Selected"), each with a
                           fixed min-width so the numbers can change (102 → 21) without
                           shifting the rest of the toolbar. */}
                    {viewConfig?.stats && (
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'flex-start' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 38 }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Clips</Typography>
                                <Box sx={{ height: '26px', display: 'flex', alignItems: 'center' }}>
                                    <Tooltip title={`${rowCount} of ${totalCount} clips visible`} placement="bottom">
                                        <Typography sx={{ fontSize: '15px', fontWeight: 700, color: theme.palette.text.primary, lineHeight: 1, cursor: 'default' }}>{rowCount}</Typography>
                                    </Tooltip>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 48 }}>
                                <Typography variant="caption" sx={{ color: selectedCount > 0 ? '#E53935' : theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Selected</Typography>
                                <Box sx={{ height: '26px', display: 'flex', alignItems: 'center' }}>
                                    <Tooltip title={`${selectedCount} selected`} placement="bottom">
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'default' }}>
                                            {/* Turns red when clips are selected, matching the red ALL select toggle */}
                                            <CheckCircleIcon sx={{ fontSize: 13, color: selectedCount > 0 ? '#E53935' : theme.palette.text.secondary }} />
                                            <Typography sx={{ fontSize: '15px', fontWeight: 700, color: selectedCount > 0 ? '#E53935' : theme.palette.text.primary, lineHeight: 1 }}>{selectedCount}</Typography>
                                        </Box>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>
                    )}

                    <GDivider />

                    {/* ── FILTER GROUP label (non-interactive) ──────────────────
                           Nothing on → amber "Click a button →" prompt.
                           Filters on → the prompt is replaced by each active filter's
                           own symbol in its own colour (+ green, − red, speaker letter
                           teal, clock for time…). A FIXED-WIDTH slot keeps the toolbar
                           from ever growing or shifting. */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', userSelect: 'none', pointerEvents: 'none', width: 114, flexShrink: 0 }}>
                        {(() => {
                            const teal = '#00897B', indigo = '#5c6bc0', violet = '#8b5cf6';
                            const sym = [];
                            if (sentiments?.positive) sym.push({ k: 'pos', el: '+', c: theme.palette.success.main });
                            if (sentiments?.neutral) sym.push({ k: 'neu', el: '=', c: theme.palette.text.secondary });
                            if (sentiments?.negative) sym.push({ k: 'neg', el: '−', c: theme.palette.error.main });
                            Object.keys(speakers || {}).forEach((s) => { if (speakers[s]) sym.push({ k: 'sp' + s, el: s, c: teal }); });
                            // Time / Length are ranges — "active" means the applied range is
                            // narrower than the clips' full bounds. Show the icon + chosen range.
                            const timeOn = secondsBounds[1] > 0 && (seconds[0] > secondsBounds[0] || seconds[1] < secondsBounds[1]);
                            if (timeOn) sym.push({ k: 'time', c: theme.palette.warning.main, el: (<><WatchLaterIcon sx={{ fontSize: 13 }} /><span style={{ fontSize: 11, fontWeight: 700 }}>{seconds[0]}–{seconds[1]}s</span></>) });
                            const lenOn = textLenBounds[1] > 0 && (textLen[0] > textLenBounds[0] || textLen[1] < textLenBounds[1]);
                            if (lenOn) sym.push({ k: 'len', c: '#009688', el: (<><span style={{ fontWeight: 800 }}>#</span><span style={{ fontSize: 11, fontWeight: 700 }}>{textLen[0]}–{textLen[1]}</span></>) });
                            if (currentSearchText && currentSearchText.trim()) sym.push({ k: 'search', el: <SearchIcon sx={{ fontSize: 13 }} />, c: theme.palette.info.main });
                            // FIND pad: "Starts With" letter + the duration bucket (e.g. 5s / 10s+).
                            if (quickFilters?.firstLetter) sym.push({ k: 'letter', el: quickFilters.firstLetter, c: theme.palette.info.main });
                            if (quickFilters?.durationSec !== null && quickFilters?.durationSec !== undefined) sym.push({ k: 'durbk', c: theme.palette.info.main, el: <span style={{ fontSize: 11, fontWeight: 700 }}>{quickFilters.durationSec === 10 ? '10s+' : `${quickFilters.durationSec}s`}</span> });
                            if (spacesMode === 'show' || spacesMode === 'only') sym.push({ k: 'space', el: <VisibilityIcon sx={{ fontSize: 13 }} />, c: indigo });
                            if (quickFilters?.hasQuestion) sym.push({ k: 'q', el: '?', c: theme.palette.info.main });
                            if (quickFilters?.containsNumbers) sym.push({ k: 'num', el: '#', c: theme.palette.warning.main });
                            const aiCount = ['entityTypes', 'contentFlags', 'keyPhrases', 'filterVerbs', 'filterNouns', 'filterAdjectives']
                                .reduce((n, k) => n + ((quickFilters?.[k] || []).length), 0);
                            if (aiCount > 0) sym.push({ k: 'ai', el: <AutoFixHighIcon sx={{ fontSize: 13 }} />, c: violet });
                            const on = sym.length > 0;
                            const accent = on ? theme.palette.info.main : theme.palette.warning.main;
                            const canReset = on && viewConfig?.resetFilters;
                            return (<>
                                {/* When filtering, the label doubles as a subtle Clear —
                                    no separate button, no width change, no jump. It just
                                    turns into a "↺ Clear filters" link (hover → red). The
                                    symbols below still say WHAT is filtering. */}
                                <Tooltip title={canReset ? 'Clear all filters & search' : ''} placement="bottom" disableHoverListener={!canReset}>
                                    <Typography
                                        variant="caption"
                                        onClick={canReset ? handleResetClick : undefined}
                                        sx={{
                                            color: accent, mb: 0.5, fontSize: '9px', textTransform: 'uppercase',
                                            letterSpacing: '0.5px', fontWeight: 700, whiteSpace: 'nowrap',
                                            display: 'inline-flex', alignItems: 'center', gap: '3px',
                                            pointerEvents: canReset ? 'auto' : 'none',
                                            cursor: canReset ? 'pointer' : 'default',
                                            '&:hover': canReset ? { color: theme.palette.error.main } : {},
                                        }}
                                    >
                                        {canReset && <RestartAltIcon sx={{ fontSize: 11 }} />}
                                        {on ? (canReset ? 'Clear filters' : 'Filtering clips by') : 'Filter clips by'}
                                    </Typography>
                                </Tooltip>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '4px', minHeight: '26px' }}>
                                    <FilterListIcon sx={{ fontSize: '15px', color: accent, mt: '4px' }} />
                                    {/* fixed-width slot — width never changes; symbols wrap to a new line. */}
                                    <Box sx={{ width: 96, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px 6px', pt: '2px' }}>
                                        {on ? (
                                            sym.map((s) => (
                                                <Box key={s.k} component="span" sx={{ color: s.c, fontWeight: 800, fontSize: '14px', lineHeight: 1, display: 'inline-flex', alignItems: 'center', gap: '2px' }}>
                                                    {s.el}
                                                </Box>
                                            ))
                                        ) : (<>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 600, lineHeight: 1.1, whiteSpace: 'nowrap', color: theme.palette.text.primary, mt: '2px' }}>Click a button</Typography>
                                            <KeyboardArrowRightIcon sx={{ fontSize: '18px', color: accent }} />
                                        </>)}
                                    </Box>
                                </Box>
                            </>);
                        })()}
                    </Box>

                    </Box>
                    {/* ── end pinned cluster ── */}

                    {/* ── SENTIMENT ─────────────────────────────────────────── */}
                    {viewConfig?.sentiment && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Emotional Sentiment</Typography>
                            <Stack direction={isVertical ? 'column' : 'row'} spacing={0.5}>
                                {[
                                    { key: 'positive', label: '+ Positive', color: theme.palette.success.main },
                                    { key: 'neutral',  label: '= Neutral',  color: theme.palette.text.secondary },
                                    { key: 'negative', label: '− Negative', color: theme.palette.error.main },
                                ].map(({ key, label, color }) => (
                                    <Tooltip key={key} title={sentiments[key] ? `Hide ${label.slice(2).toLowerCase()} clips` : `Show ${label.slice(2).toLowerCase()} clips`} placement="bottom">
                                        <Button
                                            size="small"
                                            variant={sentiments[key] ? 'contained' : 'outlined'}
                                            onClick={() => handleButtonClick(() => onSentimentChange({ target: { value: key } }))}
                                            sx={{
                                                fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                borderColor: sentiments[key] ? color : alpha(color, 0.5),
                                                color: sentiments[key] ? '#fff' : color,
                                                backgroundColor: sentiments[key] ? color : 'transparent',
                                                '&:hover': { backgroundColor: alpha(color, 0.15), borderColor: color },
                                            }}
                                        >
                                            {label}
                                        </Button>
                                    </Tooltip>
                                ))}
                            </Stack>
                        </Box>
                    )}

                    {/* ── SPEAKER ────────────────────────────────────────────── */}
                    {viewConfig?.speaker && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Speaker</Typography>
                            <Stack direction={isVertical ? 'column' : 'row'} spacing={0.5}>
                                {Object.keys(speakers).map((speaker) => {
                                    // If this letter was renamed (speakerNames[letter], e.g. E→"Mitchel"),
                                    // peek the name in the hover tooltip so the button stays a compact
                                    // letter but you can still see who it is: "Hide Mitchel (E)".
                                    const spkName = speakerNames && speakerNames[speaker];
                                    const spkLabel = spkName ? `${spkName} (${speaker})` : `Speaker ${speaker}`;
                                    return (
                                    <Tooltip key={speaker} title={speakers[speaker] ? `Hide ${spkLabel}` : `Show ${spkLabel}`} placement="bottom">
                                        <Button
                                            size="small"
                                            variant={speakers[speaker] ? 'contained' : 'outlined'}
                                            onClick={() => handleButtonClick(() => onSpeakerChange({ target: { value: speaker } }))}
                                            sx={{
                                                fontSize: '11px', padding: '1px 5px', minWidth: '22px', height: '26px', textTransform: 'none', fontWeight: 700,
                                                borderColor: speakers[speaker] ? '#00897B' : theme.palette.text.disabled,
                                                color: speakers[speaker] ? '#fff' : theme.palette.text.secondary,
                                                backgroundColor: speakers[speaker] ? '#00897B' : 'transparent',
                                                '&:hover': { backgroundColor: speakers[speaker] ? '#00796B' : alpha('#00897B', 0.08), borderColor: '#00897B' },
                                            }}
                                        >
                                            {speaker}
                                        </Button>
                                    </Tooltip>
                                    );
                                })}
                            </Stack>
                        </Box>
                    )}

                    <GDivider />

                    {/* ── CLIP TIME (before Length) ──────────────────────────── */}
                    {viewConfig?.seconds && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Time</Typography>
                            <Tooltip title={`Filter by clip duration (${secondsValues[0]}s–${secondsValues[1]}s) — click to set range`} placement="bottom">
                                <Button size="small" variant="outlined" onClick={() => setActiveModal('Seconds')}
                                    sx={{ fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none', gap: '3px',
                                        borderColor: theme.palette.warning.main, color: theme.palette.warning.main,
                                        '&:hover': { backgroundColor: alpha(theme.palette.warning.main, 0.1) } }}>
                                    <WatchLaterIcon sx={{ fontSize: '11px' }} /> Clip Time
                                </Button>
                            </Tooltip>
                        </Box>
                    )}

                    {/* ── WORD LENGTH ────────────────────────────────────────── */}
                    {viewConfig?.length && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Length</Typography>
                            <Tooltip title={`Filter by character count (${textLen[0]}–${textLen[1]} chars) — click to set range`} placement="bottom">
                                <Button size="small" variant="outlined" onClick={() => setActiveModal('Length')}
                                    sx={{ fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none', gap: '3px',
                                        borderColor: '#009688', color: '#009688',
                                        '&:hover': { backgroundColor: alpha('#009688', 0.1) } }}>
                                    <NumbersIcon sx={{ fontSize: '11px' }} /> Length
                                </Button>
                            </Tooltip>
                        </Box>
                    )}

                    <GDivider />

                    {/* ── BUFFERS (silent gap clips) ───────────────────────── */}
                    {viewConfig?.spaces && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Silences</Typography>
                            {onSpacesModeChange ? (
                                <Stack direction={isVertical ? 'column' : 'row'} spacing={0.5}>
                                    {[
                                        { key: 'show', label: 'Show', tooltip: 'Include silent buffer clips in the list' },
                                        { key: 'hide', label: 'Hide', tooltip: 'Hide silent buffer clips (default)' },
                                        { key: 'only', label: 'Only', tooltip: 'Show only silent buffer clips' },
                                    ].map(({ key, label, tooltip }) => (
                                        <Tooltip key={key} title={tooltip} placement="bottom">
                                            <Button size="small"
                                                variant={spacesMode === key ? 'contained' : 'outlined'}
                                                onClick={() => onSpacesModeChange(key)}
                                                sx={{ fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                    borderColor: spacesMode === key ? '#3949ab' : alpha('#5c6bc0', 0.55),
                                                    color: spacesMode === key ? '#fff' : '#5c6bc0',
                                                    backgroundColor: spacesMode === key ? '#3949ab' : 'transparent',
                                                    '&:hover': { backgroundColor: alpha('#5c6bc0', 0.1) } }}>
                                                {label}
                                            </Button>
                                        </Tooltip>
                                    ))}
                                </Stack>
                            ) : (
                                <Tooltip title={spacesOnOff ? 'Hide spaces' : 'Show spaces'} placement="bottom">
                                    <Button size="small" variant={spacesOnOff ? 'contained' : 'outlined'}
                                        onClick={() => handleButtonClick(onSetSpaces)}
                                        sx={{ fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                            borderColor: '#5c6bc0', color: spacesOnOff ? '#fff' : '#5c6bc0',
                                            backgroundColor: spacesOnOff ? '#3949ab' : 'transparent',
                                            '&:hover': { backgroundColor: alpha('#5c6bc0', 0.1) } }}>
                                        {spacesOnOff ? 'Showing' : 'Hidden'}
                                    </Button>
                                </Tooltip>
                            )}
                        </Box>
                    )}

                    {/* ── FIND — Browse A–Z + Search ────────────────────────── */}
                    {((onQuickFilterChange && (availableFirstLetters.length > 0 || availableDurations.length > 0)) || viewConfig?.search) && (
                        <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Find
                            </Typography>
                            <Stack direction={isVertical ? "column" : "row"} spacing={0.5} alignItems="center">
                                {onQuickFilterChange && (availableFirstLetters.length > 0 || availableDurations.length > 0) && (
                                    <ClickAwayListener onClickAway={() => setFilterPopoverAnchor(null)}>
                                        <Box>
                                            <Tooltip title="Filter by first letter or clip duration" placement="bottom">
                                                <Button size="small"
                                                    variant={(quickFilters.firstLetter || quickFilters.durationSec !== null) ? 'contained' : 'outlined'}
                                                    onClick={(e) => setFilterPopoverAnchor(filterPopoverOpen ? null : e.currentTarget)}
                                                    sx={{ fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                        borderColor: (quickFilters.firstLetter || quickFilters.durationSec !== null) ? theme.palette.info.main : alpha(theme.palette.info.main, 0.5),
                                                        color: (quickFilters.firstLetter || quickFilters.durationSec !== null) ? '#fff' : theme.palette.info.main,
                                                        backgroundColor: (quickFilters.firstLetter || quickFilters.durationSec !== null) ? theme.palette.info.main : 'transparent',
                                                        '&:hover': { borderColor: theme.palette.info.main, backgroundColor: alpha(theme.palette.info.main, 0.1) } }}>
                                                    {quickFilters.firstLetter ? `"${quickFilters.firstLetter}"` : quickFilters.durationSec !== null ? `${quickFilters.durationSec === 10 ? '10s+' : `${quickFilters.durationSec}s`}` : 'A–Z / 0s'}
                                                </Button>
                                            </Tooltip>
                                            <Popper open={filterPopoverOpen} anchorEl={filterPopoverAnchor} placement="bottom-start" style={{ zIndex: 1500 }}>
                                                <Paper elevation={4} sx={{ p: 1.5, maxWidth: 280, backgroundColor: theme.palette.background.paper }}>
                                                    {availableFirstLetters.length > 0 && (
                                                        <Box sx={{ mb: 1 }}>
                                                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5 }}>Starts With</Typography>
                                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
                                                                {availableFirstLetters.map((letter) => (
                                                                    <Button key={letter} size="small"
                                                                        variant={quickFilters.firstLetter === letter ? 'contained' : 'outlined'}
                                                                        onClick={() => onQuickFilterChange('firstLetter', letter)}
                                                                        sx={{ fontSize: '10px', padding: '0px 4px', minWidth: '22px', height: '20px', textTransform: 'none',
                                                                            borderColor: quickFilters.firstLetter === letter ? theme.palette.info.main : theme.palette.text.disabled,
                                                                            color: quickFilters.firstLetter === letter ? '#fff' : theme.palette.text.secondary,
                                                                            backgroundColor: quickFilters.firstLetter === letter ? theme.palette.info.main : 'transparent',
                                                                            '&:hover': { borderColor: theme.palette.info.main, backgroundColor: alpha(theme.palette.info.main, 0.1) } }}>
                                                                        {letter}
                                                                    </Button>
                                                                ))}
                                                            </Box>
                                                        </Box>
                                                    )}
                                                    {availableDurations.length > 0 && (
                                                        <Box>
                                                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5 }}>Duration</Typography>
                                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
                                                                {availableDurations.map((sec) => (
                                                                    <Button key={sec} size="small"
                                                                        variant={quickFilters.durationSec === sec ? 'contained' : 'outlined'}
                                                                        onClick={() => onQuickFilterChange('durationSec', sec)}
                                                                        sx={{ fontSize: '10px', padding: '0px 5px', minWidth: 'unset', height: '20px', textTransform: 'none',
                                                                            borderColor: quickFilters.durationSec === sec ? theme.palette.secondary.main : theme.palette.text.disabled,
                                                                            color: quickFilters.durationSec === sec ? '#fff' : theme.palette.text.secondary,
                                                                            backgroundColor: quickFilters.durationSec === sec ? theme.palette.secondary.main : 'transparent',
                                                                            '&:hover': { borderColor: theme.palette.secondary.main, backgroundColor: alpha(theme.palette.secondary.main, 0.1) } }}>
                                                                        {sec === 10 ? '10s+' : `${sec}s`}
                                                                    </Button>
                                                                ))}
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Paper>
                                            </Popper>
                                        </Box>
                                    </ClickAwayListener>
                                )}
                                {viewConfig?.search && (
                                    <Tooltip title={activeModal === 'Search' ? "Close search" : store.getSearch(currentView) !== "" ? `Searching: "${store.getSearch(currentView)}"` : "Search transcript text"} placement="bottom">
                                        <Button size="small"
                                            variant="contained"
                                            onClick={handleSearchClick}
                                            sx={{ fontSize: '11px', padding: '3px 14px', minWidth: 'unset', height: '26px', textTransform: 'none', gap: '4px',
                                                borderColor: theme.palette.info.main,
                                                color: '#fff',
                                                backgroundColor: activeModal === 'Search' || store.getSearch(currentView) !== "" ? theme.palette.info.main : alpha(theme.palette.info.main, 0.35),
                                                boxShadow: 'none',
                                                '&:hover': { backgroundColor: theme.palette.info.main, boxShadow: 'none' } }}>
                                            <SearchIcon sx={{ fontSize: '14px' }} />
                                            {store.getSearch(currentView) !== "" ? `"${store.getSearch(currentView).substring(0, 12)}${store.getSearch(currentView).length > 12 ? '…' : ''}"` : 'Search'}
                                        </Button>
                                    </Tooltip>
                                )}
                            </Stack>
                        </Box>
                    )}

                    {/* ── CONTENT FILTERS — questions + numbers ────────────── */}
                    {onQuickFilterChange && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ visibility: 'hidden', display: 'block', mb: 0.5, fontSize: '9px' }}>·</Typography>
                            <Stack direction={isVertical ? "column" : "row"} spacing={0.5} alignItems="center" flexWrap="nowrap">
                                {[
                                    { key: 'hasQuestion',     symbol: '?', label: 'Questions', active: quickFilters.hasQuestion,     color: theme.palette.info.main },
                                    { key: 'containsNumbers', symbol: '#', label: 'Numbers',   active: quickFilters.containsNumbers, color: theme.palette.warning.main },
                                ].map(({ key, symbol, label, active, color }) => {
                                    const isHovered = hoveredShow === key;
                                    return (
                                        <Button key={key} size="small" variant={active ? 'contained' : 'outlined'}
                                            onClick={() => onQuickFilterChange(key)}
                                            onMouseEnter={() => setHoveredShow(key)}
                                            onMouseLeave={() => setHoveredShow(null)}
                                            sx={{
                                                fontSize: '11px', fontWeight: 700, padding: '1px 7px', height: '26px', textTransform: 'none',
                                                minWidth: 0, overflow: 'hidden', justifyContent: 'flex-start',
                                                borderColor: color, color: active ? '#fff' : color,
                                                backgroundColor: active ? color : 'transparent',
                                                transition: 'background-color 0.15s ease',
                                                '&:hover': { backgroundColor: active ? color : alpha(color, 0.1) },
                                            }}>
                                            {symbol}
                                            <span style={{
                                                maxWidth: isHovered ? '70px' : 0, opacity: isHovered ? 1 : 0,
                                                overflow: 'hidden', whiteSpace: 'nowrap', fontWeight: 400, fontSize: '10px',
                                                marginLeft: isHovered ? '5px' : 0,
                                                transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
                                            }}>{label}</span>
                                        </Button>
                                    );
                                })}
                            </Stack>
                        </Box>
                    )}

                    {/* ── SHOW — selected filter + pin to top ──────────────── */}
                    {(onQuickFilterChange || onPinSelectedToTop) && (
                        <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Show
                            </Typography>
                            <Stack direction={isVertical ? "column" : "row"} spacing={0.5} alignItems="center" flexWrap="nowrap">
                                {onQuickFilterChange && (() => {
                                    const key = 'selectedOnly';
                                    const active = quickFilters.selectedOnly;
                                    const color = theme.palette.success.main;
                                    const isHovered = hoveredShow === key;
                                    return (
                                        <Button key={key} size="small" variant={active ? 'contained' : 'outlined'}
                                            onClick={() => onQuickFilterChange(key)}
                                            onMouseEnter={() => setHoveredShow(key)}
                                            onMouseLeave={() => setHoveredShow(null)}
                                            sx={{
                                                fontSize: '11px', fontWeight: 700, padding: '1px 7px', height: '26px', textTransform: 'none',
                                                minWidth: 0, overflow: 'hidden', justifyContent: 'flex-start',
                                                borderColor: color, color: active ? '#fff' : color,
                                                backgroundColor: active ? color : 'transparent',
                                                transition: 'background-color 0.15s ease',
                                                '&:hover': { backgroundColor: active ? color : alpha(color, 0.1) },
                                            }}>
                                            ✓
                                            <span style={{
                                                maxWidth: isHovered ? '70px' : 0, opacity: isHovered ? 1 : 0,
                                                overflow: 'hidden', whiteSpace: 'nowrap', fontWeight: 400, fontSize: '10px',
                                                marginLeft: isHovered ? '5px' : 0,
                                                transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
                                            }}>Selected</span>
                                        </Button>
                                    );
                                })()}
                                {onPinSelectedToTop && onQuickFilterChange && (
                                    <Tooltip title={selectedCount > 0 ? `Pin ${selectedCount} selected clip${selectedCount !== 1 ? 's' : ''} to top in pick order` : "Select clips first, then pin them to the top"} placement="bottom">
                                        <span
                                            onMouseEnter={() => setHoveredMark('pin')}
                                            onMouseLeave={() => setHoveredMark(null)}
                                        >
                                            <Button size="small" variant="outlined"
                                                onClick={selectedCount > 0 ? onPinSelectedToTop : undefined}
                                                disabled={selectedCount === 0}
                                                sx={{ fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none',
                                                    overflow: 'hidden', justifyContent: 'flex-start', pointerEvents: selectedCount === 0 ? 'none' : 'auto',
                                                    borderColor: selectedCount > 0 ? theme.palette.warning.main : theme.palette.text.disabled,
                                                    color: selectedCount > 0 ? theme.palette.warning.main : theme.palette.text.disabled,
                                                    backgroundColor: 'transparent',
                                                    '&:hover': { backgroundColor: selectedCount > 0 ? alpha(theme.palette.warning.main, 0.1) : 'transparent' },
                                                    '&.Mui-disabled': { borderColor: theme.palette.text.disabled, color: theme.palette.text.disabled } }}>
                                                <PushPinIcon sx={{ fontSize: '11px' }} />
                                                <span style={{
                                                    maxWidth: hoveredMark === 'pin' ? '70px' : 0, opacity: hoveredMark === 'pin' ? 1 : 0,
                                                    overflow: 'hidden', whiteSpace: 'nowrap', fontSize: '10px', fontWeight: 400,
                                                    marginLeft: hoveredMark === 'pin' ? '5px' : 0,
                                                    transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
                                                }}>Pin to Top</span>
                                            </Button>
                                        </span>
                                    </Tooltip>
                                )}
                            </Stack>
                        </Box>
                    )}

                    {/* ── AI FILTERS — unified popover ───────────────────────── */}
                    {(() => {
                        const fmt = (s) => s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
                        const activeEntityTypes = quickFilters.entityTypes || [];
                        const activeContentFlags = quickFilters.contentFlags || [];
                        const activeKeyPhrases = quickFilters.keyPhrases || [];
                        const activeVerbs = quickFilters.filterVerbs || [];
                        const activeNouns = quickFilters.filterNouns || [];
                        const activeAdjectives = quickFilters.filterAdjectives || [];
                        const totalActive = activeEntityTypes.length + activeContentFlags.length + activeKeyPhrases.length + activeVerbs.length + activeNouns.length + activeAdjectives.length;
                        const hasAnyData = availableEntityTypes.length > 0 || availableContentFlags.length > 0 || availableKeyPhrases.length > 0 || availableVerbs.length > 0 || availableNouns.length > 0 || availableAdjectives.length > 0;
                        if (!hasAnyData) return null;
                        const FilterSection = ({ label, items, activeItems, filterKey, color }) => {
                            if (!items.length) return null;
                            return (
                                <Box sx={{ mb: 1 }}>
                                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', mb: 0.5 }}>{label}</Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
                                        {items.map((item) => {
                                            const active = activeItems.includes(item);
                                            return (
                                                <Button key={item} size="small"
                                                    variant={active ? 'contained' : 'outlined'}
                                                    onClick={() => onQuickFilterChange(filterKey, item)}
                                                    sx={{ fontSize: '10px', padding: '1px 7px', minWidth: 'unset', height: '22px', textTransform: 'none',
                                                        borderColor: active ? color : alpha(color, 0.45),
                                                        color: active ? '#fff' : color,
                                                        backgroundColor: active ? color : 'transparent',
                                                        '&:hover': { borderColor: color, backgroundColor: alpha(color, 0.1) } }}>
                                                    {fmt(item)}
                                                </Button>
                                            );
                                        })}
                                    </Box>
                                </Box>
                            );
                        };
                        return (
                            <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>AI Filters</Typography>
                                <ClickAwayListener onClickAway={() => setAiFiltersAnchor(null)}>
                                    <Box>
                                        <Tooltip title={totalActive > 0 ? `${totalActive} active filter${totalActive > 1 ? 's' : ''}` : 'Filter by entities, phrases, keywords'} placement="bottom">
                                            <Button size="small"
                                                ref={aiFiltersAnchorRef}
                                                variant="contained"
                                                onClick={(e) => { setAiFiltersCentered(false); setAiFiltersAnchor(aiFiltersOpen ? null : e.currentTarget); }}
                                                sx={{ fontSize: '10px', padding: '1px 8px', minWidth: 'unset', height: '26px', textTransform: 'none', gap: '3px',
                                                    background: totalActive > 0
                                                        ? 'linear-gradient(135deg, #e53935 0%, #c62828 100%)'
                                                        : 'linear-gradient(135deg, #424242 0%, #212121 100%)',
                                                    color: '#fff',
                                                    border: totalActive > 0 ? '1px solid #ef5350' : '1px solid #616161',
                                                    boxShadow: totalActive > 0 ? '0 0 6px rgba(229,57,53,0.5)' : 'none',
                                                    '&:hover': { opacity: 0.9, boxShadow: totalActive > 0 ? '0 0 10px rgba(229,57,53,0.7)' : '0 0 4px rgba(255,255,255,0.2)' } }}>
                                                <AutoFixHighIcon sx={{ fontSize: '12px' }} />
                                                {totalActive > 0 ? `${totalActive} filter${totalActive > 1 ? 's' : ''}` : 'AI Filters'} <KeyboardArrowDownIcon sx={{ fontSize: '11px' }} />
                                            </Button>
                                        </Tooltip>
                                        <Popper open={aiFiltersOpen} anchorEl={aiFiltersCentered ? centerAnchor : aiFiltersAnchor} placement={aiFiltersCentered ? "bottom" : "bottom-start"} style={{ zIndex: 1500 }}>
                                            <Paper elevation={4} sx={{ p: 1.5, maxWidth: 300, maxHeight: 400, overflowY: 'auto', backgroundColor: theme.palette.background.paper }}>
                                                <FilterSection label="Entity Types" items={availableEntityTypes} activeItems={activeEntityTypes} filterKey="entityType" color="#00897b" />
                                                <FilterSection label="Content Flags" items={availableContentFlags} activeItems={activeContentFlags} filterKey="contentFlag" color={theme.palette.error.main} />
                                                <FilterSection label="Key Phrases" items={availableKeyPhrases} activeItems={activeKeyPhrases} filterKey="keyPhrase" color="#0288d1" />
                                                <FilterSection label="Verbs" items={availableVerbs} activeItems={activeVerbs} filterKey="filterVerb" color="#558b2f" />
                                                <FilterSection label="Adjectives" items={availableAdjectives} activeItems={activeAdjectives} filterKey="filterAdjective" color="#f57c00" />
                                                <FilterSection label="Nouns" items={availableNouns} activeItems={activeNouns} filterKey="filterNoun" color="#546e7a" />
                                            </Paper>
                                        </Popper>
                                    </Box>
                                </ClickAwayListener>
                            </Box>
                        );
                    })()}
                    {/* ── FILLER — AI fades the throwaway lines so the gold shines ─── */}
                    {onApplyFiller && viewConfig?.createVideo && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Filler</Typography>
                            <Stack direction={isVertical ? 'column' : 'row'} spacing={0.5} alignItems="center">
                                {/* No re-scan once done — filler doesn't change, so hide the button and keep the real estate. */}
                                {!fillerDone && (
                                    <Tooltip title={'AI marks the throwaway lines (ums, run-up, rambling) so your best clips stand out'} placement="bottom">
                                        <span>
                                            <Button size="small" variant="contained" disabled={fillerLoading}
                                                onClick={handleFindFiller}
                                                startIcon={fillerLoading ? <CircularProgress size={11} sx={{ color: '#e6326b' }} /> : <AutoFixHighIcon sx={{ fontSize: '11px' }} />}
                                                sx={{ fontSize: '10px', padding: '1px 8px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                    borderColor: '#e6326b', color: '#fff', backgroundColor: '#e6326b',
                                                    '&:hover': { backgroundColor: '#c81e57' } }}>
                                                {fillerLoading ? 'Scanning…' : 'Find filler'}
                                            </Button>
                                        </span>
                                    </Tooltip>
                                )}
                                {fillerDone && onFillerModeChange && [
                                    { key: 'dim', label: 'Dim', tooltip: 'Fade the filler — your keepers shine and grow' },
                                    { key: 'hide', label: 'Hide', tooltip: 'Remove the filler clips from the list' },
                                    { key: 'only', label: 'Only', tooltip: 'Show ONLY the filler — a filler montage' },
                                ].map(({ key, label, tooltip }) => (
                                    <Tooltip key={key} title={tooltip} placement="bottom">
                                        <Button size="small"
                                            variant={fillerMode === key ? 'contained' : 'outlined'}
                                            onClick={() => onFillerModeChange(key)}
                                            sx={{ fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                borderColor: fillerMode === key ? '#e6326b' : alpha('#e6326b', 0.55),
                                                color: fillerMode === key ? '#fff' : '#e6326b',
                                                backgroundColor: fillerMode === key ? '#e6326b' : 'transparent',
                                                '&:hover': { backgroundColor: alpha('#e6326b', 0.1) } }}>
                                            {label}
                                        </Button>
                                    </Tooltip>
                                ))}
                            </Stack>
                        </Box>
                    )}

                    {/* ── VIRALITY — AI scores each clip 0–100 and sorts most-viral first ── */}
                    {onApplyVirality && viewConfig?.createVideo && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Virality</Typography>
                            <Stack direction={isVertical ? 'column' : 'row'} spacing={0.5} alignItems="center">
                                {/* No re-score once done — scores don't change, so hide the button and keep the real estate. */}
                                {!viralityDone && (
                                    <Tooltip title={'AI scores every clip 0–100 for shareability, then sorts the most viral to the top'} placement="bottom">
                                        <span>
                                            <Button size="small" variant="contained" disabled={viralityLoading}
                                                onClick={handleScoreVirality}
                                                startIcon={viralityLoading ? <CircularProgress size={11} sx={{ color: '#f59e0b' }} /> : <AutoFixHighIcon sx={{ fontSize: '11px' }} />}
                                                sx={{ fontSize: '10px', padding: '1px 8px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                    borderColor: '#f59e0b', color: '#1a1a1a', backgroundColor: '#f59e0b',
                                                    '&:hover': { backgroundColor: '#d98806' } }}>
                                                {viralityLoading ? 'Scoring…' : 'Score virality'}
                                            </Button>
                                        </span>
                                    </Tooltip>
                                )}
                                {viralityDone && onSortVirality && (
                                    <Tooltip title="Re-sort by virality (high → low)" placement="bottom">
                                        <Button size="small" variant="outlined" onClick={onSortVirality}
                                            sx={{ fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                borderColor: alpha('#f59e0b', 0.55), color: '#f59e0b',
                                                '&:hover': { backgroundColor: alpha('#f59e0b', 0.1) } }}>
                                            🔥 Sort
                                        </Button>
                                    </Tooltip>
                                )}
                                {viralityDone && onViralityRangeChange && (() => {
                                    const vOn = viralityRange[0] > 0 || viralityRange[1] < 100;
                                    return (
                                        <Tooltip title={`Filter by score (${viralityRange[0]}–${viralityRange[1]}) — click to set range`} placement="bottom">
                                            <Button size="small" variant={vOn ? 'contained' : 'outlined'} onClick={() => setActiveModal('Virality')}
                                                sx={{ fontSize: '10px', padding: '1px 6px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                    borderColor: '#f59e0b', color: vOn ? '#1a1a1a' : '#f59e0b',
                                                    backgroundColor: vOn ? '#f59e0b' : 'transparent',
                                                    '&:hover': { backgroundColor: vOn ? '#d98806' : alpha('#f59e0b', 0.1) } }}>
                                                {vOn ? `${viralityRange[0]}–${viralityRange[1]}` : 'Range'}
                                            </Button>
                                        </Tooltip>
                                    );
                                })()}
                            </Stack>
                        </Box>
                    )}


                    {/* ── RESET ────────────────────────────────────────────── */}
                    {viewConfig?.resetFilters && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>History</Typography>
                            <Tooltip title="Clear all filters, search, and sorting" placement="bottom">
                                <Button size="small" variant="contained" onClick={handleResetClick}
                                    sx={{ fontSize: '11px', padding: '3px 10px', minWidth: 'unset', height: '26px', textTransform: 'none', gap: '4px',
                                        backgroundColor: theme.palette.error.main, color: '#fff',
                                        '&:hover': { backgroundColor: theme.palette.error.dark } }}>
                                    <RestartAltIcon sx={{ fontSize: '14px' }} /> Reset All
                                </Button>
                            </Tooltip>
                        </Box>
                    )}

                    <GDivider />

                    {/* ── MARK — pen + edit tools ───────────────────────────── */}
                    {(onPenModeChange || onEditModeChange || onPlayNextChange) && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Mark</Typography>
                            <Stack direction="row" spacing={0.5}>
                                {onPenModeChange && (
                                    <Tooltip title={penMode ? 'Pen mode ON — drag across words to highlight, click highlighted word to clear' : 'Enable pen mode to highlight specific words within clips'} placement="bottom">
                                        <Button size="small" variant={penMode ? 'contained' : 'outlined'} onClick={onPenModeChange}
                                            onMouseEnter={() => setHoveredMark('pen')}
                                            onMouseLeave={() => setHoveredMark(null)}
                                            sx={{
                                                fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none',
                                                overflow: 'hidden', justifyContent: 'flex-start',
                                                borderColor: penMode ? '#F59E0B' : alpha('#F59E0B', 0.5),
                                                color: penMode ? '#fff' : '#F59E0B',
                                                backgroundColor: penMode ? '#F59E0B' : 'transparent',
                                                '&:hover': { backgroundColor: penMode ? '#D97706' : alpha('#F59E0B', 0.1), borderColor: '#F59E0B' },
                                            }}>
                                            <AutoFixHighIcon sx={{ fontSize: '11px' }} />
                                            <span style={{
                                                maxWidth: hoveredMark === 'pen' ? '40px' : 0, opacity: hoveredMark === 'pen' ? 1 : 0,
                                                overflow: 'hidden', whiteSpace: 'nowrap', fontSize: '10px', fontWeight: 400,
                                                marginLeft: hoveredMark === 'pen' ? '5px' : 0,
                                                transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
                                            }}>Pen</span>
                                        </Button>
                                    </Tooltip>
                                )}
                                {onEditModeChange && (
                                    <Tooltip title={editMode ? 'Edit mode ON — click pencil icons to edit transcript text' : 'Enable edit mode to show pencil buttons on each clip'} placement="bottom">
                                        <Button size="small" variant={editMode ? 'contained' : 'outlined'} onClick={onEditModeChange}
                                            onMouseEnter={() => setHoveredMark('edit')}
                                            onMouseLeave={() => setHoveredMark(null)}
                                            sx={{
                                                fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none',
                                                overflow: 'hidden', justifyContent: 'flex-start',
                                                borderColor: editMode ? '#26c6da' : alpha('#26c6da', 0.5),
                                                color: editMode ? '#fff' : '#26c6da',
                                                backgroundColor: editMode ? '#26c6da' : 'transparent',
                                                '&:hover': { backgroundColor: editMode ? '#00acc1' : alpha('#26c6da', 0.1), borderColor: '#26c6da' },
                                            }}>
                                            <EditNoteIcon sx={{ fontSize: '13px' }} />
                                            <span style={{
                                                maxWidth: hoveredMark === 'edit' ? '40px' : 0, opacity: hoveredMark === 'edit' ? 1 : 0,
                                                overflow: 'hidden', whiteSpace: 'nowrap', fontSize: '10px', fontWeight: 400,
                                                marginLeft: hoveredMark === 'edit' ? '5px' : 0,
                                                transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
                                            }}>Edit</span>
                                        </Button>
                                    </Tooltip>
                                )}
                                {onPlayNextChange && (
                                    <Tooltip title={playNext ? 'Play Next ON — clips play one after another automatically' : 'Enable Play Next to auto-advance through clips'} placement="bottom">
                                        <Button size="small" variant={playNext ? 'contained' : 'outlined'} onClick={onPlayNextChange}
                                            onMouseEnter={() => setHoveredMark('playnext')}
                                            onMouseLeave={() => setHoveredMark(null)}
                                            sx={{
                                                fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none',
                                                overflow: 'hidden', justifyContent: 'flex-start',
                                                borderColor: playNext ? '#4ade80' : alpha('#4ade80', 0.5),
                                                color: playNext ? '#fff' : '#4ade80',
                                                backgroundColor: playNext ? '#16a34a' : 'transparent',
                                                '&:hover': { backgroundColor: playNext ? '#15803d' : alpha('#4ade80', 0.1), borderColor: '#4ade80' },
                                            }}>
                                            <SkipNextIcon sx={{ fontSize: '13px' }} />
                                            <span style={{
                                                maxWidth: hoveredMark === 'playnext' ? '75px' : 0, opacity: hoveredMark === 'playnext' ? 1 : 0,
                                                overflow: 'hidden', whiteSpace: 'nowrap', fontSize: '10px', fontWeight: 400,
                                                marginLeft: hoveredMark === 'playnext' ? '5px' : 0,
                                                transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
                                            }}>Play Next</span>
                                        </Button>
                                    </Tooltip>
                                )}
                                {onPlayHighlightsChange && (
                                    <Tooltip title={playHighlightsOnly ? 'Playing HIGHLIGHTS ONLY — only pen-marked moments play (full clips if no mark). Click for full clips.' : 'Play only the pen-highlighted moments of each clip (instead of the whole clip)'} placement="bottom">
                                        <Button size="small" variant={playHighlightsOnly ? 'contained' : 'outlined'} onClick={onPlayHighlightsChange}
                                            onMouseEnter={() => setHoveredMark('hlonly')}
                                            onMouseLeave={() => setHoveredMark(null)}
                                            sx={{
                                                fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none',
                                                overflow: 'hidden', justifyContent: 'flex-start',
                                                borderColor: playHighlightsOnly ? '#f59e0b' : alpha('#f59e0b', 0.5),
                                                color: playHighlightsOnly ? '#fff' : '#f59e0b',
                                                backgroundColor: playHighlightsOnly ? '#d97706' : 'transparent',
                                                '&:hover': { backgroundColor: playHighlightsOnly ? '#b45309' : alpha('#f59e0b', 0.1), borderColor: '#f59e0b' },
                                            }}>
                                            <HighlightIcon sx={{ fontSize: '14px' }} />
                                            <span style={{
                                                maxWidth: hoveredMark === 'hlonly' ? '95px' : 0, opacity: hoveredMark === 'hlonly' ? 1 : 0,
                                                overflow: 'hidden', whiteSpace: 'nowrap', fontSize: '10px', fontWeight: 400,
                                                marginLeft: hoveredMark === 'hlonly' ? '5px' : 0,
                                                transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
                                            }}>Marks only</span>
                                        </Button>
                                    </Tooltip>
                                )}
                            </Stack>
                        </Box>
                    )}

                    <GDivider />

                    {/* ── SORT ──────────────────────────────────────────────── */}
                    {onSortOrderChange && (
                        <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Sort
                            </Typography>
                            <Stack direction={isVertical ? "column" : "row"} spacing={0.5} alignItems="flex-start" flexWrap="wrap">
                                {[
                                    { key: 'chronological', label: 'Chrono',   icon: <WatchLaterIcon sx={{ fontSize: '11px' }} />,   tip: 'Sort in the order clips appear in the original recording' },
                                    { key: 'alphabetical',  label: 'Alpha',    icon: <SortByAlphaIcon sx={{ fontSize: '11px' }} />,  tip: 'Sort alphabetically by the first word of each sentence' },
                                    { key: 'duration',      label: 'Duration', icon: <AccessTimeIcon sx={{ fontSize: '11px' }} />,   tip: 'Sort by how long each clip is (the Seconds column) — shortest first, or longest first' },
                                ].map(({ key, label, icon, tip }) => {
                                    const isActive = sortOrder?.field === key;
                                    const arrow = isActive ? (sortOrder.direction === 'asc' ? '↑' : '↓') : '';
                                    const isHoveredSort = hoveredSort === key;
                                    const showLabel = isHoveredSort || isActive;
                                    return (
                                        <Tooltip key={key} title={isActive ? `Currently sorted ${sortOrder.direction === 'asc' ? 'A→Z / short→long' : 'Z→A / long→short'} — click to reverse` : tip} placement="bottom">
                                            <Button size="small" variant={isActive ? 'contained' : 'outlined'}
                                                onClick={() => onSortOrderChange(key)}
                                                onMouseEnter={() => setHoveredSort(key)}
                                                onMouseLeave={() => setHoveredSort(null)}
                                                sx={{ fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none',
                                                    overflow: 'hidden', justifyContent: 'flex-start',
                                                    borderColor: isActive ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.4),
                                                    color: isActive ? '#fff' : theme.palette.primary.main,
                                                    backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
                                                    transition: 'background-color 0.15s ease',
                                                    '&:hover': { borderColor: theme.palette.primary.main, backgroundColor: isActive ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.1) } }}>
                                                {icon}
                                                <span style={{
                                                    maxWidth: showLabel ? '65px' : 0,
                                                    opacity: showLabel ? 1 : 0,
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    fontWeight: isActive ? 600 : 400,
                                                    fontSize: '10px',
                                                    marginLeft: showLabel ? '4px' : 0,
                                                    transition: 'max-width 0.45s cubic-bezier(0.4,0,0.2,1), opacity 0.35s ease-in-out, margin-left 0.45s cubic-bezier(0.4,0,0.2,1)',
                                                }}>{label}{arrow ? ` ${arrow}` : ''}</span>
                                            </Button>
                                        </Tooltip>
                                    );
                                })}
                            </Stack>
                        </Box>
                    )}

                    <GDivider />

                    {/* ── DISPLAY + VIEWS ───────────────────────────────────── */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Display</Typography>
                        <Stack direction={isVertical ? 'column' : 'row'} spacing={0.5} alignItems="center">
                            {onViewChange && (
                                <Tooltip title={`Current: ${currentView} — click to switch`} placement="bottom">
                                    <Button size="small" variant="outlined" onClick={() => setActiveModal('Views')}
                                        sx={{
                                            padding: '1px 4px', minWidth: 'unset', height: '26px', gap: '2px',
                                            borderColor: alpha(theme.palette.primary.main, 0.4), color: theme.palette.primary.main,
                                            '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.08), borderColor: theme.palette.primary.main },
                                        }}>
                                        <GridViewIcon sx={{ fontSize: '13px' }} />
                                        <KeyboardArrowDownIcon sx={{ fontSize: '13px' }} />
                                    </Button>
                                </Tooltip>
                            )}
                            {viewConfig?.subtitles && (
                                <Tooltip title={subtitlesEnabled ? 'Captions ON — click to turn off' : 'Captions OFF — click to turn on'} placement="bottom">
                                    <IconButton size="small" onClick={onSetResetSubtitles}
                                        sx={{ width: 26, height: 26, borderRadius: '4px', border: '1px solid',
                                            borderColor: subtitlesEnabled ? theme.palette.info.main : alpha(theme.palette.info.main, 0.4),
                                            color: subtitlesEnabled ? '#fff' : theme.palette.info.main,
                                            backgroundColor: subtitlesEnabled ? theme.palette.info.main : 'transparent',
                                            '&:hover': { backgroundColor: alpha(theme.palette.info.main, 0.15) } }}>
                                        {subtitlesEnabled ? <SubtitlesIcon sx={{ fontSize: '14px' }} /> : <SubtitlesOffIcon sx={{ fontSize: '14px' }} />}
                                    </IconButton>
                                </Tooltip>
                            )}
                            {viewConfig?.precision && (
                                <Tooltip title={precision ? 'Decimals ON — click to hide milliseconds' : 'Decimals OFF — click to show milliseconds'} placement="bottom">
                                    <IconButton size="small" onClick={onPrecisionChange}
                                        sx={{ width: 26, height: 26, borderRadius: '4px', border: '1px solid',
                                            borderColor: precision ? theme.palette.success.main : alpha(theme.palette.success.main, 0.4),
                                            color: precision ? '#fff' : theme.palette.success.main,
                                            backgroundColor: precision ? theme.palette.success.main : 'transparent',
                                            '&:hover': { backgroundColor: alpha(theme.palette.success.main, 0.15) } }}>
                                        <AccessTimeIcon sx={{ fontSize: '14px' }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {viewConfig?.videoWidth && (
                                <Tooltip title={`Video thumbnail size (${videoWidth}px) — click to resize`} placement="bottom">
                                    <IconButton size="small" onClick={() => setActiveModal('VideoWidth')}
                                        sx={{ width: 26, height: 26, borderRadius: '4px', border: '1px solid',
                                            borderColor: alpha(theme.palette.primary.main, 0.5), color: theme.palette.primary.main,
                                            '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.12) } }}>
                                        <AspectRatioIcon sx={{ fontSize: '14px' }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {onTranscriptStyleChange && (
                                <ClickAwayListener onClickAway={() => setTextStyleOpen(false)}>
                                    <Box>
                                        <Tooltip title={`Transcript font: ${currentSize}px ${currentFontKey}`} placement="bottom">
                                            <IconButton
                                                ref={textStyleAnchorRef}
                                                size="small"
                                                onClick={() => { setTextStyleCentered(false); setTextStyleOpen(v => !v); }}
                                                sx={{ width: 26, height: 26, borderRadius: '4px', border: '1px solid',
                                                    borderColor: textStyleOpen ? theme.palette.secondary.main : alpha(theme.palette.secondary.main, 0.45),
                                                    color: theme.palette.secondary.main,
                                                    '&:hover': { backgroundColor: alpha(theme.palette.secondary.main, 0.1) } }}>
                                                <MenuBookIcon sx={{ fontSize: '14px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Popper open={textStyleOpen} anchorEl={textStyleCentered ? centerAnchor : textStyleAnchorRef.current} placement={textStyleCentered ? "bottom" : "bottom-start"} style={{ zIndex: 1500 }}>
                                            <Paper elevation={6} sx={{ p: 2, width: 280, backgroundColor: theme.palette.background.paper, border: `1px solid ${theme.palette.divider}` }}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5, fontSize: '12px' }}>
                                                    Transcript Text Style
                                                </Typography>
                                                {/* Size slider */}
                                                <Box sx={{ mb: 2 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
                                                        <Typography variant="caption" sx={{ fontSize: '11px', fontWeight: 600 }}>Font size</Typography>
                                                        <Typography variant="caption" sx={{ fontSize: '11px', fontWeight: 700, color: theme.palette.secondary.main }}>{currentSize}px</Typography>
                                                    </Box>
                                                    <PanelSlider
                                                        value={currentSize}
                                                        onChange={(_, v) => onTranscriptStyleChange(prev => ({ ...prev, size: v }))}
                                                        min={12} max={28} step={1}
                                                        size="small"
                                                        marks={[{ value: 12, label: '12' }, { value: 16, label: '16' }, { value: 22, label: '22' }, { value: 28, label: '28' }]}
                                                        sx={{ color: theme.palette.secondary.main, '& .MuiSlider-thumb': { width: 14, height: 14 }, '& .MuiSlider-markLabel': { fontSize: '9px' } }}
                                                    />
                                                </Box>
                                                {/* Bold / Italic toggles */}
                                                <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                                                    <Box onClick={() => onTranscriptStyleChange(prev => ({ ...prev, bold: !prev?.bold }))}
                                                        sx={{ flex: 1, textAlign: 'center', cursor: 'pointer', py: 0.5, borderRadius: 1, fontWeight: 800, fontSize: '14px',
                                                            border: `1px solid ${transcriptStyle?.bold ? theme.palette.secondary.main : theme.palette.divider}`,
                                                            backgroundColor: transcriptStyle?.bold ? alpha(theme.palette.secondary.main, 0.15) : 'transparent',
                                                            color: theme.palette.text.primary, userSelect: 'none' }}>
                                                        B
                                                    </Box>
                                                    <Box onClick={() => onTranscriptStyleChange(prev => ({ ...prev, italic: !prev?.italic }))}
                                                        sx={{ flex: 1, textAlign: 'center', cursor: 'pointer', py: 0.5, borderRadius: 1, fontStyle: 'italic', fontWeight: 600, fontSize: '14px',
                                                            border: `1px solid ${transcriptStyle?.italic ? theme.palette.secondary.main : theme.palette.divider}`,
                                                            backgroundColor: transcriptStyle?.italic ? alpha(theme.palette.secondary.main, 0.15) : 'transparent',
                                                            color: theme.palette.text.primary, userSelect: 'none' }}>
                                                        I
                                                    </Box>
                                                </Box>
                                                {/* Font list grouped by category */}
                                                <Typography variant="caption" sx={{ fontSize: '11px', fontWeight: 600, display: 'block', mb: 0.5 }}>Font</Typography>
                                                <Box sx={{ maxHeight: 260, overflowY: 'auto', border: `1px solid ${theme.palette.divider}`, borderRadius: 1 }}>
                                                    {['Caption', 'Sans-Serif', 'Serif', 'Mono'].map(group => (
                                                        <Box key={group}>
                                                            <Typography variant="caption" sx={{ fontSize: '9px', color: theme.palette.text.secondary, textTransform: 'uppercase', letterSpacing: '0.5px', px: 1, py: 0.5, display: 'block', backgroundColor: theme.palette.action.hover }}>
                                                                {group}
                                                            </Typography>
                                                            {TRANSCRIPT_FONTS.filter(f => f.group === group).map(font => (
                                                                <Box key={font.key}
                                                                    onClick={() => onTranscriptStyleChange(prev => ({ ...prev, fontKey: font.key, fontCSS: font.css }))}
                                                                    sx={{ px: 1.5, py: 0.75, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                        backgroundColor: currentFontKey === font.key ? alpha(theme.palette.secondary.main, 0.15) : 'transparent',
                                                                        '&:hover': { backgroundColor: currentFontKey === font.key ? alpha(theme.palette.secondary.main, 0.2) : theme.palette.action.hover } }}>
                                                                    <Typography sx={{ fontSize: `${Math.min(currentSize, 18)}px`, fontFamily: font.css, lineHeight: 1.3, color: theme.palette.text.primary }}>
                                                                        {font.label}
                                                                    </Typography>
                                                                    {currentFontKey === font.key && (
                                                                        <CheckIcon sx={{ fontSize: '14px', color: theme.palette.secondary.main, flexShrink: 0 }} />
                                                                    )}
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Paper>
                                        </Popper>
                                    </Box>
                                </ClickAwayListener>
                            )}
                        </Stack>
                    </Box>

                    <GDivider />

                    {/* ── COLUMNS ───────────────────────────────────────────── */}
                    {onToggleColumnSet && (
                        <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Columns
                            </Typography>
                            {(() => {
                                const sets = ['standard','extended','media','cbd','ayy','pillars'];
                                const labels = { standard:'Standard', extended:'Entities', media:'Media', cbd:'Chachma·Bina·Daas', ayy:'Avraham·Yitzchak·Yaakov', pillars:'Torah·Avoda·Gimilat' };
                                const tips   = { standard:'Actions · Descriptions · Things + Q?', extended:'Entities · Highlights · Flags + Numbers', media:'Sound Effects · Visuals · Camera Shot', cbd:'Chachma · Bina · Daas', ayy:'Avraham · Yitzchak · Yaakov', pillars:'Torah · Avoda · Gimilat Hasidim' };
                                const idx    = sets.indexOf(columnSet);
                                const isStd  = columnSet === 'standard';
                                const nextLabel = labels[sets[(idx + 1) % sets.length]];
                                return (
                                    <Tooltip title={`Now: ${tips[columnSet]} — click to switch to ${nextLabel}`} placement="bottom">
                                        <Button size="small" variant={isStd ? 'outlined' : 'contained'}
                                            onClick={onToggleColumnSet}
                                            onMouseEnter={() => setHoveredTool('columns')}
                                            onMouseLeave={() => setHoveredTool(null)}
                                            sx={{ fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none', overflow: 'hidden', justifyContent: 'flex-start',
                                                borderColor: theme.palette.secondary.main,
                                                color: isStd ? theme.palette.secondary.main : '#fff',
                                                backgroundColor: isStd ? 'transparent' : theme.palette.secondary.main,
                                                '&:hover': { borderColor: theme.palette.secondary.main, backgroundColor: isStd ? alpha(theme.palette.secondary.main, 0.1) : theme.palette.secondary.dark } }}>
                                            <SwapHorizIcon sx={{ fontSize: '13px' }} />
                                            <span style={expandLabelSx('columns', 150)}>{labels[columnSet]}</span>
                                        </Button>
                                    </Tooltip>
                                );
                            })()}
                        </Box>
                    )}

                    {/* Mobile extra columns toggle — only on small screens */}
                    {onToggleMobileColumns && isMobile && (
                        <Box sx={{ minWidth: 10, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: -0.7, textAlign: 'left', fontSize: '9px' }}>
                                More
                            </Typography>
                            <Tooltip title={showExtraMobileColumns ? "Hide extra columns" : "Show extra columns"} placement="bottom">
                                <IconButton onClick={onToggleMobileColumns}
                                    sx={{ color: showExtraMobileColumns ? theme.palette.primary.main : theme.palette.text.disabled, padding: '4px' }}>
                                    <ViewWeekIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    <GDivider />

                    {/* ── HELP ──────────────────────────────────────────────── */}
                    <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Help
                        </Typography>
                        <Tooltip title="Open help & guide — what every button does, plus shortcuts" placement="bottom">
                            <Button size="small" variant="outlined" onClick={() => setShortcutsOpen(true)}
                                onMouseEnter={() => setHoveredTool('help')}
                                onMouseLeave={() => setHoveredTool(null)}
                                sx={{ fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none', overflow: 'hidden', justifyContent: 'flex-start',
                                    borderColor: alpha(theme.palette.secondary.main, 0.6), color: theme.palette.secondary.main,
                                    '&:hover': { borderColor: theme.palette.secondary.main, backgroundColor: alpha(theme.palette.secondary.main, 0.1) } }}>
                                <KeyboardIcon sx={{ fontSize: '13px' }} />
                                <span style={expandLabelSx('help', 70)}>Shortcuts</span>
                            </Button>
                        </Tooltip>
                    </Box>

                    {/* ── REGROUP ─────────────────────────────────────────── */}
                    {viewConfig?.regroup && onRegroupChange && (
                        <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>
                                Segment by
                            </Typography>
                            <ClickAwayListener onClickAway={() => setRegroupOpen(false)}>
                                <Box>
                                    <Tooltip title="Choose how the video is cut into clips — by sentence, word, custom merge, or fixed seconds" placement="bottom">
                                        <Button
                                            ref={regroupAnchorRef}
                                            onMouseDown={() => setRegroupCentered(false)}
                                            size="small"
                                            variant="contained"
                                            onClick={handleOpenRegroup}
                                            sx={{
                                                fontSize: '11px', padding: '3px 10px', minWidth: 'unset', height: '26px', textTransform: 'none', fontWeight: 600,
                                                backgroundColor: regroupParams ? '#f59e0b' : alpha('#f59e0b', 0.18),
                                                borderColor: '#f59e0b',
                                                color: regroupParams ? '#fff' : '#f59e0b',
                                                border: '1px solid',
                                                '&:hover': { backgroundColor: regroupParams ? '#d97706' : alpha('#f59e0b', 0.28) },
                                            }}
                                        >
                                            ⚙ {!regroupParams ? 'Sentences'
                                                : regroupParams.mode === 'word' ? 'Words'
                                                : regroupParams.mode === 'interval' ? `${regroupParams.interval}s`
                                                : 'Custom'}
                                        </Button>
                                    </Tooltip>
                                    <Popper open={regroupOpen} anchorEl={regroupCentered ? centerAnchor : regroupAnchorRef.current} placement={regroupCentered ? "bottom" : "bottom-start"} style={{ zIndex: 1500 }}>
                                        <Paper elevation={6} sx={{ p: regroupCentered ? 3.5 : 2.5, width: regroupCentered ? "min(94vw, 560px)" : 360, backgroundColor: theme.palette.background.paper, border: `1px solid ${theme.palette.divider}` }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: regroupCentered ? 1.5 : 0.75, fontSize: regroupCentered ? '17px' : '12px' }}>
                                                ⚙ Segments
                                            </Typography>

                                            {/* Top-level mode: Original / Custom / By seconds.
                                                'word' counts as Original (its sub-mode). */}
                                            {(() => {
                                              const isWord = regroupParams && regroupParams.mode === 'word';
                                              const activeMode = (!regroupParams || isWord) ? 'original'
                                                  : (regroupParams.mode === 'interval' ? 'interval' : 'custom');
                                              return (
                                                <Box sx={{ display: 'flex', gap: 0.5, mb: 1 }}>
                                                    {[
                                                        { key: 'original', label: 'Original' },
                                                        { key: 'custom', label: 'Custom' },
                                                        { key: 'interval', label: 'By seconds' },
                                                    ].map(({ key, label }) => {
                                                        const active = activeMode === key;
                                                        // 'custom' maps to the old 'merge' handler
                                                        const onClick = () => handleRegroupMode(key === 'custom' ? 'merge' : key);
                                                        return (
                                                            <Button key={key} size="small" onClick={onClick}
                                                                sx={{ flex: 1, fontSize: regroupCentered ? '14px' : '10px', height: regroupCentered ? '40px' : '24px', fontWeight: regroupCentered ? 700 : 500, textTransform: 'none', minWidth: 0, px: regroupCentered ? 1.5 : 0.5,
                                                                    backgroundColor: active ? '#f59e0b' : 'transparent',
                                                                    color: active ? '#fff' : '#f59e0b',
                                                                    border: `1px solid ${active ? '#f59e0b' : alpha('#f59e0b', 0.5)}`,
                                                                    '&:hover': { backgroundColor: active ? '#d97706' : alpha('#f59e0b', 0.1) } }}>
                                                                {label}
                                                            </Button>
                                                        );
                                                    })}
                                                </Box>
                                              );
                                            })()}

                                            {/* Original sub-toggle: Sentence by sentence vs Word by word */}
                                            {(!regroupParams || (regroupParams && regroupParams.mode === 'word')) && (
                                                <Box sx={{ display: 'flex', gap: 0.5, mb: 1.5 }}>
                                                    {[
                                                        { key: 'sentence', label: 'Sentence by sentence' },
                                                        { key: 'word', label: 'Word by word' },
                                                    ].map(({ key, label }) => {
                                                        const isWord = regroupParams && regroupParams.mode === 'word';
                                                        const active = (key === 'word') === !!isWord;
                                                        return (
                                                            <Button key={key} size="small" onClick={() => handleOriginalSub(key)}
                                                                sx={{ flex: 1, fontSize: regroupCentered ? '13px' : '9px', height: regroupCentered ? '36px' : '22px', fontWeight: regroupCentered ? 700 : 500, textTransform: 'none', minWidth: 0, px: regroupCentered ? 1.25 : 0.5,
                                                                    backgroundColor: active ? alpha('#f59e0b', 0.85) : 'transparent',
                                                                    color: active ? '#fff' : alpha('#f59e0b', 0.8),
                                                                    border: `1px solid ${active ? '#f59e0b' : alpha('#f59e0b', 0.35)}`,
                                                                    '&:hover': { backgroundColor: active ? '#d97706' : alpha('#f59e0b', 0.1) } }}>
                                                                {label}
                                                            </Button>
                                                        );
                                                    })}
                                                </Box>
                                            )}

                                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: selectedCount > 0 ? 1 : 2, fontSize: '10px', lineHeight: 1.5 }}>
                                                {!regroupParams
                                                    ? 'Recommended: the original sentence-by-sentence transcript from AssemblyAI — nothing merged or re-cut.'
                                                    : regroupParams.mode === 'word'
                                                        ? 'Every word becomes its own clip — the finest cut. Great for grabbing exact moments.'
                                                        : regroupParams.mode === 'interval'
                                                            ? 'Re-cuts the whole video into even time slices — each clip shows only the words spoken in that slice. Great for gameplay or scrubbing.'
                                                            : 'Custom: merge consecutive sentences into bigger clips with the controls below. Sentences stay whole; speaker changes always break.'}
                                            </Typography>

                                            {/* By-seconds interval picker — presets + live slider */}
                                            {regroupParams && regroupParams.mode === 'interval' && (
                                                <Box sx={{ mb: 2 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.75 }}>
                                                        <Typography variant="caption" sx={{ color: theme.palette.text.primary, fontSize: '11px', fontWeight: 600 }}>
                                                            One clip every…
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '11px', color: '#f59e0b' }}>{localParams.interval}s</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mb: 1.5 }}>
                                                        {[1, 2, 5, 10, 20, 30].map((sec) => {
                                                            const active = localParams.interval === sec;
                                                            return (
                                                                <Button key={sec} size="small" onClick={() => handleRegroupInterval(sec)}
                                                                    sx={{ minWidth: 0, flex: '1 0 28%', fontSize: '11px', height: '28px', textTransform: 'none', fontWeight: 700,
                                                                        backgroundColor: active ? '#f59e0b' : 'transparent',
                                                                        color: active ? '#fff' : '#f59e0b',
                                                                        border: `1px solid ${active ? '#f59e0b' : alpha('#f59e0b', 0.5)}`,
                                                                        '&:hover': { backgroundColor: active ? '#d97706' : alpha('#f59e0b', 0.1) } }}>
                                                                    {sec}s
                                                                </Button>
                                                            );
                                                        })}
                                                    </Box>
                                                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: '9px', display: 'block', mb: 0.5 }}>
                                                        …or drag for any length and watch the clips re-flow live
                                                    </Typography>
                                                    <PanelSlider
                                                        value={localParams.interval || 5}
                                                        onChange={(_, v) => handleRegroupInterval(v)}
                                                        min={1} max={60} step={1}
                                                        size="small"
                                                        marks={[{ value: 1, label: '1s' }, { value: 60, label: '60s' }]}
                                                        sx={{ color: '#f59e0b', '& .MuiSlider-thumb': { width: 14, height: 14 }, '& .MuiSlider-markLabel': { fontSize: '9px' } }}
                                                    />
                                                </Box>
                                            )}

                                            {selectedCount > 0 && (
                                                <Box sx={{ mb: 2, p: 1, borderRadius: 1, backgroundColor: alpha('#f59e0b', 0.12), border: '1px solid', borderColor: alpha('#f59e0b', 0.4) }}>
                                                    <Typography variant="caption" sx={{ fontSize: '10px', color: '#f59e0b', lineHeight: 1.5, display: 'block' }}>
                                                        ⚠ {selectedCount} clip{selectedCount !== 1 ? 's' : ''} selected. Changing segments may shift which clip your selection maps to — check your basket after adjusting.
                                                    </Typography>
                                                </Box>
                                            )}

                                            {regroupParams && regroupParams.mode !== 'interval' && regroupParams.mode !== 'word' && (<>
                                            {/* Max characters */}
                                            <Box sx={{ mb: 2.5 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
                                                    <Typography variant="caption" sx={{ color: theme.palette.text.primary, fontSize: '11px', fontWeight: 600 }}>Clip size</Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '11px', color: '#f59e0b' }}>{localParams.maxChars} chars</Typography>
                                                </Box>
                                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: '9px', display: 'block', mb: 0.5 }}>
                                                    Max characters per clip — drag right to make clips larger
                                                </Typography>
                                                <Slider
                                                    value={localParams.maxChars}
                                                    onChange={(_, v) => handleRegroupSlider('maxChars', v)}
                                                    min={20} max={500} step={5}
                                                    size="small"
                                                    marks={[{ value: 20, label: 'Small' }, { value: 500, label: 'Large' }]}
                                                    sx={{ color: '#f59e0b', '& .MuiSlider-thumb': { width: 14, height: 14 }, '& .MuiSlider-markLabel': { fontSize: '9px' } }}
                                                />
                                            </Box>

                                            {/* Keep short clips together */}
                                            <Box sx={{ mb: 2.5 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
                                                    <Typography variant="caption" sx={{ color: theme.palette.text.primary, fontSize: '11px', fontWeight: 600 }}>Keep merging until</Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '11px', color: '#f59e0b' }}>{localParams.minDuration}s</Typography>
                                                </Box>
                                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: '9px', display: 'block', mb: 0.5 }}>
                                                    Keep absorbing sentences until the clip is at least this many seconds
                                                </Typography>
                                                <Slider
                                                    value={localParams.minDuration}
                                                    onChange={(_, v) => handleRegroupSlider('minDuration', v)}
                                                    min={0} max={15} step={0.5}
                                                    size="small"
                                                    marks={[{ value: 0, label: 'Off' }, { value: 15, label: '15s' }]}
                                                    sx={{ color: '#f59e0b', '& .MuiSlider-thumb': { width: 14, height: 14 }, '& .MuiSlider-markLabel': { fontSize: '9px' } }}
                                                />
                                            </Box>

                                            {/* Split on pauses */}
                                            <Box sx={{ mb: 2 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.25 }}>
                                                    <Typography variant="caption" sx={{ color: theme.palette.text.primary, fontSize: '11px', fontWeight: 600 }}>Split on pauses longer than</Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '11px', color: '#f59e0b' }}>{localParams.maxGap === 0 ? 'Never' : `${localParams.maxGap}s`}</Typography>
                                                </Box>
                                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: '9px', display: 'block', mb: 0.5 }}>
                                                    If there's a silence longer than this between two sentences, they won't be merged (keeps topic breaks)
                                                </Typography>
                                                <Slider
                                                    value={localParams.maxGap}
                                                    onChange={(_, v) => handleRegroupSlider('maxGap', v)}
                                                    min={0} max={10} step={0.5}
                                                    size="small"
                                                    marks={[{ value: 0, label: 'Never' }, { value: 10, label: '10s' }]}
                                                    sx={{ color: '#f59e0b', '& .MuiSlider-thumb': { width: 14, height: 14 }, '& .MuiSlider-markLabel': { fontSize: '9px' } }}
                                                />
                                            </Box>
                                            </>)}

                                            <Divider sx={{ mb: 1.5 }} />

                                            {/* Live count */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5, gap: 1 }}>
                                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: '10px' }}>
                                                    {originalRowCount} original sentences →
                                                </Typography>
                                                <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '11px', color: '#f59e0b' }}>
                                                    {rowCount} clips
                                                </Typography>
                                            </Box>
                                            {regroupParams && (
                                                <Typography variant="caption" sx={{ color: alpha(theme.palette.text.secondary, 0.7), fontSize: '9px', display: 'block', mb: 1.5 }}>
                                                    Silent gap clips (Spaces) are hidden while Regroup is active
                                                </Typography>
                                            )}

                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <Button
                                                    size="small" variant="outlined" fullWidth
                                                    onClick={handleRegroupReset}
                                                    sx={{ fontSize: '10px', height: '26px', textTransform: 'none', borderColor: theme.palette.divider, color: theme.palette.text.secondary }}
                                                >
                                                    Reset to Original
                                                </Button>
                                                <Button
                                                    size="small" variant="contained" fullWidth
                                                    onClick={() => setRegroupOpen(false)}
                                                    sx={{ fontSize: '10px', height: '26px', textTransform: 'none', backgroundColor: '#f59e0b', '&:hover': { backgroundColor: '#d97706' } }}
                                                >
                                                    Done
                                                </Button>
                                            </Box>
                                        </Paper>
                                    </Popper>
                                </Box>
                            </ClickAwayListener>
                        </Box>
                    )}

                    {/* ── TRANSLATE ────────────────────────────────────────── */}
                    {onTranslateAll && (
                        <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Translate
                            </Typography>
                            <Stack direction={isVertical ? 'column' : 'row'} spacing={0.5} alignItems="center">
                                {/* Language picker */}
                                <ClickAwayListener onClickAway={() => { setLangPickerOpen(false); setLangSearch(''); }}>
                                    <Box>
                                        <Tooltip title={translationLang ? `Translating to ${selectedLangInfo?.label || translationLang}` : 'Pick a language to translate transcript'} placement="bottom">
                                            <Button
                                                ref={langPickerAnchorRef}
                                                size="small"
                                                variant={translationLang ? 'contained' : 'outlined'}
                                                onClick={() => setLangPickerOpen(v => !v)}
                                                onMouseEnter={() => setHoveredTool('translate')}
                                                onMouseLeave={() => setHoveredTool(null)}
                                                sx={{ fontSize: '10px', padding: '1px 7px', minWidth: 0, height: '26px', textTransform: 'none', overflow: 'hidden', justifyContent: 'flex-start',
                                                    backgroundColor: translationLang ? '#0288d1' : 'transparent',
                                                    borderColor: translationLang ? '#0288d1' : alpha('#0288d1', 0.5),
                                                    color: translationLang ? '#fff' : '#0288d1',
                                                    '&:hover': { backgroundColor: translationLang ? '#0277bd' : alpha('#0288d1', 0.1) } }}>
                                                <LanguageIcon sx={{ fontSize: '13px' }} />
                                                <span style={expandLabelSx('translate', 90)}>{translationLang ? (selectedLangInfo?.native || translationLang) : 'Language'}</span>
                                            </Button>
                                        </Tooltip>
                                        <Popper open={langPickerOpen} anchorEl={langPickerAnchorRef.current} placement="bottom-start" style={{ zIndex: 1500 }}>
                                            <Paper elevation={6} sx={{ width: 230, backgroundColor: theme.palette.background.paper, border: `1px solid ${theme.palette.divider}` }}>
                                                <Box sx={{ p: 1, borderBottom: `1px solid ${theme.palette.divider}` }}>
                                                    <input
                                                        autoFocus
                                                        value={langSearch}
                                                        onChange={e => setLangSearch(e.target.value)}
                                                        placeholder="Search language…"
                                                        style={{ width: '100%', border: 'none', outline: 'none', background: 'transparent', color: theme.palette.text.primary, fontSize: '12px', padding: '2px 4px' }}
                                                    />
                                                </Box>
                                                <Box sx={{ maxHeight: 280, overflowY: 'auto' }}>
                                                    {TRANSLATE_LANGUAGES
                                                        .filter(l => !langSearch || l.label.toLowerCase().includes(langSearch.toLowerCase()) || l.native.toLowerCase().includes(langSearch.toLowerCase()))
                                                        .map(lang => (
                                                            <Box key={lang.code}
                                                                onClick={() => { onTranslationLangChange(lang.code); setLangPickerOpen(false); setLangSearch(''); }}
                                                                sx={{ px: 1.5, py: 0.75, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                    backgroundColor: translationLang === lang.code ? alpha('#0288d1', 0.15) : 'transparent',
                                                                    '&:hover': { backgroundColor: alpha('#0288d1', 0.1) } }}>
                                                                <Box>
                                                                    <Typography variant="caption" sx={{ fontSize: '12px', display: 'block', color: theme.palette.text.primary }}>{lang.label}</Typography>
                                                                    <Typography variant="caption" sx={{ fontSize: '10px', color: theme.palette.text.secondary }}>{lang.native}</Typography>
                                                                </Box>
                                                                {translationLang === lang.code && <CheckIcon sx={{ fontSize: '14px', color: '#0288d1' }} />}
                                                            </Box>
                                                        ))}
                                                </Box>
                                            </Paper>
                                        </Popper>
                                    </Box>
                                </ClickAwayListener>
                                {/* Show/Hide translation toggle — appears once there are saved translations */}
                                {onToggleTranslation && canToggleTranslation && !translating && (
                                    <Tooltip title={translationLang ? 'Showing translation — click to show original' : `Show ${lastTranslationLang ? lastTranslationLang.toUpperCase() : ''} translation`} placement="bottom">
                                        <Button size="small" variant={translationLang ? 'contained' : 'outlined'}
                                            onClick={onToggleTranslation}
                                            sx={{ fontSize: '10px', padding: '1px 8px', minWidth: 'unset', height: '26px', textTransform: 'none', gap: '4px',
                                                backgroundColor: translationLang ? '#0288d1' : 'transparent',
                                                borderColor: translationLang ? '#0288d1' : alpha('#0288d1', 0.5),
                                                color: translationLang ? '#fff' : '#0288d1',
                                                '&:hover': { backgroundColor: translationLang ? '#0277bd' : alpha('#0288d1', 0.1) } }}>
                                            {translationLang
                                                ? <VisibilityIcon sx={{ fontSize: '13px' }} />
                                                : <VisibilityOffIcon sx={{ fontSize: '13px' }} />}
                                            {translationLang ? 'Translated' : 'Original'}
                                        </Button>
                                    </Tooltip>
                                )}
                                {/* Translate button — only shown once language selected */}
                                {translationLang && !translating && (
                                    <Tooltip title={hasTranslations ? 'Re-translate with current language' : 'Translate all visible transcript sentences'} placement="bottom">
                                        <Button size="small" variant="contained"
                                            onClick={() => onTranslateAll(translationLang)}
                                            sx={{ fontSize: '10px', padding: '1px 8px', minWidth: 'unset', height: '26px', textTransform: 'none',
                                                backgroundColor: '#0288d1', '&:hover': { backgroundColor: '#0277bd' } }}>
                                            {hasTranslations ? 'Re-run' : 'Translate'}
                                        </Button>
                                    </Tooltip>
                                )}
                                {/* Progress during translation */}
                                {translating && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 80 }}>
                                        <LinearProgress variant="determinate" value={translationProgress} sx={{ flex: 1, height: 6, borderRadius: 3, backgroundColor: alpha('#0288d1', 0.2), '& .MuiLinearProgress-bar': { backgroundColor: '#0288d1' } }} />
                                        <Typography variant="caption" sx={{ fontSize: '9px', color: '#0288d1', whiteSpace: 'nowrap' }}>{translationProgress}%</Typography>
                                    </Box>
                                )}
                                {/* Clear button */}
                                {hasTranslations && !translating && (
                                    <Tooltip title="Remove all translations" placement="bottom">
                                        <IconButton size="small" onClick={onClearTranslation}
                                            sx={{ width: 22, height: 22, color: theme.palette.text.secondary, '&:hover': { color: theme.palette.error.main } }}>
                                            <CloseIcon sx={{ fontSize: '12px' }} />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Stack>
                        </Box>
                    )}

                    {/* ── BLACK CHERRY AI ───────────────────────────────────── */}
                    {viewConfig?.createVideo && onBuildAiPack && onSelectByIds && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: isVertical ? 0 : 1 }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                AI Editor
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                <Tooltip title="Black Cherry — chat with Cherry, your AI co-editor, to arrange clips live (or copy/paste)" placement="bottom">
                                    <Button variant="contained" size="small" disableElevation onClick={() => { setAiCopied(null); setAiOpen(true); }}
                                        startIcon={<MovieIcon sx={{ fontSize: '15px' }} />}
                                        sx={{ fontSize: '11px', padding: '2px 12px', height: '26px', textTransform: 'none', fontWeight: 700, color: '#fff',
                                            background: 'linear-gradient(95deg, #7a1530 0%, #b4264f 45%, #8b5cf6 100%)',
                                            boxShadow: '0 0 10px rgba(139,92,246,0.55)',
                                            '&:hover': { background: 'linear-gradient(95deg, #5e0f24 0%, #9c1f43 45%, #7c3aed 100%)', boxShadow: '0 0 16px rgba(139,92,246,0.8)' } }}>
                                        Black Cherry
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Paste AI Picks — copy the AI's reply, then click here (or press ⌘⇧V / Ctrl+Shift+V) to apply it instantly. Pasting a new reply replaces the last one." placement="bottom">
                                    <Button variant="contained" size="small" disableElevation onClick={handlePasteAiFromClipboard}
                                        startIcon={<ContentPasteGoIcon sx={{ fontSize: '15px' }} />}
                                        sx={{ fontSize: '11px', padding: '2px 12px', height: '26px', textTransform: 'none', fontWeight: 700, color: '#fff',
                                            backgroundColor: '#8b5cf6', boxShadow: '0 0 10px rgba(139,92,246,0.5)',
                                            '&:hover': { backgroundColor: '#7c3aed', boxShadow: '0 0 16px rgba(139,92,246,0.85)' } }}>
                                        Paste AI Picks
                                    </Button>
                                </Tooltip>
                                {aiLink && onToggleAiLink && (
                                    <Tooltip title={aiLink.on
                                        ? 'AI link is ON — picks made by ChatGPT / Claude through the CherryClipz connector appear here live. Click to stop following.'
                                        : 'AI link — follow ChatGPT / Claude live: connect the CherryClipz connector in your assistant, turn this on, and its picks tick and order themselves here (no copy-paste).'} placement="bottom">
                                        <Button variant={aiLink.on ? 'contained' : 'outlined'} size="small" disableElevation onClick={onToggleAiLink}
                                            startIcon={<LinkIcon sx={{ fontSize: '15px' }} />}
                                            sx={{ fontSize: '11px', padding: '2px 12px', height: '26px', textTransform: 'none', fontWeight: 700,
                                                color: aiLink.on ? '#fff' : '#8b5cf6', borderColor: '#8b5cf6',
                                                backgroundColor: aiLink.on ? (aiLink.status === 'disconnected' ? '#7a1520' : '#7c3aed') : 'transparent',
                                                boxShadow: aiLink.on ? '0 0 10px rgba(139,92,246,0.6)' : 'none',
                                                '&:hover': { backgroundColor: aiLink.on ? '#6d28d9' : 'rgba(139,92,246,0.12)', borderColor: '#7c3aed' } }}>
                                            {!aiLink.on ? 'AI link'
                                                : aiLink.status === 'arming' ? 'Linking…'
                                                : aiLink.status === 'disconnected' ? 'Link lost'
                                                : aiLink.status === 'live' ? `${aiLink.count} from AI`
                                                : 'Linked · waiting'}
                                        </Button>
                                    </Tooltip>
                                )}
                            </Box>
                        </Box>
                    )}

                    {/* ── EXPORT ────────────────────────────────────────────── */}
                    {viewConfig?.createVideo && (
                        <Box sx={{ minWidth: isVertical ? '100%' : 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: isVertical ? 0 : 1 }}>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5, fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Export
                            </Typography>
                            <Button variant="contained" size="small" onClick={handleCreateMedia}
                                startIcon={<MovieIcon sx={{ fontSize: 14 }} />}
                                sx={{ backgroundColor: theme.palette.secondary.main, color: '#fff', fontSize: '11px',
                                    padding: '2px 10px', height: '24px', textTransform: 'none', fontWeight: 600,
                                    '&:hover': { backgroundColor: theme.palette.secondary.dark } }}>
                                Export
                            </Button>
                        </Box>
                    )}

                </Stack>
            </Box >
            <CustomModal
                open={activeModal === 'Length'}
                onClose={() => setActiveModal(null)}
                type="slider"
                value={textLen}
                onChange={(_, newValues) => onLengthChange(newValues)}
                min={textLen[0]}
                max={textLen[1]}
                color={theme.palette.success.main}
                title="Length Range"
            />
            <CustomModal
                open={activeModal === 'Virality'}
                onClose={() => setActiveModal(null)}
                type="slider"
                value={viralityRange}
                onChange={(_, newValues) => onViralityRangeChange && onViralityRangeChange(newValues)}
                min={0}
                max={100}
                color={'#f59e0b'}
                title="Virality Range (0–100)"
            />
            <CustomModal
                open={activeModal === 'Seconds'}
                onClose={() => setActiveModal(null)}
                type="slider"
                value={secondsValues}
                onChange={(_, newValues) => handleSecondsChange(newValues)}
                min={seconds[0]}
                max={seconds[1]}
                color={theme.palette.warning.main}
                title={precision ? "Seconds and centiseconds" : "Seconds Range"}
                precision={precision}
            />
            <CustomModal
                open={activeModal === 'Search'}
                onClose={() => setActiveModal(null)}
                type="search"
                color={theme.palette.info.main}
                title="Search"
                onSearchChange={onSearchChange}
                store={store}
                searchValue={store.getSearch(currentView)}
                searchContext={searchContext}
                onSearchContextChange={onSearchContextChange}
                currentView={currentView}
            />
            <CustomModal
                open={activeModal === 'Views'}
                onClose={() => setActiveModal(null)}
                type="views"
                color={theme.palette.info.main}
                title="Select View"
                value={currentView}
                onChange={handleViewChange}
                options={viewItems}
            />
            <CustomModal
                key={exportModalKey}
                open={activeModal === 'Create'}
                onClose={() => {
                    setActiveModal(null);
                    setSelectedCreateOptions([]);
                }}
                type="create"
                color={theme.palette.secondary.main}
                title="What should we make?"
                options={exportOptions}
                selectedOptions={selectedCreateOptions}
                onOptionChange={handleCreateOptionChange}
                onCreateMedia={makeMidia}
                searchValue={store.getSearch(currentView)}
                defaultExportTitle={defaultExportTitle}
                selectedDurationMs={selectedDurationMs}
                transcriptStyle={transcriptStyle}
                exportPreview={exportPreview}
                onShareLink={onShareLink}
                onEditText={onEditText}
            />
            <CustomModal
                open={activeModal === 'VideoWidth'}
                onClose={() => setActiveModal(null)}
                type="slider"
                value={videoWidth}
                onChange={(_, newValue) => onVideoWidthChange(newValue)}
                min={videoWidthRange.min}
                max={videoWidthRange.max}
                color={theme.palette.primary.main}
                title="Video Width"
                step={10}
                unit=""
                isSingleValue={true}
            />

            {/* Help & Guide Dialog — visual Toolbar guide + Keyboard & mouse reference */}
            <Dialog open={shortcutsOpen} onClose={() => setShortcutsOpen(false)} maxWidth="sm" fullWidth sx={{ zIndex: 9999 }}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 0 }}>
                    <HelpOutlineIcon sx={{ fontSize: 20 }} /> Help &amp; Guide
                </DialogTitle>
                <Tabs
                    value={helpTab}
                    onChange={(_, v) => setHelpTab(v)}
                    sx={{ px: 3, minHeight: 40, '& .MuiTab-root': { minHeight: 40, textTransform: 'none', fontWeight: 600, fontSize: '13px' } }}
                >
                    <Tab label="Toolbar guide" />
                    <Tab label="Keyboard & mouse" />
                    <Tab label="Beta" />
                </Tabs>
                <DialogContent>
                    {helpTab === 0 && (() => {
                        const gi = { fontSize: 18 };                                  // toolbar icon size in the chip
                        const chip = { fontSize: '11px', fontWeight: 700, fontFamily: 'monospace', whiteSpace: 'nowrap' };
                        // Colors lifted straight from each toolbar button so the legend matches.
                        const C = {
                            warn: theme.palette.warning.main, info: theme.palette.info.main,
                            err: theme.palette.error.main, prim: theme.palette.primary.main,
                            success: theme.palette.success.main, teal: '#009688', indigo: '#5c6bc0',
                            amber: '#F59E0B', cyan: '#26c6da', green: '#4ade80', violet: '#8b5cf6',
                            blue: '#0288d1', slate: '#90a4ae', sec: theme.palette.secondary.main,
                        };
                        const sentimentChip = (
                            <Box sx={{ ...chip, display: 'flex', gap: '3px' }}>
                                <span style={{ color: C.success }}>+</span>
                                <span style={{ color: theme.palette.text.disabled }}>=</span>
                                <span style={{ color: C.err }}>−</span>
                            </Box>
                        );
                        const guide = [
                            { section: '① Select clips', items: [
                                { icon: <CheckIcon sx={gi} />, name: 'Select a clip (✓)', desc: 'Tick a clip’s checkbox — or double-click its transcript text — to add it to your video. Each pick shows its play order: 1st, 2nd, 3rd…', color: C.err },
                                { icon: <Box sx={{ ...chip, fontSize: '10px' }}>ALL</Box>, name: 'Select all (ALL)', desc: 'Tick ALL at the top of the checkbox column to grab every clip at once — untick it to clear them all', color: C.err },
                                { icon: <DragIndicatorIcon sx={gi} />, name: 'Drag to reorder (≡)', desc: 'Grab a clip by its handle (≡ on the left) and drag it up or down to change the order it plays in your video', color: C.slate },
                            ]},
                            { section: '② Export your video', items: [
                                { icon: <MovieIcon sx={gi} />, name: 'Export', desc: 'Press Export to stitch your selected clips into one video, in pick order — as MP4 (whole clips), Super Cut (searched words only), audio, captions, or Premiere XML', color: C.sec },
                            ]},
                            { section: 'Find & filter', items: [
                                { icon: sentimentChip, name: 'Sentiment', desc: 'Filter by emotional sentiment — positive, neutral, or negative' },
                                { icon: <Box sx={chip}>A–F</Box>, name: 'Speaker', desc: 'Show only clips from one speaker', color: C.slate },
                                { icon: <AccessTimeIcon sx={gi} />, name: 'Clip Time', desc: 'Filter clips by their duration range', color: C.warn },
                                { icon: <NumbersIcon sx={gi} />, name: 'Length', desc: 'Filter by transcript character count', color: C.teal },
                                { icon: <VisibilityIcon sx={gi} />, name: 'Silences', desc: 'Show, hide, or isolate the silent gaps between speech', color: C.indigo },
                                { icon: <SearchIcon sx={gi} />, name: 'Search', desc: 'Search the transcript text for words or phrases. A context slider lets you reveal the clips around each hit.', color: C.info },
                                { icon: <AutoFixHighIcon sx={gi} />, name: 'AI Filters', desc: 'Filter by entities, phrases, and keywords. The Search context slider works on these matches too.', color: C.violet },
                                { icon: <RestartAltIcon sx={gi} />, name: 'Reset All', desc: 'Clear all filters, search, and sorting at once', color: C.err },
                            ]},
                            { section: 'Sort', items: [
                                { icon: <WatchLaterIcon sx={gi} />, name: 'Chrono', desc: 'Recording order — start → end', color: C.prim },
                                { icon: <SortByAlphaIcon sx={gi} />, name: 'Alpha', desc: 'Alphabetical by the first word — A → Z', color: C.prim },
                                { icon: <AccessTimeIcon sx={gi} />, name: 'Duration', desc: 'By clip length (the Seconds column) — shortest or longest first', color: C.prim },
                                { icon: <Box sx={chip}>▴</Box>, name: 'Column ▴', desc: 'Click any column’s triangle to sort by it; click again to flip', color: C.amber },
                            ]},
                            { section: 'Mark & edit', items: [
                                { icon: <AutoFixHighIcon sx={gi} />, name: 'Pen', desc: 'Highlight specific words within a clip', color: C.amber },
                                { icon: <EditNoteIcon sx={gi} />, name: 'Edit', desc: 'Edit the transcript text to fix errors', color: C.cyan },
                                { icon: <PushPinIcon sx={gi} />, name: 'Pin to top', desc: 'Move selected clips to the top, in pick order', color: C.prim },
                                { icon: <SkipNextIcon sx={gi} />, name: 'Play Next', desc: 'Auto-advance — play selected clips one after another', color: C.green },
                                { icon: <HighlightIcon sx={gi} />, name: 'Marks only', desc: 'When Play Next is on, this plays ONLY your pen-highlighted moments — a quick preview of just the bits you marked', color: C.amber },
                                { icon: <TouchAppIcon sx={gi} />, name: 'Click a word to seek', desc: 'Click any word in the transcript and the video jumps to exactly when it was spoken', color: C.info },
                            ]},
                            { section: 'View & cut', items: [
                                { icon: <SubtitlesIcon sx={gi} />, name: 'Captions', desc: 'Toggle synchronized captions on the video', color: C.info },
                                { icon: <Box sx={{ fontSize: '16px' }}>⚙</Box>, name: 'Segment by', desc: 'Cut clips by sentence, word, custom merge, or fixed seconds', color: C.amber },
                                { icon: <SwapHorizIcon sx={gi} />, name: 'Columns', desc: 'Switch which AI columns (Actions, Things…) are shown', color: C.prim },
                                { icon: <Box sx={{ fontSize: '16px', fontWeight: 800 }}>…</Box>, name: '“…” pause marks', desc: 'Shown in the transcript wherever there’s a long silence between two spoken words — hover to see how long', color: C.amber },
                                { icon: <Box sx={{ fontSize: '15px', fontWeight: 800 }}>Aa</Box>, name: 'Text style', desc: 'Set the transcript font size and typeface for easier reading (defaults to a comfortable larger size)', color: C.prim },
                            ]},
                            { section: 'Find a clip in context', items: [
                                { icon: <CenterFocusStrongIcon sx={gi} />, name: 'Reveal (focus button)', desc: 'When you’ve searched, filtered, or sorted, the focus button next to a clip’s download arrow jumps to it in the full transcript — clears the search/filters/sort, shows spaces, keeps your selection', color: C.info },
                                { icon: <SearchIcon sx={gi} />, name: 'Context around matches', desc: 'In the Search box, a slider reveals the clips just before and after each search OR AI-filter hit — shown dimmed but still selectable, so you never lose the surrounding context. Your selection is never touched.', color: C.info },
                            ]},
                            { section: 'AI editor', items: [
                                { icon: <AutoFixHighIcon sx={gi} />, name: 'Black Cherry AI', desc: 'Let ChatGPT, Claude, or Gemini build your edit. Type your goal right in the box, copy, and paste into the AI — it reads your transcript, summarizes it, plans an edit, then hands back the clip ids in a clean code block. Rough cut (whole clips) or Precise editor (trims within clips). Works in the Categories view on big topic chunks too.', color: '#8b5cf6' },
                                { icon: <ContentPasteGoIcon sx={gi} />, name: 'Paste AI Picks', desc: 'Copy the AI’s reply, then click Paste AI Picks (or press ⌘⇧V / Ctrl+Shift+V) to apply it instantly — no window needed. A new paste replaces the last one, so you can keep trying ideas without hitting Reset.', color: '#8b5cf6' },
                                { icon: <LinkIcon sx={gi} />, name: 'AI link', desc: 'Skip the copy-paste: add the CherryClipz connector to ChatGPT or Claude, turn AI link on here, and every cut the assistant makes ticks and orders itself in this editor live (and on the Premiere timeline if the panel is open with 📱 on).', color: '#8b5cf6' },
                            ]},
                            { section: 'Language', items: [
                                { icon: <LanguageIcon sx={gi} />, name: 'Translate', desc: 'Translate the transcript into another language', color: C.blue },
                            ]},
                        ];
                        return (<>
                            {/* Core workflow — the one thing every new user needs to know. */}
                            <Box sx={{ mb: 2.5, p: 1.5, borderRadius: 1.5, border: `1px solid ${alpha(C.prim, 0.5)}`, backgroundColor: alpha(C.prim, 0.1) }}>
                                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '13px', mb: 0.5, color: theme.palette.text.primary }}>
                                    How to export a clip
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: theme.palette.text.secondary, lineHeight: 1.55 }}>
                                    <b>1.</b> Select a clip — tick its checkbox or double-click its transcript text.&nbsp;
                                    <b>2.</b> Click <b style={{ color: C.prim }}>Export</b>.
                                    <br />Select several and they’re <b>stitched together into one clip</b>, in the order you picked them (the small numbers show pick order).
                                </Typography>
                            </Box>
                            {guide.map(({ section, items }) => (
                            <Box key={section} sx={{ mb: 2 }}>
                                <Typography variant="overline" sx={{ color: theme.palette.text.secondary, fontWeight: 700 }}>{section}</Typography>
                                <Divider sx={{ mb: 1 }} />
                                {items.map(({ icon, name, desc, color }) => (
                                    <Box key={name} sx={{ display: 'flex', gap: 1.5, mb: 1, alignItems: 'center' }}>
                                        <Box sx={{
                                            width: 34, height: 34, borderRadius: 1, flexShrink: 0,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            border: `1px solid ${alpha(color || theme.palette.text.secondary, 0.5)}`,
                                            color: color || theme.palette.text.secondary,
                                            backgroundColor: alpha(color || theme.palette.text.secondary, 0.08),
                                        }}>
                                            {icon}
                                        </Box>
                                        <Box sx={{ minWidth: 0 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '12px', lineHeight: 1.3 }}>{name}</Typography>
                                            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px', lineHeight: 1.3 }}>{desc}</Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        ))}
                            {/* Cherry's lenses — the persona editing perspectives + what inspired them. */}
                            <Box sx={{ mt: 1, mb: 2, p: 1.5, borderRadius: 1.5, border: `1px solid ${alpha('#8b5cf6', 0.4)}`, backgroundColor: alpha('#8b5cf6', 0.06) }}>
                                <Typography variant="body2" sx={{ fontWeight: 800, fontSize: '13px', mb: 0.5, color: '#c4b5fd' }}>Cherry's lenses — the same footage, different minds</Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: theme.palette.text.secondary, lineHeight: 1.6, mb: 1 }}>
                                    There are near-infinite ways to cut a video. Each <b>lens</b> (in the Chat tab) makes Cherry edit from a different master's perspective — a different way to explore that space — so the same footage can become many different films. Tap one to switch minds:
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: theme.palette.text.secondary, lineHeight: 1.75 }}>
                                    <b>🎞️ Filmmaker's eye</b> — mood, atmosphere, visual poetry (the art-house auteur).<br />
                                    <b>📜 Historian's record</b> — moments of lasting significance, kept in context (the archivist).<br />
                                    <b>🎙️ Journalist's cut</b> — the key claims and the truth that matters (the reporter).<br />
                                    <b>🎭 Dramatist's arc</b> — character, conflict and emotional turns (the playwright).<br />
                                    <b>🧠 Essayist's thread</b> — the ideas and the meaning beneath (the video essayist).<br />
                                    <b>🌀 Poet of chaos</b> — an unexpected, beautiful order in the chaos (the avant-garde poet).<br />
                                    <b>🕯️ Rabbi</b> — inspiration and scripture, nothing against the Torah (the wise teacher).<br />
                                    <b>🧪 Experimentalist</b> — bold, rule-breaking, daring over safe (the avant-garde).<br />
                                    <b>🔍 Fact-checker</b> — flags claims as true / false in context, with confidence (the analyst — always verify independently).<br />
                                    <b>😂 Comedian</b> — the funniest beats and best comedic timing.<br />
                                    <b>💥 Hook-master</b> — scroll-stopping, shareable moments, strongest hook first.
                                </Typography>
                                <Typography variant="caption" sx={{ fontSize: '11px', color: theme.palette.text.disabled, display: 'block', mt: 1 }}>
                                    Inspired by the real crafts of editing — each lens encodes how that kind of creator finds the gold a generic AI would miss.
                                </Typography>
                            </Box>
                            {/* How sorting works — rules + which columns sort. */}
                            <Box sx={{ mt: 1, mb: 2, p: 1.5, borderRadius: 1.5, border: `1px solid ${theme.palette.divider}`, backgroundColor: alpha(theme.palette.common.white, 0.03) }}>
                                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '13px', mb: 0.5 }}>How sorting works</Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: theme.palette.text.secondary, lineHeight: 1.6 }}>
                                    Use a <b>Sort</b> button, or click a column’s <b style={{ color: C.amber }}>▴</b> triangle. Click again to <b>flip</b> the direction (e.g. A→Z ↔ Z→A). Only one column sorts at a time — sorting a new one replaces the last. The active column shows an <b style={{ color: C.amber }}>amber order label</b> under its name, and <b>Pin to Top</b> overrides sorting for your selected clips.
                                    <br /><br /><b>Columns you can sort:</b> Transcript (A→Z), Seconds (duration), Length (characters) — and in the AI-columns view also Questions, Actions, Descriptions, Things, and Speaker.
                                </Typography>
                            </Box>
                            {/* What the colors mean — sentiment tint + timecode states. */}
                            <Box sx={{ mb: 1, p: 1.5, borderRadius: 1.5, border: `1px solid ${theme.palette.divider}`, backgroundColor: alpha(theme.palette.common.white, 0.03) }}>
                                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '13px', mb: 0.75 }}>What the colors mean</Typography>
                                {[
                                    { sw: C.success, label: 'Positive', desc: 'clip with positive sentiment' },
                                    { sw: theme.palette.text.disabled, label: 'Neutral', desc: 'no strong sentiment' },
                                    { sw: C.err, label: 'Negative', desc: 'clip with negative sentiment' },
                                    { sw: C.cyan, label: 'Teal time', desc: 'you trimmed this clip by hand' },
                                    { sw: C.amber, label: 'Amber time', desc: 'auto-nudged by a neighbor’s change' },
                                ].map(({ sw, label, desc }) => (
                                    <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                        <Box sx={{ width: 14, height: 14, borderRadius: '3px', backgroundColor: sw, flexShrink: 0 }} />
                                        <Typography variant="body2" sx={{ fontSize: '12px' }}><b>{label}</b> <Box component="span" sx={{ color: theme.palette.text.secondary }}>— {desc}</Box></Typography>
                                    </Box>
                                ))}
                            </Box>
                        </>);
                    })()}
                    {helpTab === 1 && (() => {
                        const C = { prim: theme.palette.primary.main, info: theme.palette.info.main, warn: theme.palette.warning.main, amber: '#F59E0B' };
                        // Keys styled like real keyboard keys (the heavier bottom border gives the 3D feel).
                        const keyPill = {
                            fontFamily: 'monospace', fontSize: '11px', whiteSpace: 'nowrap',
                            backgroundColor: alpha(theme.palette.common.white, 0.07),
                            border: `1px solid ${alpha(theme.palette.common.white, 0.18)}`,
                            borderBottomWidth: '2px', borderRadius: '5px', padding: '3px 8px',
                            minWidth: '180px', flexShrink: 0, textAlign: 'center', color: theme.palette.text.primary,
                        };
                        const sections = [
                            { section: 'Selecting clips', icon: <CheckIcon sx={{ fontSize: 16 }} />, color: C.prim, shortcuts: [
                                { keys: 'Click a checkbox', desc: 'Select / deselect a single clip' },
                                { keys: 'Click several checkboxes', desc: 'Each one adds to your selection — no key needed' },
                                { keys: 'Shift + Click', desc: 'Range-select — grab every clip between the last one you clicked and this one' },
                                { keys: 'Double-click the text', desc: 'Select / deselect a clip by clicking its transcript' },
                                { keys: 'Select All checkbox', desc: 'Select or deselect every visible clip at once' },
                                { keys: 'Pick numbers 1 · 2 · 3', desc: 'Each selected clip shows its pick order — the sequence it plays and stitches in when you export' },
                            ]},
                            { section: 'Reordering clips', icon: <DragIndicatorIcon sx={{ fontSize: 16 }} />, color: C.prim, shortcuts: [
                                { keys: 'Drag a clip up / down', desc: 'Grab a clip by its row and drag to reorder it by hand' },
                                { keys: 'Pin to Top button', desc: 'Jump all selected clips to the top of the list, in your pick order' },
                            ]},
                            { section: 'Playback', icon: <MovieIcon sx={{ fontSize: 16 }} />, color: C.info, shortcuts: [
                                { keys: 'Click a thumbnail', desc: 'Play / pause that clip (plays from its IN point)' },
                                { keys: 'Click a word', desc: 'Jump the video to that word and play from there' },
                                { keys: 'Captions (Show)', desc: 'Highlights the current word in yellow as the video plays' },
                                { keys: 'Play Next', desc: 'Plays your selected clips back-to-back, in pick order' },
                            ]},
                            { section: 'Splitting a clip', icon: <Box sx={{ fontSize: 15 }}>✂</Box>, color: C.amber, shortcuts: [
                                { keys: 'Right-click a word', desc: 'Place a split point before that word (shows a yellow ✂ hint)' },
                                { keys: 'Enter', desc: 'Confirm the split — divides the clip into two at the cursor' },
                                { keys: 'Esc', desc: 'Cancel a pending split' },
                                { keys: '↩ Unsplit', desc: 'Appears on split clips — merges the two halves back into one' },
                            ]},
                            { section: 'Fine-tuning timing', icon: <AccessTimeIcon sx={{ fontSize: 16 }} />, color: C.warn, shortcuts: [
                                { keys: '− / +  (IN row)', desc: 'Trim or extend the start by 0.1s. Extending steals time from the previous clip' },
                                { keys: '− / +  (OUT row)', desc: 'Trim or extend the end by 0.1s. Extending pushes the next clip’s start forward' },
                                { keys: 'Teal / amber times', desc: 'Teal = you adjusted it by hand. Amber = auto-nudged by a neighbor’s change' },
                                { keys: 'Ctrl + Z   (⌘Z)', desc: 'Undo the last timing change' },
                                { keys: 'Ctrl + Y   (⌘Y)', desc: 'Redo the last undone change' },
                            ]},
                            { section: 'Pen — highlight words', icon: <AutoFixHighIcon sx={{ fontSize: 16 }} />, color: C.amber, shortcuts: [
                                { keys: 'Pen button', desc: 'Toggle pen mode — the cursor becomes a crosshair' },
                                { keys: 'Click + drag words', desc: 'Highlight a range of words inside a clip (yellow)' },
                                { keys: 'Click a highlight', desc: 'Clear the highlight on that clip' },
                            ]},
                            { section: 'Filters & search', icon: <SearchIcon sx={{ fontSize: 16 }} />, color: C.info, shortcuts: [
                                { keys: '✓ Selected', desc: 'Show only the clips you’ve selected' },
                                { keys: 'Context slider', desc: 'In Search, reveal clips around each search/AI-filter hit (dimmed but selectable)' },
                                { keys: 'Reset All', desc: 'Clear every filter, sort, and search at once' },
                            ]},
                            { section: 'AI editor', icon: <AutoFixHighIcon sx={{ fontSize: 16 }} />, color: '#8b5cf6', shortcuts: [
                                { keys: '⌘⇧V / Ctrl+Shift+V', desc: 'Paste the AI’s reply from your clipboard and select those clips — no window needed' },
                            ]},
                        ];
                        return (<>
                            {/* The two moves that matter most — shown as a visual flow. */}
                            <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1, mb: 2.5 }}>
                                {[
                                    { n: '1', title: 'Select clips', body: 'Tick a checkbox — or double-click the transcript text', icon: <CheckIcon sx={{ fontSize: 18 }} /> },
                                    { n: '2', title: 'Export', body: 'Click Export (or press ⌘E / Ctrl+E) — several clips stitch into one, in pick order', icon: <MovieIcon sx={{ fontSize: 18 }} /> },
                                ].map((card, i) => (
                                    <React.Fragment key={card.n}>
                                        {i === 1 && <ArrowForwardIcon sx={{ alignSelf: 'center', color: theme.palette.text.disabled, fontSize: 20, flexShrink: 0 }} />}
                                        <Box sx={{ flex: 1, p: 1.25, borderRadius: 1.5, border: `1px solid ${alpha(C.prim, 0.5)}`, backgroundColor: alpha(C.prim, 0.1) }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
                                                <Box sx={{ width: 22, height: 22, borderRadius: '50%', backgroundColor: C.prim, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700, flexShrink: 0 }}>{card.n}</Box>
                                                <Box sx={{ color: C.prim, display: 'inline-flex' }}>{card.icon}</Box>
                                                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '13px' }}>{card.title}</Typography>
                                            </Box>
                                            <Typography variant="body2" sx={{ fontSize: '11.5px', color: theme.palette.text.secondary, lineHeight: 1.4 }}>{card.body}</Typography>
                                        </Box>
                                    </React.Fragment>
                                ))}
                            </Box>
                            {sections.map(({ section, icon, color, shortcuts }) => (
                                <Box key={section} sx={{ mb: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.25 }}>
                                        <Box sx={{ color, display: 'inline-flex' }}>{icon}</Box>
                                        <Typography variant="overline" sx={{ color: theme.palette.text.secondary, fontWeight: 700 }}>{section}</Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    {shortcuts.map(({ keys, desc }) => (
                                        <Box key={keys} sx={{ display: 'flex', gap: 2, mb: 0.75, alignItems: 'flex-start' }}>
                                            <Box sx={keyPill}>{keys}</Box>
                                            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px', lineHeight: 1.4 }}>{desc}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            ))}
                        </>);
                    })()}
                    {helpTab === 2 && (() => {
                        const gi = { fontSize: 18 };
                        const chip = { fontSize: '13px', fontWeight: 800, fontFamily: 'monospace', whiteSpace: 'nowrap', lineHeight: 1 };
                        const C = {
                            prim: theme.palette.primary.main, info: theme.palette.info.main,
                            warn: theme.palette.warning.main, err: theme.palette.error.main,
                            success: theme.palette.success.main, teal: '#009688', slate: '#90a4ae',
                            amber: '#F59E0B', sec: theme.palette.secondary.main,
                        };
                        const live = [
                            { section: '① Select clips', items: [
                                { icon: <CheckIcon sx={gi} />, name: 'Select a clip (✓)', desc: 'Tick a clip’s checkbox to add it to your video. Each pick shows its play order — 1st, 2nd, 3rd…', color: C.err },
                                { icon: <Box sx={{ ...chip, fontSize: '10px' }}>ALL</Box>, name: 'Select all (ALL)', desc: 'Tick ALL at the top of the checkbox column to grab every clip at once — untick it to clear them all', color: C.err },
                                { icon: <DragIndicatorIcon sx={gi} />, name: 'Drag to reorder (≡)', desc: 'Grab a clip by its handle (≡ on the left) and drag it up or down to change the order it plays', color: C.slate },
                            ]},
                            { section: '② Export', items: [
                                { icon: <MovieIcon sx={gi} />, name: 'Export', desc: 'The purple Export button stitches your selected clips into one video, in pick order, and downloads it. Choose MP4 (whole clips) or Super Cut (searched words only) — see above', color: C.sec },
                            ]},
                            { section: 'Sentiment', items: [
                                { icon: <Box sx={chip}>+</Box>, name: 'Positive', desc: 'Show only the upbeat, positive-toned clips', color: C.success },
                                { icon: <Box sx={chip}>=</Box>, name: 'Neutral', desc: 'Show only the neutral, matter-of-fact clips', color: C.slate },
                                { icon: <Box sx={chip}>−</Box>, name: 'Negative', desc: 'Show only the negative or tense-toned clips', color: C.err },
                            ]},
                            { section: 'Speaker', items: [
                                { icon: <Box sx={chip}>A</Box>, name: 'Speaker A · B · C…', desc: 'Tap a letter to show only that person’s clips. Every speaker the video detected gets their own button (A, B, C…)', color: C.slate },
                            ]},
                            { section: 'Length & Time — drag the sliders', items: [
                                { icon: <AccessTimeIcon sx={gi} />, name: 'Time → exact seconds', desc: 'Opens a slider. Drag the two handles to keep only clips of a certain duration — e.g. 3 s to 5 s for short, punchy bites. Great for finding quick one-liners', color: C.warn },
                                { icon: <ArrowForwardIcon sx={gi} />, name: 'Length → number of characters', desc: 'Drag the slider to keep only statements with a certain number of characters — e.g. 7 to 237. Fewer characters = shorter sentences', color: C.teal },
                            ]},
                            { section: 'Search', items: [
                                { icon: <SearchIcon sx={gi} />, name: 'Search', desc: 'Find any word or phrase in the transcript. Search also powers Super Cut (see Export above)', color: C.info },
                            ]},
                            { section: 'Reset — start over', items: [
                                { icon: <RestartAltIcon sx={gi} />, name: 'Reset', desc: 'One click clears EVERY filter, search and sort — and your selections — so you can start fresh. Very handy to reset, but heads-up: your current picks will be lost', color: C.err },
                            ]},
                            { section: 'Options', items: [
                                { icon: <SubtitlesIcon sx={gi} />, name: 'Captions', desc: 'Toggle captions on the preview video', color: C.info },
                                { icon: <SwapHorizIcon sx={gi} />, name: 'Columns', desc: 'Switch which info columns (Actions, Things…) are shown', color: C.prim },
                            ]},
                            { section: 'Move & navigate', items: [
                                { icon: <DragIndicatorIcon sx={gi} />, name: 'Position', desc: 'Drag the dotted handle to move the toolbar around; the ‹ › ⌄ arrows step through and reorder clips', color: C.slate },
                            ]},
                        ];
                        return (<>
                            {/* THE most important thing: select + export */}
                            <Box sx={{ mb: 2, p: 1.5, borderRadius: 1.5, border: `1px solid ${alpha(C.prim, 0.6)}`, backgroundColor: alpha(C.prim, 0.12) }}>
                                <Typography sx={{ fontWeight: 800, fontSize: '14px', mb: 0.5 }}>⭐ Make a video in 2 steps</Typography>
                                <Typography variant="body2" sx={{ fontSize: '12.5px', color: theme.palette.text.secondary, lineHeight: 1.6 }}>
                                    <b>1. <span style={{ color: C.prim }}>Select clips</span></b> — tick a clip’s checkbox. Pick as many as you want; the small numbers show the order they’ll play.<br />
                                    <b>2. <span style={{ color: C.prim }}>Export</span></b> — press the <b>movie</b> button. Your selected clips stitch into one video, in the order you picked.
                                </Typography>
                            </Box>

                            {/* Export modes: MP4 vs Super Cut, with an example */}
                            <Box sx={{ mb: 2.5, p: 1.5, borderRadius: 1.5, border: `1px solid ${alpha(C.amber, 0.55)}`, backgroundColor: alpha(C.amber, 0.08) }}>
                                <Typography sx={{ fontWeight: 800, fontSize: '13px', mb: 0.75 }}>Two ways to export</Typography>
                                <Typography variant="body2" sx={{ fontSize: '12.5px', color: theme.palette.text.secondary, lineHeight: 1.6, mb: 1 }}>
                                    <b style={{ color: theme.palette.text.primary }}>🎬 MP4 video</b> — exports the <b>whole</b> selected clip (or clips, stitched together). You get everything that was said, start to finish — no matter what you searched.
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: '12.5px', color: theme.palette.text.secondary, lineHeight: 1.6 }}>
                                    <b style={{ color: C.amber }}>✂ Super Cut (searched words only)</b> — first <b>search a word</b>, then select your clips and tick <b>Super Cut</b>. It exports <b>only the searched word</b> out of each clip and stitches them into one rapid montage.<br />
                                    <Box component="span" sx={{ color: theme.palette.text.primary }}><i>Example:</i></Box> search <b>“amazing”</b>, select 10 clips, tick Super Cut → you get a punchy supercut of the word <b>“amazing” said 10 times in a row</b>. (Pick MP4 instead and you’d get the 10 full sentences.)
                                </Typography>
                            </Box>

                            {live.map(({ section, items }) => (
                                <Box key={section} sx={{ mb: 2 }}>
                                    <Typography variant="overline" sx={{ color: theme.palette.text.secondary, fontWeight: 700 }}>{section}</Typography>
                                    <Divider sx={{ mb: 1 }} />
                                    {items.map(({ icon, name, desc, color }) => (
                                        <Box key={name} sx={{ display: 'flex', gap: 1.5, mb: 1, alignItems: 'center' }}>
                                            <Box sx={{
                                                width: 34, height: 34, borderRadius: 1, flexShrink: 0,
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                border: `1px solid ${alpha(color || theme.palette.text.secondary, 0.5)}`,
                                                color: color || theme.palette.text.secondary,
                                                backgroundColor: alpha(color || theme.palette.text.secondary, 0.08),
                                            }}>
                                                {icon}
                                            </Box>
                                            <Box sx={{ minWidth: 0 }}>
                                                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '12px', lineHeight: 1.3 }}>{name}</Typography>
                                                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '12px', lineHeight: 1.3 }}>{desc}</Typography>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            ))}
                            <Box sx={{ mb: 1, p: 1.5, borderRadius: 1.5, border: `1px solid ${alpha('#8b5cf6', 0.5)}`, backgroundColor: alpha('#8b5cf6', 0.06) }}>
                                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '13px', mb: 0.5, color: '#c4b5fd' }}>Extra power in this beta (v2)</Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: theme.palette.text.secondary, lineHeight: 1.6 }}>
                                    This beta also includes: <b>Black Cherry AI</b> (let ChatGPT/Gemini build your edit), the <b>Pen tool</b> to trim within a clip, <b>Search & AI-filter context</b>, <b>“…” pause marks</b>, <b>Play Next</b> preview, <b>+/−</b> fine-tuning of clip timing, <b>burned-in captions</b>, <b>translation</b>, and the <b>Categories</b> topic view — all explained in the other two tabs.
                                </Typography>
                            </Box>
                        </>);
                    })()}
                </DialogContent>
            </Dialog>

            {/* In-app confirm for switching segment modes while clips are selected —
                replaces the native browser confirm so it matches CherryClipz. */}
            <Dialog
                open={Boolean(confirmSwitch)}
                onClose={handleCancelSwitch}
                PaperProps={{
                    sx: {
                        backgroundColor: theme.palette.background.paper,
                        backgroundImage: 'none',
                        border: `1px solid ${alpha('#f59e0b', 0.45)}`,
                        borderRadius: 2,
                        maxWidth: 380,
                    },
                }}
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '15px', fontWeight: 700, color: theme.palette.text.primary, pb: 1 }}>
                    <Box component="span" sx={{ color: '#f59e0b', display: 'inline-flex', fontSize: '18px' }}>⚠</Box>
                    Clear your selection?
                </DialogTitle>
                <DialogContent sx={{ pb: 2 }}>
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '13px', lineHeight: 1.6 }}>
                        You have <Box component="span" sx={{ color: '#f59e0b', fontWeight: 700 }}>{confirmSwitch?.count} clip{confirmSwitch?.count === 1 ? '' : 's'}</Box> selected.
                        Switching segment modes clears your selection — these exact clips don’t exist in the other mode. Export first if you want to keep them.
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2.5 }}>
                        <Button onClick={handleCancelSwitch} size="small"
                            sx={{ textTransform: 'none', fontWeight: 600, color: theme.palette.text.secondary,
                                border: `1px solid ${theme.palette.divider}`, px: 2, borderRadius: 1.5,
                                '&:hover': { backgroundColor: theme.palette.action.hover } }}>
                            Cancel
                        </Button>
                        <Button onClick={handleConfirmSwitch} size="small" variant="contained" disableElevation
                            sx={{ textTransform: 'none', fontWeight: 700, backgroundColor: '#f59e0b', color: '#fff', px: 2, borderRadius: 1.5,
                                '&:hover': { backgroundColor: '#d97706' } }}>
                            Switch &amp; clear
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* AI Usage report — per-video + lifetime tokens/cost, logged locally from each AI run. */}
            <Dialog open={usageOpen} onClose={() => setUsageOpen(false)} maxWidth="sm" fullWidth sx={{ zIndex: 10000 }}
                PaperProps={{ sx: { backgroundImage: 'none', backgroundColor: '#15101a', border: '1px solid', borderColor: alpha('#8b5cf6', 0.45), borderRadius: 2, color: '#fff' } }}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
                    <Box component="span" sx={{ flex: 1, fontWeight: 800 }}>📊 AI Usage</Box>
                    <IconButton size="small" onClick={() => setUsageOpen(false)} sx={{ color: alpha('#fff', 0.8) }}><CloseIcon fontSize="small" /></IconButton>
                </DialogTitle>
                <DialogContent>
                    {(() => {
                        const fmtT = (n) => (n >= 1000 ? `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k` : `${n}`);
                        const fmtUsd = (u) => (u < 0.01 ? '<1¢' : u < 1 ? `~${Math.round(u * 100)}¢` : `~$${u.toFixed(2)}`);
                        if (!usageRecords.length) {
                            return <Typography sx={{ color: alpha('#fff', 0.6), py: 2 }}>No AI runs recorded yet. Black Cherry chat, Filler, and Virality runs will show up here.</Typography>;
                        }
                        const t = usageTotals(usageRecords);
                        const vids = usageByVideo(usageRecords);
                        return (
                            <>
                                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
                                    {[['Calls', `${t.calls}`], ['Tokens in', fmtT(t.tokensIn)], ['Tokens out', fmtT(t.tokensOut)], ['Est. cost', fmtUsd(t.costUSD)]].map(([l, v]) => (
                                        <Box key={l} sx={{ flex: '1 1 100px', p: 1.25, borderRadius: 1.5, border: `1px solid ${alpha('#8b5cf6', 0.3)}`, backgroundColor: alpha('#8b5cf6', 0.06) }}>
                                            <Typography sx={{ fontSize: '11px', color: alpha('#fff', 0.6) }}>{l}</Typography>
                                            <Typography sx={{ fontSize: '18px', fontWeight: 800 }}>{v}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: alpha('#fff', 0.75), mb: 0.5 }}>By video</Typography>
                                <Box sx={{ maxHeight: 260, overflowY: 'auto', border: `1px solid ${alpha('#fff', 0.1)}`, borderRadius: 1.5 }}>
                                    {vids.map((v, i) => (
                                        <Box key={`${v.transcriptId}-${i}`} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.25, py: 0.85, borderBottom: `1px solid ${alpha('#fff', 0.07)}` }}>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography sx={{ fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{v.videoTitle || 'Untitled'}</Typography>
                                                <Typography sx={{ fontSize: '11px', color: alpha('#fff', 0.5) }}>{v.calls} call{v.calls !== 1 ? 's' : ''} · {fmtT(v.tokensIn)} in / {fmtT(v.tokensOut)} out</Typography>
                                            </Box>
                                            <Typography sx={{ fontSize: '14px', fontWeight: 800, color: '#c4b5fd' }}>{fmtUsd(v.costUSD)}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
                                    <Typography sx={{ flex: 1, fontSize: '11px', color: alpha('#fff', 0.45) }}>Estimated from provider token counts; stored only in this browser. CherryClipz auto-cuts cost $0 (no AI).</Typography>
                                    <Button size="small" onClick={() => { clearAiUsage(); setUsageRecords([]); }} sx={{ textTransform: 'none', color: '#ff9ebf' }}>Clear</Button>
                                </Box>
                            </>
                        );
                    })()}
                </DialogContent>
            </Dialog>

            {/* Black Cherry AI — copy clips → paste into ChatGPT/Gemini → paste ids back. */}
            <Dialog open={aiOpen} onClose={() => setAiOpen(false)} maxWidth={false} hideBackdrop disableEnforceFocus
                sx={{ zIndex: 13000, pointerEvents: 'none',
                    // Panel: centered, near-top. Phone: centered. Desktop web: docked right.
                    '& .MuiDialog-container': { justifyContent: isPanelEmbed ? 'center' : { xs: 'center', sm: 'flex-end' }, alignItems: 'flex-start', pointerEvents: 'none' },
                    '& .MuiPaper-root': { pointerEvents: 'auto' } }}
                PaperProps={{ sx: { backgroundImage: 'none', backgroundColor: '#15101a', border: '1px solid', borderColor: alpha('#8b5cf6', 0.45), borderRadius: 2, overflow: 'hidden', width: 540, maxWidth: '94vw', m: 0,
                    // Panel is short+narrow: hug the top, no right dock, use ~all the
                    // height. Web keeps its docked offsets. (Isaac: it was squished.)
                    mt: isPanelEmbed ? '8px' : { xs: '64px', sm: '264px' },
                    mr: isPanelEmbed ? 0 : { xs: 0, sm: '248px' },
                    boxShadow: '0 14px 50px rgba(0,0,0,.6)', transform: { xs: 'none', sm: `translate(${aiDrag.x}px, ${aiDrag.y}px)` },
                    // Cap to the viewport and let the body scroll. The content is taller
                    // than a short docked panel no matter what, so the scrollbar MUST be
                    // visible (CEF hides it by default → looks "cut off"); styled below.
                    display: 'flex', flexDirection: 'column',
                    maxHeight: isPanelEmbed ? 'calc(100vh - 16px)' : { xs: 'calc(100vh - 84px)', sm: 'calc(100vh - 284px)' } } }}>
                <Box onMouseDown={startAiDrag} sx={{ px: 3, py: 1.75, cursor: 'move', userSelect: 'none', background: 'linear-gradient(95deg, rgba(122,21,48,0.55) 0%, rgba(180,38,79,0.4) 45%, rgba(139,92,246,0.45) 100%)', borderBottom: '1px solid', borderColor: alpha('#8b5cf6', 0.35) }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                        <img src={cherryLogo} alt="CherryClipz" style={{ height: 38, width: 'auto' }} />
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={{ fontWeight: 800, fontSize: '23px', lineHeight: 1.1,
                                background: 'linear-gradient(90deg, #ff5f8d, #c4b5fd)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                                Black Cherry
                            </Typography>
                            <Typography variant="caption" sx={{ color: alpha('#fff', 0.72), fontSize: '12px', letterSpacing: '0.3px' }}>
                                {archiveInfo ? `Cherry sees all ${archiveInfo.sources.length} videos as one sheet · drag to move` : 'meet Cherry, your AI co-editor · drag to move'}
                            </Typography>
                        </Box>
                        <Button size="small" onMouseDown={(e) => e.stopPropagation()} onClick={openUsage}
                            sx={{ textTransform: 'none', minWidth: 0, mr: 0.5, color: alpha('#fff', 0.85), fontSize: '12px', fontWeight: 700, '&:hover': { color: '#fff', backgroundColor: alpha('#fff', 0.12) } }}>
                            📊 Usage
                        </Button>
                        <IconButton size="small" onMouseDown={(e) => e.stopPropagation()} onClick={() => setAiOpen(false)}
                            sx={{ color: alpha('#fff', 0.85), '&:hover': { color: '#fff', backgroundColor: alpha('#fff', 0.12) } }}>
                            <Box component="span" sx={{ fontSize: 17, lineHeight: 1, fontWeight: 700 }}>✕</Box>
                        </IconButton>
                    </Box>
                </Box>
                <DialogContent sx={{ pt: 2.5, flex: 1, minHeight: 0, overflowY: 'auto',
                    // Always-visible scrollbar so it's obvious there's more below (CEF
                    // auto-hides it, which read as "cut off"). Panel mode only.
                    ...(isPanelEmbed ? {
                        '&::-webkit-scrollbar': { width: '10px' },
                        '&::-webkit-scrollbar-thumb': { backgroundColor: alpha('#8b5cf6', 0.6), borderRadius: '5px' },
                        '&::-webkit-scrollbar-track': { backgroundColor: alpha('#fff', 0.06) },
                    } : {}) }}>
                    {/* ARCHIVE: say it out loud — Cherry has every video and can cut across them. */}
                    {archiveInfo && (
                        <Box sx={{ mb: 1.5, px: 1.25, py: 0.9, borderRadius: 1.5, border: `1px solid ${alpha('#3b82f6', 0.45)}`, backgroundColor: alpha('#3b82f6', 0.08), fontSize: '12.5px', color: '#c7d2fe', lineHeight: 1.5 }}>
                            🗂 <b>Archive — {archiveInfo.sources.length} videos in one sheet.</b> Cherry sees every clip with its video and can cut across them: {archiveInfo.sources.map((src) => `${src.short} ${src.label}`).join(' · ')}
                        </Box>
                    )}
                    {/* Mode toggle: live chat (API) vs copy-paste */}
                    <Box sx={{ display: 'flex', gap: 0.75, mb: 2 }}>
                        <Button fullWidth size="small" disableElevation onClick={() => setAiMode('chat')}
                            sx={{ textTransform: 'none', fontWeight: 700, fontSize: '12px', border: '1px solid #8b5cf6',
                                backgroundColor: aiMode === 'chat' ? '#8b5cf6' : 'transparent', color: aiMode === 'chat' ? '#fff' : '#c4b5fd',
                                '&:hover': { backgroundColor: aiMode === 'chat' ? '#7c3aed' : alpha('#8b5cf6', 0.12) } }}>
                            💬 Chat live
                        </Button>
                        <Button fullWidth size="small" disableElevation onClick={() => setAiMode('paste')}
                            sx={{ textTransform: 'none', fontWeight: 700, fontSize: '12px', border: '1px solid #8b5cf6',
                                backgroundColor: aiMode === 'paste' ? '#8b5cf6' : 'transparent', color: aiMode === 'paste' ? '#fff' : '#c4b5fd',
                                '&:hover': { backgroundColor: aiMode === 'paste' ? '#7c3aed' : alpha('#8b5cf6', 0.12) } }}>
                            📋 Copy &amp; paste
                        </Button>
                    </Box>

                    {/* MODEL PICKER — pick the provider + model; each provider keeps its own key */}
                    {aiMode === 'chat' && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1, flexWrap: 'wrap' }}>
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                {Object.keys(AI_PROVIDERS).map((p) => (
                                    <Box key={p} onClick={() => switchProvider(p)}
                                        sx={{ cursor: 'pointer', px: 1.1, py: 0.4, borderRadius: 5, fontSize: '11.5px', fontWeight: 700,
                                            border: `1px solid ${aiProvider === p ? '#8b5cf6' : alpha('#8b5cf6', 0.3)}`,
                                            color: aiProvider === p ? '#fff' : '#c4b5fd', backgroundColor: aiProvider === p ? '#8b5cf6' : 'transparent',
                                            transition: 'all .15s', '&:hover': { borderColor: '#8b5cf6' } }}>
                                        {AI_PROVIDERS[p].label}
                                    </Box>
                                ))}
                            </Box>
                            <TextField size="small" variant="standard" value={aiModel}
                                onChange={(e) => setAiModel(e.target.value)}
                                onBlur={(e) => saveAiModel(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Enter') { saveAiModel(e.target.value); e.target.blur(); } }}
                                placeholder={AI_PROVIDERS[aiProvider].defaultModel}
                                title="The exact model name — edit it to try a different model"
                                sx={{ flex: 1, minWidth: 110, '& input': { fontFamily: 'monospace', fontSize: '11px', color: theme.palette.text.secondary } }} />
                        </Box>
                    )}

                    {/* LIVE CHAT — talks to your chosen model directly inside CherryClipz, no copy/paste */}
                    {aiMode === 'chat' && (
                        // On a shared link the AI runs on the owner's server key (proxy) — skip the
                        // "connect your key" gate so guests can chat without pasting a key of their
                        // own. EXCEPT when the proxy reported guest AI blocked (guestAiBlocked):
                        // then the form is the only way forward.
                        (!aiKey && (guestAiBlocked || !(typeof window !== 'undefined' && window.location.pathname.startsWith('/s/')))) ? (
                            <Box sx={{ mb: 1, p: 1.5, borderRadius: 1.5, border: `1px solid ${theme.palette.divider}`, backgroundColor: alpha('#8b5cf6', 0.06) }}>
                                <Typography sx={{ fontWeight: 700, fontSize: '13px', mb: 0.5 }}>Connect your {AI_PROVIDERS[aiProvider].label} key (one time)</Typography>
                                <Typography variant="body2" sx={{ fontSize: '11.5px', color: theme.palette.text.secondary, mb: 1 }}>
                                    Get one at {AI_PROVIDERS[aiProvider].where}. It's saved only in this browser, never sent to us.
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <TextField fullWidth size="small" type="password" placeholder={AI_PROVIDERS[aiProvider].hint} value={aiKeyDraft}
                                        onChange={(e) => setAiKeyDraft(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === 'Enter' && aiKeyDraft.trim()) { saveAiKey(aiKeyDraft.trim()); setAiKeyDraft(''); } }}
                                        sx={{ '& input': { fontFamily: 'monospace', fontSize: '12px' } }} />
                                    <Button variant="contained" disableElevation disabled={!aiKeyDraft.trim()} onClick={() => { saveAiKey(aiKeyDraft.trim()); setAiKeyDraft(''); }}
                                        sx={{ backgroundColor: '#8b5cf6', '&:hover': { backgroundColor: '#7c3aed' } }}>Save</Button>
                                </Box>
                            </Box>
                        ) : (
                            <Box>
                                {/* The history shrinks with the window so the "Ask Cherry…" box below it always
                                    shows: a fixed 400px pushed it under the panel's bottom edge on a laptop
                                    (the panel is docked 264px down), so you had to scroll to type (2026-10-09).
                                    The calc subtracts the dock offset + everything else in the panel (~310px). */}
                                <Box sx={{ height: isPanelEmbed ? 190 : { xs: 'clamp(140px, calc(100vh - 400px), 400px)', sm: 'clamp(140px, calc(100vh - 600px), 400px)' }, overflowY: 'auto', border: `1px solid ${theme.palette.divider}`, borderRadius: 1.5, p: 1.5, mb: 1.25, backgroundColor: alpha('#000', 0.25), display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                                    {aiMessages.length === 0 && (
                                        <Box sx={{ mt: 2.5, textAlign: 'center' }}>
                                            <Typography variant="body2" sx={{ fontSize: '13.5px', color: theme.palette.text.secondary, lineHeight: 1.6, mb: 2 }}>
                                                Tell Cherry what to build and she'll arrange the clips live — or tap a starter:
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', px: 1 }}>
                                                {[...(archiveInfo ? ARCHIVE_GOAL_CHIPS : []), ...AI_GOAL_CHIPS].map((c) => (
                                                    <Box key={c.t} onClick={() => handleSendChat(c.p)}
                                                        sx={{ cursor: 'pointer', px: 1.5, py: 0.85, borderRadius: 5, fontSize: '13px', fontWeight: 600,
                                                            border: `1px solid ${alpha('#8b5cf6', 0.5)}`, color: '#c4b5fd', backgroundColor: alpha('#8b5cf6', 0.08),
                                                            transition: 'all .15s', '&:hover': { backgroundColor: alpha('#8b5cf6', 0.22), borderColor: '#8b5cf6', color: '#fff' } }}>
                                                        {c.e}&nbsp; {c.t}
                                                    </Box>
                                                ))}
                                            </Box>
                                            <Typography variant="body2" sx={{ fontSize: '12.5px', color: theme.palette.text.disabled, mt: 2.25, mb: 1.25 }}>
                                                🎭 …or edit through a lens:
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', px: 1 }}>
                                                {AI_LENS_CHIPS.map((c) => (
                                                    <Box key={c.t} onClick={() => handleSendChat(c.p)}
                                                        sx={{ cursor: 'pointer', px: 1.5, py: 0.85, borderRadius: 5, fontSize: '13px', fontWeight: 600,
                                                            border: `1px solid ${alpha('#ff5f8d', 0.5)}`, color: '#ff9ebf', backgroundColor: alpha('#ff5f8d', 0.08),
                                                            transition: 'all .15s', '&:hover': { backgroundColor: alpha('#ff5f8d', 0.22), borderColor: '#ff5f8d', color: '#fff' } }}>
                                                        {c.e}&nbsp; {c.t}
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>
                                    )}
                                    {aiMessages.map((m, i) => (
                                        <Box key={i} sx={{ alignSelf: m.role === 'user' ? 'flex-end' : 'flex-start', maxWidth: '90%', px: 1.5, py: 1, borderRadius: 2, fontSize: '15px', lineHeight: 1.6, whiteSpace: 'pre-wrap',
                                            backgroundColor: m.role === 'user' ? '#8b5cf6' : alpha('#fff', 0.08), color: m.role === 'user' ? '#fff' : theme.palette.text.primary }}>
                                            {m.content}
                                        </Box>
                                    ))}
                                    {aiChatLoading && (
                                        <Box sx={{ alignSelf: 'flex-start', display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 0.75, borderRadius: 2, backgroundColor: alpha('#8b5cf6', 0.15) }}>
                                            <Box component="span" sx={{ fontSize: '15px' }}>🍒</Box>
                                            <Typography variant="body2" sx={{ fontSize: '13.5px', color: '#c4b5fd', fontStyle: 'italic' }}>
                                                Cherry is thinking… <b style={{ fontStyle: 'normal', fontVariantNumeric: 'tabular-nums' }}>{aiElapsed.toFixed(1)}s</b>
                                            </Typography>
                                        </Box>
                                    )}
                                    {!aiChatLoading && aiElapsed > 0 && aiLastN > 0 && (
                                        <Box sx={{ alignSelf: 'flex-start', display: 'inline-flex', alignItems: 'center', gap: 0.6, px: 1.1, py: 0.5, borderRadius: 4, backgroundColor: alpha('#10b981', 0.14), border: `1px solid ${alpha('#10b981', 0.45)}` }}>
                                            <Box component="span" sx={{ fontSize: '13px' }}>⚡</Box>
                                            <Typography variant="caption" sx={{ fontSize: '11.5px', color: '#34d399', fontWeight: 800, letterSpacing: '0.2px', fontVariantNumeric: 'tabular-nums' }}>
                                                Arranged {aiLastN} clip{aiLastN !== 1 ? 's' : ''}{aiLastTrimmed > 0 ? ` · ✂️ ${aiLastTrimmed} trimmed` : (aiPrecise ? ' · 0 trimmed' : '')} in {aiElapsed.toFixed(1)}s{aiElapsed < 4 ? ' · blazing fast' : aiElapsed < 8 ? ' · fast' : ''}
                                            </Typography>
                                        </Box>
                                    )}
                                    {!aiChatLoading && aiLastN === 0 && (
                                        <Box sx={{ alignSelf: 'flex-start', display: 'inline-flex', alignItems: 'center', gap: 0.6, px: 1.1, py: 0.5, borderRadius: 4, backgroundColor: alpha('#f59e0b', 0.14), border: `1px solid ${alpha('#f59e0b', 0.45)}` }}>
                                            <Box component="span" sx={{ fontSize: '13px' }}>⚠️</Box>
                                            <Typography variant="caption" sx={{ fontSize: '11.5px', color: '#fbbf24', fontWeight: 700 }}>
                                                Cherry didn't return clips — ask again, or narrow the video first (it's big)
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <TextField fullWidth size="small" multiline minRows={2} maxRows={6} placeholder="Ask Cherry…" value={aiInput}
                                        onChange={(e) => setAiInput(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSendChat(); } }}
                                        sx={{ '& textarea': { fontSize: '15px', lineHeight: 1.5 } }} />
                                    <Button variant="contained" disableElevation disabled={aiChatLoading || !aiInput.trim()} onClick={handleSendChat}
                                        sx={{ backgroundColor: '#8b5cf6', '&:hover': { backgroundColor: '#7c3aed' }, minWidth: 60 }}>Send</Button>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 0.75 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }} onClick={() => setAiIncludeSilence(v => !v)}>
                                            <Checkbox checked={aiIncludeSilence} size="small" sx={{ p: 0 }} />
                                            <Typography variant="caption" sx={{ fontSize: '11px', color: theme.palette.text.secondary }}>Include trailing silence</Typography>
                                        </Box>
                                        <Tooltip title="Let Cherry cut WITHIN each line — keeping only the strongest phrase, like the pen tool. With 'Include trailing silence' on, each trimmed phrase keeps a small cushion so it never cuts off mid-breath. You can fine-tune any phrase afterward with its +/- buttons." placement="top" arrow>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }} onClick={() => setAiPrecise(v => !v)}>
                                                <Checkbox checked={aiPrecise} size="small" sx={{ p: 0, color: '#e6326b', '&.Mui-checked': { color: '#e6326b' } }} />
                                                <Typography variant="caption" sx={{ fontSize: '11px', color: aiPrecise ? '#e6326b' : theme.palette.text.secondary, fontWeight: aiPrecise ? 700 : 400 }}>✂️ Trim to the best part</Typography>
                                            </Box>
                                        </Tooltip>
                                    </Box>
                                    <Box>
                                        <Tooltip title="Start fresh — clears the chat and the current arrangement so you can try a new direction" placement="top" arrow>
                                            <Button size="small" onClick={() => { setAiMessages([]); setAiLastN(-1); setAiLastTrimmed(0); setAiElapsed(0); if (onClearSelections) onClearSelections(); }} sx={{ fontSize: '11px', textTransform: 'none', color: theme.palette.text.secondary, minWidth: 0 }}>↺ Start over</Button>
                                        </Tooltip>
                                        <Tooltip title="Remove your saved OpenAI key (you'll need to paste it again)" placement="top" arrow>
                                            <Button size="small" onClick={() => { if (window.confirm(`Remove your saved ${AI_PROVIDERS[aiProvider].label} key?\n\nYou will need to paste it again before you can chat.`)) saveAiKey(''); }} sx={{ fontSize: '11px', textTransform: 'none', color: theme.palette.text.secondary, minWidth: 0 }}>Change key</Button>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Box>
                        )
                    )}

                    {/* COPY & PASTE — the original flow */}
                    {aiMode === 'paste' && (<>
                    <Box sx={{ mb: 2, p: 1.5, borderRadius: 1.5, border: `1px solid ${theme.palette.divider}`, backgroundColor: alpha('#8b5cf6', 0.06) }}>
                        <Typography sx={{ fontWeight: 700, fontSize: '13px', mb: 0.5 }}>1 · Tell it your goal, then copy</Typography>
                        <Typography variant="body2" sx={{ fontSize: '12px', color: theme.palette.text.secondary, mb: 1 }}>
                            Type what you want, then hit a style below. Your goal is baked right in — just paste the whole thing into ChatGPT / Claude / Gemini.
                        </Typography>
                        <TextField multiline minRows={2} maxRows={4} fullWidth size="small"
                            placeholder={'Your goal — e.g. "Make a 45-second trailer of the most surprising, emotional moments. Open on the strongest hook and end on a powerful line."'}
                            value={aiGoal} onChange={(e) => setAiGoal(e.target.value)}
                            sx={{ mb: 1, '& textarea': { fontSize: '12px', lineHeight: 1.45 } }} />
                        {/* Same personas as the live chat — click one to drop it into your goal above, then copy. */}
                        <Typography variant="caption" sx={{ fontSize: '10.5px', color: theme.palette.text.disabled, display: 'block', mb: 0.5 }}>
                            …or tap a persona to drop it in (then copy):
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.6, maxHeight: 116, overflowY: 'auto', mb: 1.25 }}>
                            {[...(archiveInfo ? ARCHIVE_GOAL_CHIPS : []), ...AI_GOAL_CHIPS, ...AI_LENS_CHIPS].map((c) => (
                                <Box key={c.t} onClick={() => setAiGoal(c.p)} title={c.p}
                                    sx={{ cursor: 'pointer', px: 1, py: 0.4, borderRadius: 4, fontSize: '11px', fontWeight: 600,
                                        border: `1px solid ${alpha('#8b5cf6', 0.4)}`, color: '#c4b5fd', backgroundColor: alpha('#8b5cf6', 0.08),
                                        transition: 'all .15s', '&:hover': { backgroundColor: alpha('#8b5cf6', 0.22), borderColor: '#8b5cf6', color: '#fff' } }}>
                                    {c.e}&nbsp;{c.t}
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <Tooltip title="The AI picks whole clips — a fast, straightforward selection" placement="top">
                                <Button variant="contained" size="small" disableElevation onClick={() => handleCopyAiPack('rough')}
                                    sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: aiCopied === 'rough' ? '#43a047' : '#8b5cf6', color: '#fff',
                                        '&:hover': { backgroundColor: aiCopied === 'rough' ? '#388e3c' : '#7c3aed' } }}>
                                    {aiCopied === 'rough' ? 'Copied! ✓' : '✂ Rough cut — whole clips'}
                                </Button>
                            </Tooltip>
                            <Tooltip title="The AI may trim each clip down to its best phrase (uses the pen) — a tighter, more creative edit" placement="top">
                                <Button variant="contained" size="small" disableElevation onClick={() => handleCopyAiPack('precise')}
                                    sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: aiCopied === 'precise' ? '#43a047' : '#6d28d9', color: '#fff',
                                        '&:hover': { backgroundColor: aiCopied === 'precise' ? '#388e3c' : '#5b21b6' } }}>
                                    {aiCopied === 'precise' ? 'Copied! ✓' : '✦ Precise editor — trim within clips'}
                                </Button>
                            </Tooltip>
                        </Box>
                    </Box>

                    <Box sx={{ p: 1.5, borderRadius: 1.5, border: `1px solid ${theme.palette.divider}` }}>
                        <Typography sx={{ fontWeight: 700, fontSize: '13px', mb: 0.5 }}>2 · Paste its reply back</Typography>
                        <Typography variant="body2" sx={{ fontSize: '12px', color: theme.palette.text.secondary, mb: 1.25 }}>
                            Paste the AI’s whole reply here, then hit Select — that’s it.
                        </Typography>
                        <TextField multiline minRows={3} maxRows={3} fullWidth size="small" placeholder="Paste the AI's reply here — e.g.  12, 47, 3, 88"
                            inputRef={aiPasteFieldRef}
                            value={aiPaste} onChange={(e) => setAiPaste(e.target.value)}
                            sx={{ mb: 1, '& textarea': { fontFamily: 'monospace', fontSize: '12px' } }} />
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mb: 1.25, cursor: 'pointer' }} onClick={() => setAiIncludeSilence(v => !v)}>
                            <Checkbox checked={aiIncludeSilence} size="small" sx={{ p: 0, mt: '1px' }} />
                            <Typography variant="body2" sx={{ fontSize: '12px', color: theme.palette.text.secondary, lineHeight: 1.4 }}>
                                <b style={{ color: theme.palette.text.primary }}>Include trailing silence</b> — give every clip breathing room so nothing cuts off abruptly: whole clips extend a touch into the gap after them, and trimmed phrases get a small cushion on both sides. Turn it off for hard, exact cuts.
                            </Typography>
                        </Box>
                        <Button variant="contained" size="small" disableElevation disabled={!aiPaste.trim()} onClick={handleApplyAiIds}
                            sx={{ textTransform: 'none', fontWeight: 700, backgroundColor: theme.palette.primary.main, color: '#fff',
                                '&:hover': { backgroundColor: theme.palette.primary.dark } }}>
                            Select these clips
                        </Button>
                    </Box>
                    </>)}
                </DialogContent>
            </Dialog>

        </Box >
    );
};

export default DraggableToolbar;